/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Care Club API - ASP.NET 8 - DEVELOPMENT (Local)
 * The Care Club API is a comprehensive backend service developed using ASP.NET 8. It facilitates seamless data access and interaction for services requiring information from the Care Club system. This API is designed to provide secure, reliable, and efficient access to member and service data, ensuring that all dependent applications can operate smoothly.
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CancellationReasonAndSubReasonDto,
  CareClubCCMAPIModelsDtoAddressLocationDto,
  CareClubCCMAPIModelsDtoAgreementSearchResultDto,
  CareClubCCMAPIModelsDtoBankDetailsDto,
  CareClubCCMAPIModelsDtoClaimGetDto,
  CareClubCCMAPIModelsDtoClaimPostDto,
  CareClubCCMAPIModelsDtoClaimValidationPendingDto,
  CareClubCCMAPIModelsDtoEnquiryDto,
  CareClubCCMAPIModelsDtoGeneratedInvoiceDto,
  CareClubCCMAPIModelsDtoInvoiceRequestDto,
  CareClubCCMAPIModelsDtoPAFAddressDto,
  CareClubCCMAPIModelsDtoSMSStatusResponse,
  CareClubCCMAPIModelsDtoServiceAgreementCreateResultDto,
  CareClubCCMAPIModelsDtoServiceAgreementDocumentDto,
  CareClubCCMAPIModelsDtoServiceAgreementEnquiryTypeDto,
  CareClubCCMAPIModelsDtoSetClaimValidationRequestDto,
  CareClubCCMAPIModelsDtoSetContactResultDto,
  CareClubCCMAPIModelsDtoTrustPilotInvitationDto,
  CareClubCCMAPIModelsDtoUserLockDetailDto,
  CareClubCCMAPIModelsDtoUserLockStatus,
  CareClubCCMAPIModelsPaymentAPIWrapperCardPaymentResponse,
  CareClubCCMAPIModelsStoredProceduresGetServiceAgreementsMatchingSearchTermResult,
  CareClubCCMAPIModelsStoredProceduresServiceAgreementPaymentDetail,
  CareClubCCMAPIModelsStoredProceduresSpGetGoCardlessCustomerAndBankDetailsBySACustomerIdResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetActiveEngineersResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetActiveUsersResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCustomerResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetExternalEngineersResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetUsersByPermissionResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferResult,
  CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetCustomerResult,
  CareClubCCMAPIModelsTablesServiceAgreementReferralDiscounts,
  CareClubCCMAPIModelsTablesServiceAgreementTypes,
  CareClubCCMAPIModelsTablesServiceAgreements,
  CareClubCCMAPIModelsViewModelsAddressSaveView,
  CareClubCCMAPIModelsViewModelsAgreementCancelView,
  CareClubCCMAPIModelsViewModelsAgreementSaveView,
  CareClubCCMAPIModelsViewModelsAppointmentTimeTypeView,
  CareClubCCMAPIModelsViewModelsAvailableOfferView,
  CareClubCCMAPIModelsViewModelsBillingDetailsView,
  CareClubCCMAPIModelsViewModelsBoilerDetailsView,
  CareClubCCMAPIModelsViewModelsCCJClaimStatusView,
  CareClubCCMAPIModelsViewModelsCallTypeView,
  CareClubCCMAPIModelsViewModelsCampaignCodeValidationView,
  CareClubCCMAPIModelsViewModelsCancelReasonDataItemView,
  CareClubCCMAPIModelsViewModelsCancelReasonView,
  CareClubCCMAPIModelsViewModelsCancellationDetailView,
  CareClubCCMAPIModelsViewModelsContactView,
  CareClubCCMAPIModelsViewModelsCostDetailsView,
  CareClubCCMAPIModelsViewModelsCreditControlActionLogView,
  CareClubCCMAPIModelsViewModelsCreditControlCaseView,
  CareClubCCMAPIModelsViewModelsCreditControlHoldView,
  CareClubCCMAPIModelsViewModelsCustomerView,
  CareClubCCMAPIModelsViewModelsDiaryEntryView,
  CareClubCCMAPIModelsViewModelsDiarySummaryResultView,
  CareClubCCMAPIModelsViewModelsDiscountRepaymentDetailsView,
  CareClubCCMAPIModelsViewModelsEnquiriesResultView,
  CareClubCCMAPIModelsViewModelsEnquiryResultView,
  CareClubCCMAPIModelsViewModelsGetJobCostDetailsRequestView,
  CareClubCCMAPIModelsViewModelsGetPlanCostAfterOffersRequestView,
  CareClubCCMAPIModelsViewModelsHistoryLinksView,
  CareClubCCMAPIModelsViewModelsIncentiveTypeView,
  CareClubCCMAPIModelsViewModelsInvoiceGroupTotalView,
  CareClubCCMAPIModelsViewModelsJobCostDetailsView,
  CareClubCCMAPIModelsViewModelsJobDetailsView,
  CareClubCCMAPIModelsViewModelsJobGroupView,
  CareClubCCMAPIModelsViewModelsJobSaveView,
  CareClubCCMAPIModelsViewModelsJobTypeView,
  CareClubCCMAPIModelsViewModelsManualPaymentMethodView,
  CareClubCCMAPIModelsViewModelsNoteView,
  CareClubCCMAPIModelsViewModelsPaymentDetailsView,
  CareClubCCMAPIModelsViewModelsPaymentSaveView,
  CareClubCCMAPIModelsViewModelsPaymentSummaryView,
  CareClubCCMAPIModelsViewModelsPlanCostAfterOffersView,
  CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView,
  CareClubCCMAPIModelsViewModelsReferenceDataView,
  CareClubCCMAPIModelsViewModelsReportLinkView,
  CareClubCCMAPIModelsViewModelsServiceAgreementByReferenceResultView,
  CareClubCCMAPIModelsViewModelsServiceAgreementJobTypeView,
  CareClubCCMAPIModelsViewModelsServiceAgreementTypeView,
  CareClubCCMAPIModelsViewModelsServiceAgreementView,
  CareClubCCMAPIModelsViewModelsStatusResultGroupView,
  CareClubCCMAPIModelsViewModelsTradeView,
  CareClubCCMAPIModelsViewModelsTransactionView,
  CareClubCCMAPIModelsViewModelsVIPDetailsView,
  CareClubCCMAPIModelsViewModelsVIPStatusTypesView,
  CareClubCCMAPIServicesAuditType,
  GetApiCCMAgreementGetAdjustmentPaymentParams,
  GetApiCCMAgreementGetAgreementsBySearchTermParams,
  GetApiCCMAgreementGetAgreementsMatchingSearchTermParams,
  GetApiCCMAgreementGetCancelReasonDataItemsParams,
  GetApiCCMAgreementGetCancelReasonsParams,
  GetApiCCMAgreementGetCancellationDetailsParams,
  GetApiCCMAgreementGetContactParams,
  GetApiCCMAgreementGetContactsParams,
  GetApiCCMAgreementGetDiscountRepaymentParams,
  GetApiCCMAgreementGetIncentiveTypesParams,
  GetApiCCMAgreementGetLatestAuditEntriesByTypeParams,
  GetApiCCMAgreementGetServiceAgreementByReferenceParams,
  GetApiCCMAgreementGetServiceAgreementParams,
  GetApiCCMAgreementGetServiceAgreementTestParams,
  GetApiCCMAgreementHasActiveAgreementForAddressParams,
  GetApiCCMAgreementHasCustomerWithEmailAddressParams,
  GetApiCCMAgreementHasCustomerWithPolicyAddressParams,
  GetApiCCMAgreementIsPostcodeBlacklistedParams,
  GetApiCCMAgreementShiftServiceAgreementContractDatesParams,
  GetApiCCMAgreementShiftServiceAgreementDatesParams,
  GetApiCCMAgreementShiftServiceAgreementInvoiceDatesParams,
  GetApiCCMAgreementTestFunctionsParams,
  GetApiCCMAuditRecordAuditParams,
  GetApiCCMBankGetBankDetailsParams,
  GetApiCCMBankGetCardDetailsParams,
  GetApiCCMClaimsGetClaimValidationsPendingParams,
  GetApiCCMCostsGetAvailableOffersParams,
  GetApiCCMCostsGetCostDetailsParams,
  GetApiCCMCostsValidateCampaignCodeParams,
  GetApiCCMCreditControlGetCCJClaimStatusesParams,
  GetApiCCMCreditControlGetCreditControlActionLogsParams,
  GetApiCCMCreditControlGetCreditControlCasesParams,
  GetApiCCMCreditControlGetHoldsParams,
  GetApiCCMCreditControlGetLetterDetailsParams,
  GetApiCCMCreditControlGetSMSDetailsParams,
  GetApiCCMCustomerGetByAgreementIdParams,
  GetApiCCMCustomerGetVIPStatusTypesParams,
  GetApiCCMDiaryGetEntryParams,
  GetApiCCMDiaryGetSummaryParams,
  GetApiCCMEngineersGetAllExternalEngineersForAreaParams,
  GetApiCCMEngineersGetAllExternalEngineersForTradeParams,
  GetApiCCMEngineersGetExternalEngineerDetailsParams,
  GetApiCCMEngineersGetExternalEngineersParams,
  GetApiCCMEnquiriesGetEnquiriesParams,
  GetApiCCMEnquiriesGetEnquiryParams,
  GetApiCCMHomeGetHistoryLinksParams,
  GetApiCCMHubAgreementsParams,
  GetApiCCMHubClaimsParams,
  GetApiCCMHubDocumentsParams,
  GetApiCCMHubLastServiceAgreementReferenceNumberParams,
  GetApiCCMJobsGetJobGroupsParams,
  GetApiCCMJobsGetJobParams,
  GetApiCCMJobsGetJobTypesParams,
  GetApiCCMNotesGetAllParams,
  GetApiCCMNotesGetByAgreementParams,
  GetApiCCMNotesGetParams,
  GetApiCCMPAFGetAddressesByFullPostcodeParams,
  GetApiCCMPAFGetAddressesParams,
  GetApiCCMPaymentGetBillingDetailsParams,
  GetApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetailsParams,
  GetApiCCMPaymentGetNextUnpaidInvoiceGroupTotalParams,
  GetApiCCMPaymentGetPaymentDetailsByCustomerIdParams,
  GetApiCCMPaymentGetPaymentDetailsParams,
  GetApiCCMPaymentGetPaymentSummaryParams,
  GetApiCCMTransactionsGetTransactionsParams,
  GetApiCCMUserLockGetAllParams,
  GetApiCCMUsersGetUsersByPermissionParams,
  GetVIPDetailsParams,
  MicrosoftAspNetCoreMvcIActionResult,
  MicrosoftAspNetCoreMvcOkResult,
  PostApiCCMAgreementActivateSuspendedAgreementParams,
  PostApiCCMAgreementAddressSaveParams,
  PostApiCCMAgreementCancelExistingPaymentMethodParams,
  PostApiCCMAgreementCancelParams,
  PostApiCCMAgreementCreateParams,
  PostApiCCMAgreementReinstateMandateParams,
  PostApiCCMAgreementRemoveContactParams,
  PostApiCCMAgreementSaveRetentionAttemptParams,
  PostApiCCMAgreementSendInitialSalesEmailParams,
  PostApiCCMAgreementSendRetentionEmailParams,
  PostApiCCMAgreementSendWelcomePackParams,
  PostApiCCMAgreementSetCancellationNotesParams,
  PostApiCCMAgreementSetContactParams,
  PostApiCCMAgreementStopCancellationParams,
  PostApiCCMAgreementUndoCancellationParams,
  PostApiCCMAgreementUpdatePaymentMethodParams,
  PostApiCCMAgreementUpdateSourceCodeParams,
  PostApiCCMAgreementUpdateUserIdEnteredParams,
  PostApiCCMClaimsCreateExcessInvoiceParams,
  PostApiCCMClaimsDeleteJobParams,
  PostApiCCMClaimsSetClaimValidationParams,
  PostApiCCMCostsAllocateSubscriptionOfferParams,
  PostApiCCMCostsAllocateSubscriptionOfferWithRefferalParams,
  PostApiCCMCostsToggleAllocatedSubscriptionOfferParams,
  PostApiCCMCreditControlApplyHoldParams,
  PostApiCCMCreditControlOpenCreditControlCaseParams,
  PostApiCCMCreditControlRemoveHoldParams,
  PostApiCCMCreditControlRemovePendingCaseParams,
  PostApiCCMCustomerCreateParams,
  PostApiCCMCustomerSaveParams,
  PostApiCCMCustomerSendFeedbackRequestParams,
  PostApiCCMCustomerSetVIPOverrideParams,
  PostApiCCMCustomerTestDecryptionParams,
  PostApiCCMCustomerTestEncryptionParams,
  PostApiCCMCustomerWriteToLogParams,
  PostApiCCMDiaryAddEntryParams,
  PostApiCCMDiaryUpdateEntryParams,
  PostApiCCMEngineersSetExternalEngineerParams,
  PostApiCCMEnquiriesSetEnquiryParams,
  PostApiCCMHubClaimsParams,
  PostApiCCMJobsBookJobParams,
  PostApiCCMNotesAddParams,
  PostApiCCMPaymentAddCreditNoteParams,
  PostApiCCMPaymentCreditOffOutstandingInvoicesParams,
  PostApiCCMPaymentSetManualPaymentParams,
  PostApiCCMPaymentTakeSquarePaymentParams,
  PostApiCCMPaymentTakeStripePaymentParams,
  PostApiCCMUserLockApplyCustomerLockByServiceAgreementIdParams,
  PostApiCCMUserLockApplyParams,
  PostApiCCMUserLockClearParams,
  RightioEmailSenderModelsEmailNoAttachmentsDto,
  RightioStripeAPIWrapperModelsDtoConfirmPaymentResponseDto,
  StannpAPIWrapperModelsDtoLetterDetailsResponse
} from '../../model';

import { customInstance } from '../../../../../services/CCMAccess/index';
import type { ErrorType , BodyType } from '../../../../../services/CCMAccess/index';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Activates a suspended service agreement with the given service agreement ID, service agreement activation reason ID, and user ID.
 * @summary Activates a suspended service agreement
 */
export const postApiCCMAgreementActivateSuspendedAgreement = (
    params?: PostApiCCMAgreementActivateSuspendedAgreementParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcIActionResult>(
      {url: `/api/CCM/Agreement/ActivateSuspendedAgreement`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementActivateSuspendedAgreementMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementActivateSuspendedAgreement>>, TError,{params?: PostApiCCMAgreementActivateSuspendedAgreementParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementActivateSuspendedAgreement>>, TError,{params?: PostApiCCMAgreementActivateSuspendedAgreementParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementActivateSuspendedAgreement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementActivateSuspendedAgreement>>, {params?: PostApiCCMAgreementActivateSuspendedAgreementParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMAgreementActivateSuspendedAgreement(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementActivateSuspendedAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementActivateSuspendedAgreement>>>
    
    export type PostApiCCMAgreementActivateSuspendedAgreementMutationError = ErrorType<string>

    /**
 * @summary Activates a suspended service agreement
 */
export const usePostApiCCMAgreementActivateSuspendedAgreement = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementActivateSuspendedAgreement>>, TError,{params?: PostApiCCMAgreementActivateSuspendedAgreementParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementActivateSuspendedAgreement>>,
        TError,
        {params?: PostApiCCMAgreementActivateSuspendedAgreementParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementActivateSuspendedAgreementMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary This endpoint is used to save an address for a user.
 */
export const postApiCCMAgreementAddressSave = (
    careClubCCMAPIModelsViewModelsAddressSaveView: BodyType<CareClubCCMAPIModelsViewModelsAddressSaveView>,
    params?: PostApiCCMAgreementAddressSaveParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/CCM/Agreement/AddressSave`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsViewModelsAddressSaveView,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementAddressSaveMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementAddressSave>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsAddressSaveView>;params?: PostApiCCMAgreementAddressSaveParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementAddressSave>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsAddressSaveView>;params?: PostApiCCMAgreementAddressSaveParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementAddressSave'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementAddressSave>>, {data: BodyType<CareClubCCMAPIModelsViewModelsAddressSaveView>;params?: PostApiCCMAgreementAddressSaveParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMAgreementAddressSave(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementAddressSaveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementAddressSave>>>
    export type PostApiCCMAgreementAddressSaveMutationBody = BodyType<CareClubCCMAPIModelsViewModelsAddressSaveView>
    export type PostApiCCMAgreementAddressSaveMutationError = ErrorType<string>

    /**
 * @summary This endpoint is used to save an address for a user.
 */
export const usePostApiCCMAgreementAddressSave = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementAddressSave>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsAddressSaveView>;params?: PostApiCCMAgreementAddressSaveParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementAddressSave>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsViewModelsAddressSaveView>;params?: PostApiCCMAgreementAddressSaveParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementAddressSaveMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Cancels an agreement with the given parameters
 * @summary Cancels an agreement
 */
export const postApiCCMAgreementCancel = (
    careClubCCMAPIModelsViewModelsAgreementCancelView: BodyType<CareClubCCMAPIModelsViewModelsAgreementCancelView>,
    params?: PostApiCCMAgreementCancelParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Agreement/Cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsViewModelsAgreementCancelView,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementCancelMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementCancel>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsAgreementCancelView>;params?: PostApiCCMAgreementCancelParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementCancel>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsAgreementCancelView>;params?: PostApiCCMAgreementCancelParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementCancel>>, {data: BodyType<CareClubCCMAPIModelsViewModelsAgreementCancelView>;params?: PostApiCCMAgreementCancelParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMAgreementCancel(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementCancel>>>
    export type PostApiCCMAgreementCancelMutationBody = BodyType<CareClubCCMAPIModelsViewModelsAgreementCancelView>
    export type PostApiCCMAgreementCancelMutationError = ErrorType<string>

    /**
 * @summary Cancels an agreement
 */
export const usePostApiCCMAgreementCancel = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementCancel>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsAgreementCancelView>;params?: PostApiCCMAgreementCancelParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementCancel>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsViewModelsAgreementCancelView>;params?: PostApiCCMAgreementCancelParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementCancelMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Sends an initial sales email to the customer based on the provided service agreement id.
 * @summary Sends an initial sales email to the customer.
 */
export const postApiCCMAgreementSendInitialSalesEmail = (
    postApiCCMAgreementSendInitialSalesEmailBody: BodyType<number>,
    params?: PostApiCCMAgreementSendInitialSalesEmailParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/CCM/Agreement/SendInitialSalesEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiCCMAgreementSendInitialSalesEmailBody,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementSendInitialSalesEmailMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSendInitialSalesEmail>>, TError,{data: BodyType<number>;params?: PostApiCCMAgreementSendInitialSalesEmailParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSendInitialSalesEmail>>, TError,{data: BodyType<number>;params?: PostApiCCMAgreementSendInitialSalesEmailParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementSendInitialSalesEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementSendInitialSalesEmail>>, {data: BodyType<number>;params?: PostApiCCMAgreementSendInitialSalesEmailParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMAgreementSendInitialSalesEmail(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementSendInitialSalesEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementSendInitialSalesEmail>>>
    export type PostApiCCMAgreementSendInitialSalesEmailMutationBody = BodyType<number>
    export type PostApiCCMAgreementSendInitialSalesEmailMutationError = ErrorType<string>

    /**
 * @summary Sends an initial sales email to the customer.
 */
export const usePostApiCCMAgreementSendInitialSalesEmail = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSendInitialSalesEmail>>, TError,{data: BodyType<number>;params?: PostApiCCMAgreementSendInitialSalesEmailParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementSendInitialSalesEmail>>,
        TError,
        {data: BodyType<number>;params?: PostApiCCMAgreementSendInitialSalesEmailParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementSendInitialSalesEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Returns a list of Incentive Types for a given Service Agreement Type
 * @summary Get a list of Incentive Types for a given Service Agreement Type
 */
export const getApiCCMAgreementGetIncentiveTypes = (
    params?: GetApiCCMAgreementGetIncentiveTypesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsIncentiveTypeView[]>(
      {url: `/api/CCM/Agreement/GetIncentiveTypes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetIncentiveTypesQueryKey = (params?: GetApiCCMAgreementGetIncentiveTypesParams,) => {
    return [`/api/CCM/Agreement/GetIncentiveTypes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetIncentiveTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetIncentiveTypes>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementGetIncentiveTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetIncentiveTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetIncentiveTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetIncentiveTypes>>> = ({ signal }) => getApiCCMAgreementGetIncentiveTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetIncentiveTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetIncentiveTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetIncentiveTypes>>>
export type GetApiCCMAgreementGetIncentiveTypesQueryError = ErrorType<string>


/**
 * @summary Get a list of Incentive Types for a given Service Agreement Type
 */

export function useGetApiCCMAgreementGetIncentiveTypes<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetIncentiveTypes>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementGetIncentiveTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetIncentiveTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetIncentiveTypesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Checks if a customer exists with the given email address.
 */
export const getApiCCMAgreementHasCustomerWithEmailAddress = (
    params?: GetApiCCMAgreementHasCustomerWithEmailAddressParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/CCM/Agreement/HasCustomerWithEmailAddress`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementHasCustomerWithEmailAddressQueryKey = (params?: GetApiCCMAgreementHasCustomerWithEmailAddressParams,) => {
    return [`/api/CCM/Agreement/HasCustomerWithEmailAddress`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementHasCustomerWithEmailAddressQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithEmailAddress>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementHasCustomerWithEmailAddressParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithEmailAddress>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementHasCustomerWithEmailAddressQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithEmailAddress>>> = ({ signal }) => getApiCCMAgreementHasCustomerWithEmailAddress(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithEmailAddress>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementHasCustomerWithEmailAddressQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithEmailAddress>>>
export type GetApiCCMAgreementHasCustomerWithEmailAddressQueryError = ErrorType<string>


/**
 * @summary Checks if a customer exists with the given email address.
 */

export function useGetApiCCMAgreementHasCustomerWithEmailAddress<TData = Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithEmailAddress>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementHasCustomerWithEmailAddressParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithEmailAddress>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementHasCustomerWithEmailAddressQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Checks if a customer has a policy address with the given property and postcode.
 */
export const getApiCCMAgreementHasCustomerWithPolicyAddress = (
    params?: GetApiCCMAgreementHasCustomerWithPolicyAddressParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/CCM/Agreement/HasCustomerWithPolicyAddress`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementHasCustomerWithPolicyAddressQueryKey = (params?: GetApiCCMAgreementHasCustomerWithPolicyAddressParams,) => {
    return [`/api/CCM/Agreement/HasCustomerWithPolicyAddress`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementHasCustomerWithPolicyAddressQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithPolicyAddress>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementHasCustomerWithPolicyAddressParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithPolicyAddress>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementHasCustomerWithPolicyAddressQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithPolicyAddress>>> = ({ signal }) => getApiCCMAgreementHasCustomerWithPolicyAddress(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithPolicyAddress>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementHasCustomerWithPolicyAddressQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithPolicyAddress>>>
export type GetApiCCMAgreementHasCustomerWithPolicyAddressQueryError = ErrorType<string>


/**
 * @summary Checks if a customer has a policy address with the given property and postcode.
 */

export function useGetApiCCMAgreementHasCustomerWithPolicyAddress<TData = Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithPolicyAddress>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementHasCustomerWithPolicyAddressParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementHasCustomerWithPolicyAddress>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementHasCustomerWithPolicyAddressQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Checks if there is an active agreement for the given property and postcode.
 */
export const getApiCCMAgreementHasActiveAgreementForAddress = (
    params?: GetApiCCMAgreementHasActiveAgreementForAddressParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/CCM/Agreement/HasActiveAgreementForAddress`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementHasActiveAgreementForAddressQueryKey = (params?: GetApiCCMAgreementHasActiveAgreementForAddressParams,) => {
    return [`/api/CCM/Agreement/HasActiveAgreementForAddress`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementHasActiveAgreementForAddressQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementHasActiveAgreementForAddress>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementHasActiveAgreementForAddressParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementHasActiveAgreementForAddress>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementHasActiveAgreementForAddressQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementHasActiveAgreementForAddress>>> = ({ signal }) => getApiCCMAgreementHasActiveAgreementForAddress(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementHasActiveAgreementForAddress>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementHasActiveAgreementForAddressQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementHasActiveAgreementForAddress>>>
export type GetApiCCMAgreementHasActiveAgreementForAddressQueryError = ErrorType<string>


/**
 * @summary Checks if there is an active agreement for the given property and postcode.
 */

export function useGetApiCCMAgreementHasActiveAgreementForAddress<TData = Awaited<ReturnType<typeof getApiCCMAgreementHasActiveAgreementForAddress>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementHasActiveAgreementForAddressParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementHasActiveAgreementForAddress>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementHasActiveAgreementForAddressQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Checks if a postcode is blacklisted and returns true if it is, false otherwise
 * @summary Checks if a postcode is blacklisted
 */
export const getApiCCMAgreementIsPostcodeBlacklisted = (
    params?: GetApiCCMAgreementIsPostcodeBlacklistedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/CCM/Agreement/IsPostcodeBlacklisted`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementIsPostcodeBlacklistedQueryKey = (params?: GetApiCCMAgreementIsPostcodeBlacklistedParams,) => {
    return [`/api/CCM/Agreement/IsPostcodeBlacklisted`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementIsPostcodeBlacklistedQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementIsPostcodeBlacklisted>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementIsPostcodeBlacklistedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementIsPostcodeBlacklisted>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementIsPostcodeBlacklistedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementIsPostcodeBlacklisted>>> = ({ signal }) => getApiCCMAgreementIsPostcodeBlacklisted(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementIsPostcodeBlacklisted>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementIsPostcodeBlacklistedQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementIsPostcodeBlacklisted>>>
export type GetApiCCMAgreementIsPostcodeBlacklistedQueryError = ErrorType<string>


/**
 * @summary Checks if a postcode is blacklisted
 */

export function useGetApiCCMAgreementIsPostcodeBlacklisted<TData = Awaited<ReturnType<typeof getApiCCMAgreementIsPostcodeBlacklisted>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementIsPostcodeBlacklistedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementIsPostcodeBlacklisted>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementIsPostcodeBlacklistedQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a list of activation reasons from the database.
 */
export const getApiCCMAgreementGetActivationReasons = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsReferenceDataView[]>(
      {url: `/api/CCM/Agreement/GetActivationReasons`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetActivationReasonsQueryKey = () => {
    return [`/api/CCM/Agreement/GetActivationReasons`] as const;
    }

    
export const getGetApiCCMAgreementGetActivationReasonsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetActivationReasons>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetActivationReasons>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetActivationReasonsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetActivationReasons>>> = ({ signal }) => getApiCCMAgreementGetActivationReasons(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetActivationReasons>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetActivationReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetActivationReasons>>>
export type GetApiCCMAgreementGetActivationReasonsQueryError = ErrorType<string>


/**
 * @summary Gets a list of activation reasons from the database.
 */

export function useGetApiCCMAgreementGetActivationReasons<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetActivationReasons>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetActivationReasons>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetActivationReasonsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a list of active engineers
 * @summary Gets a list of active engineers
 */
export const getApiCCMAgreementGetActiveEngineers = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetActiveEngineersResult[]>(
      {url: `/api/CCM/Agreement/GetActiveEngineers`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetActiveEngineersQueryKey = () => {
    return [`/api/CCM/Agreement/GetActiveEngineers`] as const;
    }

    
export const getGetApiCCMAgreementGetActiveEngineersQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetActiveEngineers>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetActiveEngineers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetActiveEngineersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetActiveEngineers>>> = ({ signal }) => getApiCCMAgreementGetActiveEngineers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetActiveEngineers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetActiveEngineersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetActiveEngineers>>>
export type GetApiCCMAgreementGetActiveEngineersQueryError = ErrorType<void>


/**
 * @summary Gets a list of active engineers
 */

export function useGetApiCCMAgreementGetActiveEngineers<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetActiveEngineers>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetActiveEngineers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetActiveEngineersQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a list of active users from the database
 * @summary Gets a list of active users
 */
export const getApiCCMAgreementGetActiveUsers = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetActiveUsersResult[]>(
      {url: `/api/CCM/Agreement/GetActiveUsers`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetActiveUsersQueryKey = () => {
    return [`/api/CCM/Agreement/GetActiveUsers`] as const;
    }

    
export const getGetApiCCMAgreementGetActiveUsersQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetActiveUsers>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetActiveUsers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetActiveUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetActiveUsers>>> = ({ signal }) => getApiCCMAgreementGetActiveUsers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetActiveUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetActiveUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetActiveUsers>>>
export type GetApiCCMAgreementGetActiveUsersQueryError = ErrorType<void>


/**
 * @summary Gets a list of active users
 */

export function useGetApiCCMAgreementGetActiveUsers<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetActiveUsers>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetActiveUsers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetActiveUsersQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint returns the adjustment payment amount for a service agreement given the service agreement id and the next payment date.
 * @summary Get the adjustment payment for a service agreement
 */
export const getApiCCMAgreementGetAdjustmentPayment = (
    params?: GetApiCCMAgreementGetAdjustmentPaymentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/CCM/Agreement/GetAdjustmentPayment`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetAdjustmentPaymentQueryKey = (params?: GetApiCCMAgreementGetAdjustmentPaymentParams,) => {
    return [`/api/CCM/Agreement/GetAdjustmentPayment`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetAdjustmentPaymentQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetAdjustmentPayment>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementGetAdjustmentPaymentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetAdjustmentPayment>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetAdjustmentPaymentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetAdjustmentPayment>>> = ({ signal }) => getApiCCMAgreementGetAdjustmentPayment(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetAdjustmentPayment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetAdjustmentPaymentQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetAdjustmentPayment>>>
export type GetApiCCMAgreementGetAdjustmentPaymentQueryError = ErrorType<string>


/**
 * @summary Get the adjustment payment for a service agreement
 */

export function useGetApiCCMAgreementGetAdjustmentPayment<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetAdjustmentPayment>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementGetAdjustmentPaymentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetAdjustmentPayment>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetAdjustmentPaymentQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets a list of agreements based on a search term and user id
 * @summary Gets a list of agreements based on a search term and user id
 */
export const getApiCCMAgreementGetAgreementsBySearchTerm = (
    params?: GetApiCCMAgreementGetAgreementsBySearchTermParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoAgreementSearchResultDto[]>(
      {url: `/api/CCM/Agreement/GetAgreementsBySearchTerm`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetAgreementsBySearchTermQueryKey = (params?: GetApiCCMAgreementGetAgreementsBySearchTermParams,) => {
    return [`/api/CCM/Agreement/GetAgreementsBySearchTerm`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetAgreementsBySearchTermQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsBySearchTerm>>, TError = ErrorType<void>>(params?: GetApiCCMAgreementGetAgreementsBySearchTermParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsBySearchTerm>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetAgreementsBySearchTermQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsBySearchTerm>>> = ({ signal }) => getApiCCMAgreementGetAgreementsBySearchTerm(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsBySearchTerm>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetAgreementsBySearchTermQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsBySearchTerm>>>
export type GetApiCCMAgreementGetAgreementsBySearchTermQueryError = ErrorType<void>


/**
 * @summary Gets a list of agreements based on a search term and user id
 */

export function useGetApiCCMAgreementGetAgreementsBySearchTerm<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsBySearchTerm>>, TError = ErrorType<void>>(
 params?: GetApiCCMAgreementGetAgreementsBySearchTermParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsBySearchTerm>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetAgreementsBySearchTermQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets a list of agreements based on a search term and user id
 * @summary Gets a list of agreements based on a search term and user id
 */
export const getApiCCMAgreementGetAgreementsMatchingSearchTerm = (
    params?: GetApiCCMAgreementGetAgreementsMatchingSearchTermParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresGetServiceAgreementsMatchingSearchTermResult[]>(
      {url: `/api/CCM/Agreement/GetAgreementsMatchingSearchTerm`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetAgreementsMatchingSearchTermQueryKey = (params?: GetApiCCMAgreementGetAgreementsMatchingSearchTermParams,) => {
    return [`/api/CCM/Agreement/GetAgreementsMatchingSearchTerm`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetAgreementsMatchingSearchTermQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsMatchingSearchTerm>>, TError = ErrorType<void>>(params?: GetApiCCMAgreementGetAgreementsMatchingSearchTermParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsMatchingSearchTerm>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetAgreementsMatchingSearchTermQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsMatchingSearchTerm>>> = ({ signal }) => getApiCCMAgreementGetAgreementsMatchingSearchTerm(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsMatchingSearchTerm>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetAgreementsMatchingSearchTermQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsMatchingSearchTerm>>>
export type GetApiCCMAgreementGetAgreementsMatchingSearchTermQueryError = ErrorType<void>


/**
 * @summary Gets a list of agreements based on a search term and user id
 */

export function useGetApiCCMAgreementGetAgreementsMatchingSearchTerm<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsMatchingSearchTerm>>, TError = ErrorType<void>>(
 params?: GetApiCCMAgreementGetAgreementsMatchingSearchTermParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetAgreementsMatchingSearchTerm>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetAgreementsMatchingSearchTermQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the cancel reason data items for a given cancel reason id.
 */
export const getApiCCMAgreementGetCancelReasonDataItems = (
    params?: GetApiCCMAgreementGetCancelReasonDataItemsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsCancelReasonDataItemView[]>(
      {url: `/api/CCM/Agreement/GetCancelReasonDataItems`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetCancelReasonDataItemsQueryKey = (params?: GetApiCCMAgreementGetCancelReasonDataItemsParams,) => {
    return [`/api/CCM/Agreement/GetCancelReasonDataItems`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetCancelReasonDataItemsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasonDataItems>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementGetCancelReasonDataItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasonDataItems>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetCancelReasonDataItemsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasonDataItems>>> = ({ signal }) => getApiCCMAgreementGetCancelReasonDataItems(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasonDataItems>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetCancelReasonDataItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasonDataItems>>>
export type GetApiCCMAgreementGetCancelReasonDataItemsQueryError = ErrorType<string>


/**
 * @summary Gets the cancel reason data items for a given cancel reason id.
 */

export function useGetApiCCMAgreementGetCancelReasonDataItems<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasonDataItems>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementGetCancelReasonDataItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasonDataItems>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetCancelReasonDataItemsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets a list of cancel reasons based on the parent id
 * @summary Gets a list of cancel reasons
 */
export const getApiCCMAgreementGetCancelReasons = (
    params?: GetApiCCMAgreementGetCancelReasonsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsCancelReasonView[]>(
      {url: `/api/CCM/Agreement/GetCancelReasons`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetCancelReasonsQueryKey = (params?: GetApiCCMAgreementGetCancelReasonsParams,) => {
    return [`/api/CCM/Agreement/GetCancelReasons`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetCancelReasonsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasons>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementGetCancelReasonsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasons>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetCancelReasonsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasons>>> = ({ signal }) => getApiCCMAgreementGetCancelReasons(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasons>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetCancelReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasons>>>
export type GetApiCCMAgreementGetCancelReasonsQueryError = ErrorType<string>


/**
 * @summary Gets a list of cancel reasons
 */

export function useGetApiCCMAgreementGetCancelReasons<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasons>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementGetCancelReasonsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetCancelReasons>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetCancelReasonsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint returns a list of Cancellation Detail View based on the Service Agreement Id.
 * @summary Get Cancellation Details
 */
export const getApiCCMAgreementGetCancellationDetails = (
    params?: GetApiCCMAgreementGetCancellationDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsCancellationDetailView[]>(
      {url: `/api/CCM/Agreement/GetCancellationDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetCancellationDetailsQueryKey = (params?: GetApiCCMAgreementGetCancellationDetailsParams,) => {
    return [`/api/CCM/Agreement/GetCancellationDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetCancellationDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationDetails>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementGetCancellationDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetCancellationDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationDetails>>> = ({ signal }) => getApiCCMAgreementGetCancellationDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetCancellationDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationDetails>>>
export type GetApiCCMAgreementGetCancellationDetailsQueryError = ErrorType<string>


/**
 * @summary Get Cancellation Details
 */

export function useGetApiCCMAgreementGetCancellationDetails<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationDetails>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementGetCancellationDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetCancellationDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets all cancellation reasons and related sub reasons
 * @summary Gets all cancellation reasons and related sub reasons
 */
export const getApiCCMAgreementGetCancellationReasons = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CancellationReasonAndSubReasonDto[]>(
      {url: `/api/CCM/Agreement/GetCancellationReasons`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetCancellationReasonsQueryKey = () => {
    return [`/api/CCM/Agreement/GetCancellationReasons`] as const;
    }

    
export const getGetApiCCMAgreementGetCancellationReasonsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationReasons>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationReasons>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetCancellationReasonsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationReasons>>> = ({ signal }) => getApiCCMAgreementGetCancellationReasons(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationReasons>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetCancellationReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationReasons>>>
export type GetApiCCMAgreementGetCancellationReasonsQueryError = ErrorType<string>


/**
 * @summary Gets all cancellation reasons and related sub reasons
 */

export function useGetApiCCMAgreementGetCancellationReasons<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationReasons>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetCancellationReasons>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetCancellationReasonsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets a list of contacts associated with a service agreement.
 * @summary Gets a list of contacts associated with a service agreement.
 */
export const getApiCCMAgreementGetContacts = (
    params?: GetApiCCMAgreementGetContactsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsContactView[]>(
      {url: `/api/CCM/Agreement/GetContacts`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetContactsQueryKey = (params?: GetApiCCMAgreementGetContactsParams,) => {
    return [`/api/CCM/Agreement/GetContacts`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetContactsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetContacts>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementGetContactsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetContacts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetContactsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetContacts>>> = ({ signal }) => getApiCCMAgreementGetContacts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetContacts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetContacts>>>
export type GetApiCCMAgreementGetContactsQueryError = ErrorType<string>


/**
 * @summary Gets a list of contacts associated with a service agreement.
 */

export function useGetApiCCMAgreementGetContacts<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetContacts>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementGetContactsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetContacts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetContactsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieves a contact by its Id and returns a ContactView object
 * @summary Gets a contact by its Id
 */
export const getApiCCMAgreementGetContact = (
    params?: GetApiCCMAgreementGetContactParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsContactView>(
      {url: `/api/CCM/Agreement/GetContact`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetContactQueryKey = (params?: GetApiCCMAgreementGetContactParams,) => {
    return [`/api/CCM/Agreement/GetContact`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetContactQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetContact>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementGetContactParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetContact>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetContactQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetContact>>> = ({ signal }) => getApiCCMAgreementGetContact(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetContact>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetContactQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetContact>>>
export type GetApiCCMAgreementGetContactQueryError = ErrorType<string>


/**
 * @summary Gets a contact by its Id
 */

export function useGetApiCCMAgreementGetContact<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetContact>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementGetContactParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetContact>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetContactQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint returns the Discount Repayment Details for the given Service Agreement Id.
 * @summary Get Discount Repayment Details
 */
export const getApiCCMAgreementGetDiscountRepayment = (
    params?: GetApiCCMAgreementGetDiscountRepaymentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsDiscountRepaymentDetailsView>(
      {url: `/api/CCM/Agreement/GetDiscountRepayment`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetDiscountRepaymentQueryKey = (params?: GetApiCCMAgreementGetDiscountRepaymentParams,) => {
    return [`/api/CCM/Agreement/GetDiscountRepayment`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetDiscountRepaymentQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetDiscountRepayment>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementGetDiscountRepaymentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetDiscountRepayment>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetDiscountRepaymentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetDiscountRepayment>>> = ({ signal }) => getApiCCMAgreementGetDiscountRepayment(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetDiscountRepayment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetDiscountRepaymentQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetDiscountRepayment>>>
export type GetApiCCMAgreementGetDiscountRepaymentQueryError = ErrorType<string>


/**
 * @summary Get Discount Repayment Details
 */

export function useGetApiCCMAgreementGetDiscountRepayment<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetDiscountRepayment>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementGetDiscountRepaymentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetDiscountRepayment>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetDiscountRepaymentQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a list of audit entries.
 * @summary Gets the latest audit entries by type for a given service agreement.
 */
export const getApiCCMAgreementGetLatestAuditEntriesByType = (
    params?: GetApiCCMAgreementGetLatestAuditEntriesByTypeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetLatestAuditEntriesByTypeResult[]>(
      {url: `/api/CCM/Agreement/GetLatestAuditEntriesByType`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetLatestAuditEntriesByTypeQueryKey = (params?: GetApiCCMAgreementGetLatestAuditEntriesByTypeParams,) => {
    return [`/api/CCM/Agreement/GetLatestAuditEntriesByType`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetLatestAuditEntriesByTypeQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetLatestAuditEntriesByType>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementGetLatestAuditEntriesByTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetLatestAuditEntriesByType>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetLatestAuditEntriesByTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetLatestAuditEntriesByType>>> = ({ signal }) => getApiCCMAgreementGetLatestAuditEntriesByType(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetLatestAuditEntriesByType>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetLatestAuditEntriesByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetLatestAuditEntriesByType>>>
export type GetApiCCMAgreementGetLatestAuditEntriesByTypeQueryError = ErrorType<string>


/**
 * @summary Gets the latest audit entries by type for a given service agreement.
 */

export function useGetApiCCMAgreementGetLatestAuditEntriesByType<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetLatestAuditEntriesByType>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementGetLatestAuditEntriesByTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetLatestAuditEntriesByType>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetLatestAuditEntriesByTypeQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets the service agreement for a given user and id.
 * @summary Gets the service agreement for a given user and id.
 */
export const getApiCCMAgreementGetServiceAgreement = (
    params?: GetApiCCMAgreementGetServiceAgreementParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsServiceAgreementView>(
      {url: `/api/CCM/Agreement/GetServiceAgreement`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetServiceAgreementQueryKey = (params?: GetApiCCMAgreementGetServiceAgreementParams,) => {
    return [`/api/CCM/Agreement/GetServiceAgreement`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetServiceAgreementQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreement>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementGetServiceAgreementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreement>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetServiceAgreementQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreement>>> = ({ signal }) => getApiCCMAgreementGetServiceAgreement(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreement>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetServiceAgreementQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreement>>>
export type GetApiCCMAgreementGetServiceAgreementQueryError = ErrorType<string>


/**
 * @summary Gets the service agreement for a given user and id.
 */

export function useGetApiCCMAgreementGetServiceAgreement<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreement>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementGetServiceAgreementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreement>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetServiceAgreementQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a Service Agreement by its reference.
 */
export const getApiCCMAgreementGetServiceAgreementByReference = (
    params?: GetApiCCMAgreementGetServiceAgreementByReferenceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsServiceAgreementByReferenceResultView>(
      {url: `/api/CCM/Agreement/GetServiceAgreementByReference`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetServiceAgreementByReferenceQueryKey = (params?: GetApiCCMAgreementGetServiceAgreementByReferenceParams,) => {
    return [`/api/CCM/Agreement/GetServiceAgreementByReference`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetServiceAgreementByReferenceQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementByReference>>, TError = ErrorType<void>>(params?: GetApiCCMAgreementGetServiceAgreementByReferenceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementByReference>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetServiceAgreementByReferenceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementByReference>>> = ({ signal }) => getApiCCMAgreementGetServiceAgreementByReference(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementByReference>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetServiceAgreementByReferenceQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementByReference>>>
export type GetApiCCMAgreementGetServiceAgreementByReferenceQueryError = ErrorType<void>


/**
 * @summary Gets a Service Agreement by its reference.
 */

export function useGetApiCCMAgreementGetServiceAgreementByReference<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementByReference>>, TError = ErrorType<void>>(
 params?: GetApiCCMAgreementGetServiceAgreementByReferenceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementByReference>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetServiceAgreementByReferenceQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets a Service Agreement types.
 */
export const getApiCCMAgreementGetServiceAgreementTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsServiceAgreementTypeView[]>(
      {url: `/api/CCM/Agreement/GetServiceAgreementTypes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetServiceAgreementTypesQueryKey = () => {
    return [`/api/CCM/Agreement/GetServiceAgreementTypes`] as const;
    }

    
export const getGetApiCCMAgreementGetServiceAgreementTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTypes>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetServiceAgreementTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTypes>>> = ({ signal }) => getApiCCMAgreementGetServiceAgreementTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetServiceAgreementTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTypes>>>
export type GetApiCCMAgreementGetServiceAgreementTypesQueryError = ErrorType<void>


/**
 * @summary Gets a Service Agreement types.
 */

export function useGetApiCCMAgreementGetServiceAgreementTypes<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTypes>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetServiceAgreementTypesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Reinstate a mandate for a customer with the given parameters.
 * @summary Reinstate a mandate for a customer
 */
export const postApiCCMAgreementReinstateMandate = (
    params?: PostApiCCMAgreementReinstateMandateParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Agreement/ReinstateMandate`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementReinstateMandateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementReinstateMandate>>, TError,{params?: PostApiCCMAgreementReinstateMandateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementReinstateMandate>>, TError,{params?: PostApiCCMAgreementReinstateMandateParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementReinstateMandate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementReinstateMandate>>, {params?: PostApiCCMAgreementReinstateMandateParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMAgreementReinstateMandate(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementReinstateMandateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementReinstateMandate>>>
    
    export type PostApiCCMAgreementReinstateMandateMutationError = ErrorType<string>

    /**
 * @summary Reinstate a mandate for a customer
 */
export const usePostApiCCMAgreementReinstateMandate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementReinstateMandate>>, TError,{params?: PostApiCCMAgreementReinstateMandateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementReinstateMandate>>,
        TError,
        {params?: PostApiCCMAgreementReinstateMandateParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementReinstateMandateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Removes a contact from a service agreement based on the provided service agreement id, service agreement contact id, and user id.
 * @summary Removes a contact from a service agreement
 */
export const postApiCCMAgreementRemoveContact = (
    params?: PostApiCCMAgreementRemoveContactParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Agreement/RemoveContact`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementRemoveContactMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementRemoveContact>>, TError,{params?: PostApiCCMAgreementRemoveContactParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementRemoveContact>>, TError,{params?: PostApiCCMAgreementRemoveContactParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementRemoveContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementRemoveContact>>, {params?: PostApiCCMAgreementRemoveContactParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMAgreementRemoveContact(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementRemoveContactMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementRemoveContact>>>
    
    export type PostApiCCMAgreementRemoveContactMutationError = ErrorType<string>

    /**
 * @summary Removes a contact from a service agreement
 */
export const usePostApiCCMAgreementRemoveContact = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementRemoveContact>>, TError,{params?: PostApiCCMAgreementRemoveContactParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementRemoveContact>>,
        TError,
        {params?: PostApiCCMAgreementRemoveContactParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementRemoveContactMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint is used to save a retention attempt for a service agreement.
 * @summary This endpoint is used to save a retention attempt for a service agreement.
 */
export const postApiCCMAgreementSaveRetentionAttempt = (
    postApiCCMAgreementSaveRetentionAttemptBody: BodyType<number>,
    params?: PostApiCCMAgreementSaveRetentionAttemptParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcIActionResult>(
      {url: `/api/CCM/Agreement/SaveRetentionAttempt`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiCCMAgreementSaveRetentionAttemptBody,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementSaveRetentionAttemptMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSaveRetentionAttempt>>, TError,{data: BodyType<number>;params?: PostApiCCMAgreementSaveRetentionAttemptParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSaveRetentionAttempt>>, TError,{data: BodyType<number>;params?: PostApiCCMAgreementSaveRetentionAttemptParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementSaveRetentionAttempt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementSaveRetentionAttempt>>, {data: BodyType<number>;params?: PostApiCCMAgreementSaveRetentionAttemptParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMAgreementSaveRetentionAttempt(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementSaveRetentionAttemptMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementSaveRetentionAttempt>>>
    export type PostApiCCMAgreementSaveRetentionAttemptMutationBody = BodyType<number>
    export type PostApiCCMAgreementSaveRetentionAttemptMutationError = ErrorType<string>

    /**
 * @summary This endpoint is used to save a retention attempt for a service agreement.
 */
export const usePostApiCCMAgreementSaveRetentionAttempt = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSaveRetentionAttempt>>, TError,{data: BodyType<number>;params?: PostApiCCMAgreementSaveRetentionAttemptParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementSaveRetentionAttempt>>,
        TError,
        {data: BodyType<number>;params?: PostApiCCMAgreementSaveRetentionAttemptParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementSaveRetentionAttemptMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Sends a retention email to the customer associated with the given service agreement.
 * @summary Sends a retention email to the customer associated with the given service agreement.
 */
export const postApiCCMAgreementSendRetentionEmail = (
    postApiCCMAgreementSendRetentionEmailBody: BodyType<number>,
    params?: PostApiCCMAgreementSendRetentionEmailParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/CCM/Agreement/SendRetentionEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiCCMAgreementSendRetentionEmailBody,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementSendRetentionEmailMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSendRetentionEmail>>, TError,{data: BodyType<number>;params?: PostApiCCMAgreementSendRetentionEmailParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSendRetentionEmail>>, TError,{data: BodyType<number>;params?: PostApiCCMAgreementSendRetentionEmailParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementSendRetentionEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementSendRetentionEmail>>, {data: BodyType<number>;params?: PostApiCCMAgreementSendRetentionEmailParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMAgreementSendRetentionEmail(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementSendRetentionEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementSendRetentionEmail>>>
    export type PostApiCCMAgreementSendRetentionEmailMutationBody = BodyType<number>
    export type PostApiCCMAgreementSendRetentionEmailMutationError = ErrorType<string>

    /**
 * @summary Sends a retention email to the customer associated with the given service agreement.
 */
export const usePostApiCCMAgreementSendRetentionEmail = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSendRetentionEmail>>, TError,{data: BodyType<number>;params?: PostApiCCMAgreementSendRetentionEmailParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementSendRetentionEmail>>,
        TError,
        {data: BodyType<number>;params?: PostApiCCMAgreementSendRetentionEmailParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementSendRetentionEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Sends a welcome pack to the user based on the provided service agreement id, send by post flag and user id.
 * @summary Sends a welcome pack to the user.
 */
export const postApiCCMAgreementSendWelcomePack = (
    params?: PostApiCCMAgreementSendWelcomePackParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcIActionResult>(
      {url: `/api/CCM/Agreement/SendWelcomePack`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementSendWelcomePackMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSendWelcomePack>>, TError,{params?: PostApiCCMAgreementSendWelcomePackParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSendWelcomePack>>, TError,{params?: PostApiCCMAgreementSendWelcomePackParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementSendWelcomePack'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementSendWelcomePack>>, {params?: PostApiCCMAgreementSendWelcomePackParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMAgreementSendWelcomePack(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementSendWelcomePackMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementSendWelcomePack>>>
    
    export type PostApiCCMAgreementSendWelcomePackMutationError = ErrorType<string>

    /**
 * @summary Sends a welcome pack to the user.
 */
export const usePostApiCCMAgreementSendWelcomePack = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSendWelcomePack>>, TError,{params?: PostApiCCMAgreementSendWelcomePackParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementSendWelcomePack>>,
        TError,
        {params?: PostApiCCMAgreementSendWelcomePackParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementSendWelcomePackMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Sets the boiler details for a given boiler and returns a response indicating the success or failure of the operation
 * @summary Sets the boiler details for a given boiler
 */
export const postApiCCMAgreementSetBoilerDetails = (
    careClubCCMAPIModelsViewModelsBoilerDetailsView: BodyType<CareClubCCMAPIModelsViewModelsBoilerDetailsView>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Agreement/SetBoilerDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsViewModelsBoilerDetailsView, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementSetBoilerDetailsMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSetBoilerDetails>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsBoilerDetailsView>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSetBoilerDetails>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsBoilerDetailsView>}, TContext> => {

const mutationKey = ['postApiCCMAgreementSetBoilerDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementSetBoilerDetails>>, {data: BodyType<CareClubCCMAPIModelsViewModelsBoilerDetailsView>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCCMAgreementSetBoilerDetails(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementSetBoilerDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementSetBoilerDetails>>>
    export type PostApiCCMAgreementSetBoilerDetailsMutationBody = BodyType<CareClubCCMAPIModelsViewModelsBoilerDetailsView>
    export type PostApiCCMAgreementSetBoilerDetailsMutationError = ErrorType<string>

    /**
 * @summary Sets the boiler details for a given boiler
 */
export const usePostApiCCMAgreementSetBoilerDetails = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSetBoilerDetails>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsBoilerDetailsView>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementSetBoilerDetails>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsViewModelsBoilerDetailsView>},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementSetBoilerDetailsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Set Cancellation Notes for a Service Agreement
 * @summary Set Cancellation Notes for a Service Agreement
 */
export const postApiCCMAgreementSetCancellationNotes = (
    params?: PostApiCCMAgreementSetCancellationNotesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Agreement/SetCancellationNotes`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementSetCancellationNotesMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSetCancellationNotes>>, TError,{params?: PostApiCCMAgreementSetCancellationNotesParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSetCancellationNotes>>, TError,{params?: PostApiCCMAgreementSetCancellationNotesParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementSetCancellationNotes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementSetCancellationNotes>>, {params?: PostApiCCMAgreementSetCancellationNotesParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMAgreementSetCancellationNotes(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementSetCancellationNotesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementSetCancellationNotes>>>
    
    export type PostApiCCMAgreementSetCancellationNotesMutationError = ErrorType<string>

    /**
 * @summary Set Cancellation Notes for a Service Agreement
 */
export const usePostApiCCMAgreementSetCancellationNotes = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSetCancellationNotes>>, TError,{params?: PostApiCCMAgreementSetCancellationNotesParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementSetCancellationNotes>>,
        TError,
        {params?: PostApiCCMAgreementSetCancellationNotesParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementSetCancellationNotesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Sets a contact for a service agreement with the given service agreement id and user id
 * @summary Sets a contact for a service agreement
 */
export const postApiCCMAgreementSetContact = (
    careClubCCMAPIModelsViewModelsContactView: BodyType<CareClubCCMAPIModelsViewModelsContactView>,
    params?: PostApiCCMAgreementSetContactParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoSetContactResultDto>(
      {url: `/api/CCM/Agreement/SetContact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsViewModelsContactView,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementSetContactMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSetContact>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsContactView>;params?: PostApiCCMAgreementSetContactParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSetContact>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsContactView>;params?: PostApiCCMAgreementSetContactParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementSetContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementSetContact>>, {data: BodyType<CareClubCCMAPIModelsViewModelsContactView>;params?: PostApiCCMAgreementSetContactParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMAgreementSetContact(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementSetContactMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementSetContact>>>
    export type PostApiCCMAgreementSetContactMutationBody = BodyType<CareClubCCMAPIModelsViewModelsContactView>
    export type PostApiCCMAgreementSetContactMutationError = ErrorType<string>

    /**
 * @summary Sets a contact for a service agreement
 */
export const usePostApiCCMAgreementSetContact = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementSetContact>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsContactView>;params?: PostApiCCMAgreementSetContactParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementSetContact>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsViewModelsContactView>;params?: PostApiCCMAgreementSetContactParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementSetContactMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Stop the cancellation of a service agreement with the given ID and user ID
 * @summary Stop the cancellation of a service agreement
 */
export const postApiCCMAgreementStopCancellation = (
    params?: PostApiCCMAgreementStopCancellationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Agreement/StopCancellation`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementStopCancellationMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementStopCancellation>>, TError,{params?: PostApiCCMAgreementStopCancellationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementStopCancellation>>, TError,{params?: PostApiCCMAgreementStopCancellationParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementStopCancellation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementStopCancellation>>, {params?: PostApiCCMAgreementStopCancellationParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMAgreementStopCancellation(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementStopCancellationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementStopCancellation>>>
    
    export type PostApiCCMAgreementStopCancellationMutationError = ErrorType<string>

    /**
 * @summary Stop the cancellation of a service agreement
 */
export const usePostApiCCMAgreementStopCancellation = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementStopCancellation>>, TError,{params?: PostApiCCMAgreementStopCancellationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementStopCancellation>>,
        TError,
        {params?: PostApiCCMAgreementStopCancellationParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementStopCancellationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Undo Cancellation of a Service Agreement
 * @summary Undo Cancellation of a Service Agreement
 */
export const postApiCCMAgreementUndoCancellation = (
    params?: PostApiCCMAgreementUndoCancellationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Agreement/UndoCancellation`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementUndoCancellationMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementUndoCancellation>>, TError,{params?: PostApiCCMAgreementUndoCancellationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementUndoCancellation>>, TError,{params?: PostApiCCMAgreementUndoCancellationParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementUndoCancellation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementUndoCancellation>>, {params?: PostApiCCMAgreementUndoCancellationParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMAgreementUndoCancellation(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementUndoCancellationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementUndoCancellation>>>
    
    export type PostApiCCMAgreementUndoCancellationMutationError = ErrorType<string>

    /**
 * @summary Undo Cancellation of a Service Agreement
 */
export const usePostApiCCMAgreementUndoCancellation = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementUndoCancellation>>, TError,{params?: PostApiCCMAgreementUndoCancellationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementUndoCancellation>>,
        TError,
        {params?: PostApiCCMAgreementUndoCancellationParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementUndoCancellationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Updates the payment method for a user with the given userId
 * @summary Updates the payment method for a user
 */
export const postApiCCMAgreementUpdatePaymentMethod = (
    careClubCCMAPIModelsViewModelsPaymentSaveView: BodyType<CareClubCCMAPIModelsViewModelsPaymentSaveView>,
    params?: PostApiCCMAgreementUpdatePaymentMethodParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Agreement/UpdatePaymentMethod`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsViewModelsPaymentSaveView,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementUpdatePaymentMethodMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementUpdatePaymentMethod>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsPaymentSaveView>;params?: PostApiCCMAgreementUpdatePaymentMethodParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementUpdatePaymentMethod>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsPaymentSaveView>;params?: PostApiCCMAgreementUpdatePaymentMethodParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementUpdatePaymentMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementUpdatePaymentMethod>>, {data: BodyType<CareClubCCMAPIModelsViewModelsPaymentSaveView>;params?: PostApiCCMAgreementUpdatePaymentMethodParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMAgreementUpdatePaymentMethod(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementUpdatePaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementUpdatePaymentMethod>>>
    export type PostApiCCMAgreementUpdatePaymentMethodMutationBody = BodyType<CareClubCCMAPIModelsViewModelsPaymentSaveView>
    export type PostApiCCMAgreementUpdatePaymentMethodMutationError = ErrorType<string>

    /**
 * @summary Updates the payment method for a user
 */
export const usePostApiCCMAgreementUpdatePaymentMethod = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementUpdatePaymentMethod>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsPaymentSaveView>;params?: PostApiCCMAgreementUpdatePaymentMethodParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementUpdatePaymentMethod>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsViewModelsPaymentSaveView>;params?: PostApiCCMAgreementUpdatePaymentMethodParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementUpdatePaymentMethodMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Cancels the existing payment method for a user with the given userId
 * @summary Cancels the existing payment method for a user
 */
export const postApiCCMAgreementCancelExistingPaymentMethod = (
    params?: PostApiCCMAgreementCancelExistingPaymentMethodParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsPaymentDetailsView>(
      {url: `/api/CCM/Agreement/CancelExistingPaymentMethod`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementCancelExistingPaymentMethodMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementCancelExistingPaymentMethod>>, TError,{params?: PostApiCCMAgreementCancelExistingPaymentMethodParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementCancelExistingPaymentMethod>>, TError,{params?: PostApiCCMAgreementCancelExistingPaymentMethodParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementCancelExistingPaymentMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementCancelExistingPaymentMethod>>, {params?: PostApiCCMAgreementCancelExistingPaymentMethodParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMAgreementCancelExistingPaymentMethod(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementCancelExistingPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementCancelExistingPaymentMethod>>>
    
    export type PostApiCCMAgreementCancelExistingPaymentMethodMutationError = ErrorType<string>

    /**
 * @summary Cancels the existing payment method for a user
 */
export const usePostApiCCMAgreementCancelExistingPaymentMethod = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementCancelExistingPaymentMethod>>, TError,{params?: PostApiCCMAgreementCancelExistingPaymentMethodParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementCancelExistingPaymentMethod>>,
        TError,
        {params?: PostApiCCMAgreementCancelExistingPaymentMethodParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementCancelExistingPaymentMethodMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Updates the source code for a given service agreement.
 * @summary Updates the source code for a given service agreement.
 */
export const postApiCCMAgreementUpdateSourceCode = (
    params?: PostApiCCMAgreementUpdateSourceCodeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Agreement/UpdateSourceCode`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementUpdateSourceCodeMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementUpdateSourceCode>>, TError,{params?: PostApiCCMAgreementUpdateSourceCodeParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementUpdateSourceCode>>, TError,{params?: PostApiCCMAgreementUpdateSourceCodeParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementUpdateSourceCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementUpdateSourceCode>>, {params?: PostApiCCMAgreementUpdateSourceCodeParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMAgreementUpdateSourceCode(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementUpdateSourceCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementUpdateSourceCode>>>
    
    export type PostApiCCMAgreementUpdateSourceCodeMutationError = ErrorType<string>

    /**
 * @summary Updates the source code for a given service agreement.
 */
export const usePostApiCCMAgreementUpdateSourceCode = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementUpdateSourceCode>>, TError,{params?: PostApiCCMAgreementUpdateSourceCodeParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementUpdateSourceCode>>,
        TError,
        {params?: PostApiCCMAgreementUpdateSourceCodeParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementUpdateSourceCodeMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Updates the userId entered for a service agreement with the given serviceAgreementId, createdByUserId, and userId.
 * @summary Updates the userId entered for a service agreement
 */
export const postApiCCMAgreementUpdateUserIdEntered = (
    params?: PostApiCCMAgreementUpdateUserIdEnteredParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Agreement/UpdateUserIdEntered`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementUpdateUserIdEnteredMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementUpdateUserIdEntered>>, TError,{params?: PostApiCCMAgreementUpdateUserIdEnteredParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementUpdateUserIdEntered>>, TError,{params?: PostApiCCMAgreementUpdateUserIdEnteredParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementUpdateUserIdEntered'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementUpdateUserIdEntered>>, {params?: PostApiCCMAgreementUpdateUserIdEnteredParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMAgreementUpdateUserIdEntered(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementUpdateUserIdEnteredMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementUpdateUserIdEntered>>>
    
    export type PostApiCCMAgreementUpdateUserIdEnteredMutationError = ErrorType<string>

    /**
 * @summary Updates the userId entered for a service agreement
 */
export const usePostApiCCMAgreementUpdateUserIdEntered = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementUpdateUserIdEntered>>, TError,{params?: PostApiCCMAgreementUpdateUserIdEnteredParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementUpdateUserIdEntered>>,
        TError,
        {params?: PostApiCCMAgreementUpdateUserIdEnteredParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementUpdateUserIdEnteredMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Shifts the service agreement dates by the given number of months, can be negative. Changes also dates of invoices and contracts.
 * @summary Shifts the service agreement dates by the given number of months, can be negative. Changes also dates of invoices and contracts.
 */
export const getApiCCMAgreementShiftServiceAgreementDates = (
    params?: GetApiCCMAgreementShiftServiceAgreementDatesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Agreement/ShiftServiceAgreementDates`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementShiftServiceAgreementDatesQueryKey = (params?: GetApiCCMAgreementShiftServiceAgreementDatesParams,) => {
    return [`/api/CCM/Agreement/ShiftServiceAgreementDates`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementShiftServiceAgreementDatesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementDates>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementShiftServiceAgreementDatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementDates>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementShiftServiceAgreementDatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementDates>>> = ({ signal }) => getApiCCMAgreementShiftServiceAgreementDates(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementDates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementShiftServiceAgreementDatesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementDates>>>
export type GetApiCCMAgreementShiftServiceAgreementDatesQueryError = ErrorType<string>


/**
 * @summary Shifts the service agreement dates by the given number of months, can be negative. Changes also dates of invoices and contracts.
 */

export function useGetApiCCMAgreementShiftServiceAgreementDates<TData = Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementDates>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementShiftServiceAgreementDatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementDates>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementShiftServiceAgreementDatesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Shifts the service agreement contract dates by the given number of months, can be negative.
 * @summary Shifts the service agreement contract dates by the given number of months, can be negative.
 */
export const getApiCCMAgreementShiftServiceAgreementContractDates = (
    params?: GetApiCCMAgreementShiftServiceAgreementContractDatesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Agreement/ShiftServiceAgreementContractDates`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementShiftServiceAgreementContractDatesQueryKey = (params?: GetApiCCMAgreementShiftServiceAgreementContractDatesParams,) => {
    return [`/api/CCM/Agreement/ShiftServiceAgreementContractDates`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementShiftServiceAgreementContractDatesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementContractDates>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementShiftServiceAgreementContractDatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementContractDates>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementShiftServiceAgreementContractDatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementContractDates>>> = ({ signal }) => getApiCCMAgreementShiftServiceAgreementContractDates(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementContractDates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementShiftServiceAgreementContractDatesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementContractDates>>>
export type GetApiCCMAgreementShiftServiceAgreementContractDatesQueryError = ErrorType<string>


/**
 * @summary Shifts the service agreement contract dates by the given number of months, can be negative.
 */

export function useGetApiCCMAgreementShiftServiceAgreementContractDates<TData = Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementContractDates>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementShiftServiceAgreementContractDatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementContractDates>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementShiftServiceAgreementContractDatesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Shifts the service agreement invoice dates by the given number of months, can be negative.
 * @summary Shifts the service agreement invoice dates by the given number of months, can be negative.
 */
export const getApiCCMAgreementShiftServiceAgreementInvoiceDates = (
    params?: GetApiCCMAgreementShiftServiceAgreementInvoiceDatesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Agreement/ShiftServiceAgreementInvoiceDates`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementShiftServiceAgreementInvoiceDatesQueryKey = (params?: GetApiCCMAgreementShiftServiceAgreementInvoiceDatesParams,) => {
    return [`/api/CCM/Agreement/ShiftServiceAgreementInvoiceDates`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementShiftServiceAgreementInvoiceDatesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementInvoiceDates>>, TError = ErrorType<string>>(params?: GetApiCCMAgreementShiftServiceAgreementInvoiceDatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementInvoiceDates>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementShiftServiceAgreementInvoiceDatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementInvoiceDates>>> = ({ signal }) => getApiCCMAgreementShiftServiceAgreementInvoiceDates(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementInvoiceDates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementShiftServiceAgreementInvoiceDatesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementInvoiceDates>>>
export type GetApiCCMAgreementShiftServiceAgreementInvoiceDatesQueryError = ErrorType<string>


/**
 * @summary Shifts the service agreement invoice dates by the given number of months, can be negative.
 */

export function useGetApiCCMAgreementShiftServiceAgreementInvoiceDates<TData = Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementInvoiceDates>>, TError = ErrorType<string>>(
 params?: GetApiCCMAgreementShiftServiceAgreementInvoiceDatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementShiftServiceAgreementInvoiceDates>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementShiftServiceAgreementInvoiceDatesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Creates a new Agreement and returns the newly created Agreement
 * @summary Creates a new Agreement
 */
export const postApiCCMAgreementCreate = (
    careClubCCMAPIModelsViewModelsAgreementSaveView: BodyType<CareClubCCMAPIModelsViewModelsAgreementSaveView>,
    params?: PostApiCCMAgreementCreateParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoServiceAgreementCreateResultDto>(
      {url: `/api/CCM/Agreement/Create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsViewModelsAgreementSaveView,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMAgreementCreateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementCreate>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsAgreementSaveView>;params?: PostApiCCMAgreementCreateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementCreate>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsAgreementSaveView>;params?: PostApiCCMAgreementCreateParams}, TContext> => {

const mutationKey = ['postApiCCMAgreementCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMAgreementCreate>>, {data: BodyType<CareClubCCMAPIModelsViewModelsAgreementSaveView>;params?: PostApiCCMAgreementCreateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMAgreementCreate(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMAgreementCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMAgreementCreate>>>
    export type PostApiCCMAgreementCreateMutationBody = BodyType<CareClubCCMAPIModelsViewModelsAgreementSaveView>
    export type PostApiCCMAgreementCreateMutationError = ErrorType<void>

    /**
 * @summary Creates a new Agreement
 */
export const usePostApiCCMAgreementCreate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMAgreementCreate>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsAgreementSaveView>;params?: PostApiCCMAgreementCreateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMAgreementCreate>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsViewModelsAgreementSaveView>;params?: PostApiCCMAgreementCreateParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMAgreementCreateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    export const getApiCCMAgreementServiceAgreementTypesCacheTest = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsTablesServiceAgreementTypes[]>(
      {url: `/api/CCM/Agreement/ServiceAgreementTypesCacheTest`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiCCMAgreementServiceAgreementTypesCacheTestQueryKey = () => {
    return [`/api/CCM/Agreement/ServiceAgreementTypesCacheTest`] as const;
    }

    
export const getGetApiCCMAgreementServiceAgreementTypesCacheTestQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementServiceAgreementTypesCacheTest>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementServiceAgreementTypesCacheTest>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementServiceAgreementTypesCacheTestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementServiceAgreementTypesCacheTest>>> = ({ signal }) => getApiCCMAgreementServiceAgreementTypesCacheTest(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementServiceAgreementTypesCacheTest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementServiceAgreementTypesCacheTestQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementServiceAgreementTypesCacheTest>>>
export type GetApiCCMAgreementServiceAgreementTypesCacheTestQueryError = ErrorType<unknown>



export function useGetApiCCMAgreementServiceAgreementTypesCacheTest<TData = Awaited<ReturnType<typeof getApiCCMAgreementServiceAgreementTypesCacheTest>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementServiceAgreementTypesCacheTest>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementServiceAgreementTypesCacheTestQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiCCMAgreementGetServiceAgreementTest = (
    params?: GetApiCCMAgreementGetServiceAgreementTestParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsTablesServiceAgreements>(
      {url: `/api/CCM/Agreement/GetServiceAgreementTest`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementGetServiceAgreementTestQueryKey = (params?: GetApiCCMAgreementGetServiceAgreementTestParams,) => {
    return [`/api/CCM/Agreement/GetServiceAgreementTest`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementGetServiceAgreementTestQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTest>>, TError = ErrorType<unknown>>(params?: GetApiCCMAgreementGetServiceAgreementTestParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTest>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementGetServiceAgreementTestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTest>>> = ({ signal }) => getApiCCMAgreementGetServiceAgreementTest(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementGetServiceAgreementTestQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTest>>>
export type GetApiCCMAgreementGetServiceAgreementTestQueryError = ErrorType<unknown>



export function useGetApiCCMAgreementGetServiceAgreementTest<TData = Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTest>>, TError = ErrorType<unknown>>(
 params?: GetApiCCMAgreementGetServiceAgreementTestParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementGetServiceAgreementTest>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementGetServiceAgreementTestQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiCCMAgreementTestFunctions = (
    params?: GetApiCCMAgreementTestFunctionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/CCM/Agreement/TestFunctions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAgreementTestFunctionsQueryKey = (params?: GetApiCCMAgreementTestFunctionsParams,) => {
    return [`/api/CCM/Agreement/TestFunctions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAgreementTestFunctionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAgreementTestFunctions>>, TError = ErrorType<unknown>>(params?: GetApiCCMAgreementTestFunctionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementTestFunctions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAgreementTestFunctionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAgreementTestFunctions>>> = ({ signal }) => getApiCCMAgreementTestFunctions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementTestFunctions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAgreementTestFunctionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAgreementTestFunctions>>>
export type GetApiCCMAgreementTestFunctionsQueryError = ErrorType<unknown>



export function useGetApiCCMAgreementTestFunctions<TData = Awaited<ReturnType<typeof getApiCCMAgreementTestFunctions>>, TError = ErrorType<unknown>>(
 params?: GetApiCCMAgreementTestFunctionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAgreementTestFunctions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAgreementTestFunctionsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint will record an audit entry.
 * @summary Record Audit
 */
export const getApiCCMAuditRecordAudit = (
    params?: GetApiCCMAuditRecordAuditParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIServicesAuditType>(
      {url: `/api/CCM/Audit/RecordAudit`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMAuditRecordAuditQueryKey = (params?: GetApiCCMAuditRecordAuditParams,) => {
    return [`/api/CCM/Audit/RecordAudit`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMAuditRecordAuditQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMAuditRecordAudit>>, TError = ErrorType<string>>(params?: GetApiCCMAuditRecordAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAuditRecordAudit>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMAuditRecordAuditQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMAuditRecordAudit>>> = ({ signal }) => getApiCCMAuditRecordAudit(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAuditRecordAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMAuditRecordAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMAuditRecordAudit>>>
export type GetApiCCMAuditRecordAuditQueryError = ErrorType<string>


/**
 * @summary Record Audit
 */

export function useGetApiCCMAuditRecordAudit<TData = Awaited<ReturnType<typeof getApiCCMAuditRecordAudit>>, TError = ErrorType<string>>(
 params?: GetApiCCMAuditRecordAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMAuditRecordAudit>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMAuditRecordAuditQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint will return the bank details of the specified account number and sort code.
 * @summary Get Bank Details
 */
export const getApiCCMBankGetBankDetails = (
    params?: GetApiCCMBankGetBankDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoBankDetailsDto>(
      {url: `/api/CCM/Bank/GetBankDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMBankGetBankDetailsQueryKey = (params?: GetApiCCMBankGetBankDetailsParams,) => {
    return [`/api/CCM/Bank/GetBankDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMBankGetBankDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMBankGetBankDetails>>, TError = ErrorType<string>>(params?: GetApiCCMBankGetBankDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMBankGetBankDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMBankGetBankDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMBankGetBankDetails>>> = ({ signal }) => getApiCCMBankGetBankDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMBankGetBankDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMBankGetBankDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMBankGetBankDetails>>>
export type GetApiCCMBankGetBankDetailsQueryError = ErrorType<string>


/**
 * @summary Get Bank Details
 */

export function useGetApiCCMBankGetBankDetails<TData = Awaited<ReturnType<typeof getApiCCMBankGetBankDetails>>, TError = ErrorType<string>>(
 params?: GetApiCCMBankGetBankDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMBankGetBankDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMBankGetBankDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint will return the details of a card based on the card number provided.
 * @summary Get the details of a card based on the card number
 */
export const getApiCCMBankGetCardDetails = (
    params?: GetApiCCMBankGetCardDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/CCM/Bank/GetCardDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMBankGetCardDetailsQueryKey = (params?: GetApiCCMBankGetCardDetailsParams,) => {
    return [`/api/CCM/Bank/GetCardDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMBankGetCardDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMBankGetCardDetails>>, TError = ErrorType<string>>(params?: GetApiCCMBankGetCardDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMBankGetCardDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMBankGetCardDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMBankGetCardDetails>>> = ({ signal }) => getApiCCMBankGetCardDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMBankGetCardDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMBankGetCardDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMBankGetCardDetails>>>
export type GetApiCCMBankGetCardDetailsQueryError = ErrorType<string>


/**
 * @summary Get the details of a card based on the card number
 */

export function useGetApiCCMBankGetCardDetails<TData = Awaited<ReturnType<typeof getApiCCMBankGetCardDetails>>, TError = ErrorType<string>>(
 params?: GetApiCCMBankGetCardDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMBankGetCardDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMBankGetCardDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Sets the claim validation for a given user.
 * @summary Sets the claim validation for a given user.
 */
export const postApiCCMClaimsSetClaimValidation = (
    careClubCCMAPIModelsDtoSetClaimValidationRequestDto: BodyType<CareClubCCMAPIModelsDtoSetClaimValidationRequestDto>,
    params?: PostApiCCMClaimsSetClaimValidationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/CCM/Claims/SetClaimValidation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsDtoSetClaimValidationRequestDto,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMClaimsSetClaimValidationMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMClaimsSetClaimValidation>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoSetClaimValidationRequestDto>;params?: PostApiCCMClaimsSetClaimValidationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMClaimsSetClaimValidation>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoSetClaimValidationRequestDto>;params?: PostApiCCMClaimsSetClaimValidationParams}, TContext> => {

const mutationKey = ['postApiCCMClaimsSetClaimValidation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMClaimsSetClaimValidation>>, {data: BodyType<CareClubCCMAPIModelsDtoSetClaimValidationRequestDto>;params?: PostApiCCMClaimsSetClaimValidationParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMClaimsSetClaimValidation(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMClaimsSetClaimValidationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMClaimsSetClaimValidation>>>
    export type PostApiCCMClaimsSetClaimValidationMutationBody = BodyType<CareClubCCMAPIModelsDtoSetClaimValidationRequestDto>
    export type PostApiCCMClaimsSetClaimValidationMutationError = ErrorType<string>

    /**
 * @summary Sets the claim validation for a given user.
 */
export const usePostApiCCMClaimsSetClaimValidation = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMClaimsSetClaimValidation>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoSetClaimValidationRequestDto>;params?: PostApiCCMClaimsSetClaimValidationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMClaimsSetClaimValidation>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsDtoSetClaimValidationRequestDto>;params?: PostApiCCMClaimsSetClaimValidationParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMClaimsSetClaimValidationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Deletes a job from the service agreement based on the provided service agreement job id and user id.
 * @summary Deletes a job from the service agreement
 */
export const postApiCCMClaimsDeleteJob = (
    params?: PostApiCCMClaimsDeleteJobParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Claims/DeleteJob`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMClaimsDeleteJobMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMClaimsDeleteJob>>, TError,{params?: PostApiCCMClaimsDeleteJobParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMClaimsDeleteJob>>, TError,{params?: PostApiCCMClaimsDeleteJobParams}, TContext> => {

const mutationKey = ['postApiCCMClaimsDeleteJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMClaimsDeleteJob>>, {params?: PostApiCCMClaimsDeleteJobParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMClaimsDeleteJob(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMClaimsDeleteJobMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMClaimsDeleteJob>>>
    
    export type PostApiCCMClaimsDeleteJobMutationError = ErrorType<string>

    /**
 * @summary Deletes a job from the service agreement
 */
export const usePostApiCCMClaimsDeleteJob = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMClaimsDeleteJob>>, TError,{params?: PostApiCCMClaimsDeleteJobParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMClaimsDeleteJob>>,
        TError,
        {params?: PostApiCCMClaimsDeleteJobParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMClaimsDeleteJobMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Creates an excess invoice for a given service agreement job.
 * @summary Creates an excess invoice for a given service agreement job.
 */
export const postApiCCMClaimsCreateExcessInvoice = (
    params?: PostApiCCMClaimsCreateExcessInvoiceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Claims/CreateExcessInvoice`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMClaimsCreateExcessInvoiceMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMClaimsCreateExcessInvoice>>, TError,{params?: PostApiCCMClaimsCreateExcessInvoiceParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMClaimsCreateExcessInvoice>>, TError,{params?: PostApiCCMClaimsCreateExcessInvoiceParams}, TContext> => {

const mutationKey = ['postApiCCMClaimsCreateExcessInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMClaimsCreateExcessInvoice>>, {params?: PostApiCCMClaimsCreateExcessInvoiceParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMClaimsCreateExcessInvoice(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMClaimsCreateExcessInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMClaimsCreateExcessInvoice>>>
    
    export type PostApiCCMClaimsCreateExcessInvoiceMutationError = ErrorType<string>

    /**
 * @summary Creates an excess invoice for a given service agreement job.
 */
export const usePostApiCCMClaimsCreateExcessInvoice = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMClaimsCreateExcessInvoice>>, TError,{params?: PostApiCCMClaimsCreateExcessInvoiceParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMClaimsCreateExcessInvoice>>,
        TError,
        {params?: PostApiCCMClaimsCreateExcessInvoiceParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMClaimsCreateExcessInvoiceMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Gets a list of claim validations pending for a given user.
 * @summary Gets a list of claim validations pending for a given user.
 */
export const getApiCCMClaimsGetClaimValidationsPending = (
    params?: GetApiCCMClaimsGetClaimValidationsPendingParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoClaimValidationPendingDto[]>(
      {url: `/api/CCM/Claims/GetClaimValidationsPending`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMClaimsGetClaimValidationsPendingQueryKey = (params?: GetApiCCMClaimsGetClaimValidationsPendingParams,) => {
    return [`/api/CCM/Claims/GetClaimValidationsPending`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMClaimsGetClaimValidationsPendingQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMClaimsGetClaimValidationsPending>>, TError = ErrorType<string>>(params?: GetApiCCMClaimsGetClaimValidationsPendingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMClaimsGetClaimValidationsPending>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMClaimsGetClaimValidationsPendingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMClaimsGetClaimValidationsPending>>> = ({ signal }) => getApiCCMClaimsGetClaimValidationsPending(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMClaimsGetClaimValidationsPending>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMClaimsGetClaimValidationsPendingQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMClaimsGetClaimValidationsPending>>>
export type GetApiCCMClaimsGetClaimValidationsPendingQueryError = ErrorType<string>


/**
 * @summary Gets a list of claim validations pending for a given user.
 */

export function useGetApiCCMClaimsGetClaimValidationsPending<TData = Awaited<ReturnType<typeof getApiCCMClaimsGetClaimValidationsPending>>, TError = ErrorType<string>>(
 params?: GetApiCCMClaimsGetClaimValidationsPendingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMClaimsGetClaimValidationsPending>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMClaimsGetClaimValidationsPendingQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieves available offers for the given service agreement and user
 * @summary Retrieves available offers for the given service agreement and user
 */
export const getApiCCMCostsGetAvailableOffers = (
    params?: GetApiCCMCostsGetAvailableOffersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsAvailableOfferView[]>(
      {url: `/api/CCM/Costs/GetAvailableOffers`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMCostsGetAvailableOffersQueryKey = (params?: GetApiCCMCostsGetAvailableOffersParams,) => {
    return [`/api/CCM/Costs/GetAvailableOffers`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMCostsGetAvailableOffersQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMCostsGetAvailableOffers>>, TError = ErrorType<string>>(params?: GetApiCCMCostsGetAvailableOffersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCostsGetAvailableOffers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMCostsGetAvailableOffersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMCostsGetAvailableOffers>>> = ({ signal }) => getApiCCMCostsGetAvailableOffers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCostsGetAvailableOffers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMCostsGetAvailableOffersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMCostsGetAvailableOffers>>>
export type GetApiCCMCostsGetAvailableOffersQueryError = ErrorType<string>


/**
 * @summary Retrieves available offers for the given service agreement and user
 */

export function useGetApiCCMCostsGetAvailableOffers<TData = Awaited<ReturnType<typeof getApiCCMCostsGetAvailableOffers>>, TError = ErrorType<string>>(
 params?: GetApiCCMCostsGetAvailableOffersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCostsGetAvailableOffers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMCostsGetAvailableOffersQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieves the reasons for offer allocation
 * @summary Retrieves the reasons for offer allocation
 */
export const getApiCCMCostsGetOfferAllocationReasons = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetReferenceDataResult[]>(
      {url: `/api/CCM/Costs/GetOfferAllocationReasons`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiCCMCostsGetOfferAllocationReasonsQueryKey = () => {
    return [`/api/CCM/Costs/GetOfferAllocationReasons`] as const;
    }

    
export const getGetApiCCMCostsGetOfferAllocationReasonsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMCostsGetOfferAllocationReasons>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCostsGetOfferAllocationReasons>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMCostsGetOfferAllocationReasonsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMCostsGetOfferAllocationReasons>>> = ({ signal }) => getApiCCMCostsGetOfferAllocationReasons(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCostsGetOfferAllocationReasons>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMCostsGetOfferAllocationReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMCostsGetOfferAllocationReasons>>>
export type GetApiCCMCostsGetOfferAllocationReasonsQueryError = ErrorType<string>


/**
 * @summary Retrieves the reasons for offer allocation
 */

export function useGetApiCCMCostsGetOfferAllocationReasons<TData = Awaited<ReturnType<typeof getApiCCMCostsGetOfferAllocationReasons>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCostsGetOfferAllocationReasons>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMCostsGetOfferAllocationReasonsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the plan cost after offers.
 */
export const postApiCCMCostsGetPlanCostAfterOffers = (
    careClubCCMAPIModelsViewModelsGetPlanCostAfterOffersRequestView: BodyType<CareClubCCMAPIModelsViewModelsGetPlanCostAfterOffersRequestView>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsPlanCostAfterOffersView>(
      {url: `/api/CCM/Costs/GetPlanCostAfterOffers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsViewModelsGetPlanCostAfterOffersRequestView, signal
    },
      options);
    }
  


export const getPostApiCCMCostsGetPlanCostAfterOffersMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsGetPlanCostAfterOffers>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsGetPlanCostAfterOffersRequestView>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsGetPlanCostAfterOffers>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsGetPlanCostAfterOffersRequestView>}, TContext> => {

const mutationKey = ['postApiCCMCostsGetPlanCostAfterOffers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCostsGetPlanCostAfterOffers>>, {data: BodyType<CareClubCCMAPIModelsViewModelsGetPlanCostAfterOffersRequestView>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCCMCostsGetPlanCostAfterOffers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCostsGetPlanCostAfterOffersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCostsGetPlanCostAfterOffers>>>
    export type PostApiCCMCostsGetPlanCostAfterOffersMutationBody = BodyType<CareClubCCMAPIModelsViewModelsGetPlanCostAfterOffersRequestView>
    export type PostApiCCMCostsGetPlanCostAfterOffersMutationError = ErrorType<string>

    /**
 * @summary Gets the plan cost after offers.
 */
export const usePostApiCCMCostsGetPlanCostAfterOffers = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsGetPlanCostAfterOffers>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsGetPlanCostAfterOffersRequestView>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCostsGetPlanCostAfterOffers>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsViewModelsGetPlanCostAfterOffersRequestView>},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCostsGetPlanCostAfterOffersMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint returns the cost details for a Service Agreement.
 * @summary Get Cost Details for a Service Agreement
 */
export const getApiCCMCostsGetCostDetails = (
    params?: GetApiCCMCostsGetCostDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsCostDetailsView>(
      {url: `/api/CCM/Costs/GetCostDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMCostsGetCostDetailsQueryKey = (params?: GetApiCCMCostsGetCostDetailsParams,) => {
    return [`/api/CCM/Costs/GetCostDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMCostsGetCostDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMCostsGetCostDetails>>, TError = ErrorType<string>>(params?: GetApiCCMCostsGetCostDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCostsGetCostDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMCostsGetCostDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMCostsGetCostDetails>>> = ({ signal }) => getApiCCMCostsGetCostDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCostsGetCostDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMCostsGetCostDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMCostsGetCostDetails>>>
export type GetApiCCMCostsGetCostDetailsQueryError = ErrorType<string>


/**
 * @summary Get Cost Details for a Service Agreement
 */

export function useGetApiCCMCostsGetCostDetails<TData = Awaited<ReturnType<typeof getApiCCMCostsGetCostDetails>>, TError = ErrorType<string>>(
 params?: GetApiCCMCostsGetCostDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCostsGetCostDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMCostsGetCostDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Allocate a subscription offer to a service agreement with the specified parameters.
 * @summary Allocate a subscription offer to a service agreement
 */
export const postApiCCMCostsAllocateSubscriptionOffer = (
    params?: PostApiCCMCostsAllocateSubscriptionOfferParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Costs/AllocateSubscriptionOffer`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCostsAllocateSubscriptionOfferMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsAllocateSubscriptionOffer>>, TError,{params?: PostApiCCMCostsAllocateSubscriptionOfferParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsAllocateSubscriptionOffer>>, TError,{params?: PostApiCCMCostsAllocateSubscriptionOfferParams}, TContext> => {

const mutationKey = ['postApiCCMCostsAllocateSubscriptionOffer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCostsAllocateSubscriptionOffer>>, {params?: PostApiCCMCostsAllocateSubscriptionOfferParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMCostsAllocateSubscriptionOffer(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCostsAllocateSubscriptionOfferMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCostsAllocateSubscriptionOffer>>>
    
    export type PostApiCCMCostsAllocateSubscriptionOfferMutationError = ErrorType<string>

    /**
 * @summary Allocate a subscription offer to a service agreement
 */
export const usePostApiCCMCostsAllocateSubscriptionOffer = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsAllocateSubscriptionOffer>>, TError,{params?: PostApiCCMCostsAllocateSubscriptionOfferParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCostsAllocateSubscriptionOffer>>,
        TError,
        {params?: PostApiCCMCostsAllocateSubscriptionOfferParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCostsAllocateSubscriptionOfferMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Allocate a subscription offer to a service agreement with the specified parameters.
 * @summary Allocate a subscription offer to a service agreement
 */
export const postApiCCMCostsAllocateSubscriptionOfferWithRefferal = (
    careClubCCMAPIModelsTablesServiceAgreementReferralDiscounts: BodyType<CareClubCCMAPIModelsTablesServiceAgreementReferralDiscounts>,
    params?: PostApiCCMCostsAllocateSubscriptionOfferWithRefferalParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Costs/AllocateSubscriptionOfferWithRefferal`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsTablesServiceAgreementReferralDiscounts,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCostsAllocateSubscriptionOfferWithRefferalMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsAllocateSubscriptionOfferWithRefferal>>, TError,{data: BodyType<CareClubCCMAPIModelsTablesServiceAgreementReferralDiscounts>;params?: PostApiCCMCostsAllocateSubscriptionOfferWithRefferalParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsAllocateSubscriptionOfferWithRefferal>>, TError,{data: BodyType<CareClubCCMAPIModelsTablesServiceAgreementReferralDiscounts>;params?: PostApiCCMCostsAllocateSubscriptionOfferWithRefferalParams}, TContext> => {

const mutationKey = ['postApiCCMCostsAllocateSubscriptionOfferWithRefferal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCostsAllocateSubscriptionOfferWithRefferal>>, {data: BodyType<CareClubCCMAPIModelsTablesServiceAgreementReferralDiscounts>;params?: PostApiCCMCostsAllocateSubscriptionOfferWithRefferalParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMCostsAllocateSubscriptionOfferWithRefferal(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCostsAllocateSubscriptionOfferWithRefferalMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCostsAllocateSubscriptionOfferWithRefferal>>>
    export type PostApiCCMCostsAllocateSubscriptionOfferWithRefferalMutationBody = BodyType<CareClubCCMAPIModelsTablesServiceAgreementReferralDiscounts>
    export type PostApiCCMCostsAllocateSubscriptionOfferWithRefferalMutationError = ErrorType<string>

    /**
 * @summary Allocate a subscription offer to a service agreement
 */
export const usePostApiCCMCostsAllocateSubscriptionOfferWithRefferal = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsAllocateSubscriptionOfferWithRefferal>>, TError,{data: BodyType<CareClubCCMAPIModelsTablesServiceAgreementReferralDiscounts>;params?: PostApiCCMCostsAllocateSubscriptionOfferWithRefferalParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCostsAllocateSubscriptionOfferWithRefferal>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsTablesServiceAgreementReferralDiscounts>;params?: PostApiCCMCostsAllocateSubscriptionOfferWithRefferalParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCostsAllocateSubscriptionOfferWithRefferalMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Toggles the allocated subscription offer for a specific service agreement and allocation.
 */
export const postApiCCMCostsToggleAllocatedSubscriptionOffer = (
    params?: PostApiCCMCostsToggleAllocatedSubscriptionOfferParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/CCM/Costs/ToggleAllocatedSubscriptionOffer`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCostsToggleAllocatedSubscriptionOfferMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsToggleAllocatedSubscriptionOffer>>, TError,{params?: PostApiCCMCostsToggleAllocatedSubscriptionOfferParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsToggleAllocatedSubscriptionOffer>>, TError,{params?: PostApiCCMCostsToggleAllocatedSubscriptionOfferParams}, TContext> => {

const mutationKey = ['postApiCCMCostsToggleAllocatedSubscriptionOffer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCostsToggleAllocatedSubscriptionOffer>>, {params?: PostApiCCMCostsToggleAllocatedSubscriptionOfferParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMCostsToggleAllocatedSubscriptionOffer(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCostsToggleAllocatedSubscriptionOfferMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCostsToggleAllocatedSubscriptionOffer>>>
    
    export type PostApiCCMCostsToggleAllocatedSubscriptionOfferMutationError = ErrorType<string>

    /**
 * @summary Toggles the allocated subscription offer for a specific service agreement and allocation.
 */
export const usePostApiCCMCostsToggleAllocatedSubscriptionOffer = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsToggleAllocatedSubscriptionOffer>>, TError,{params?: PostApiCCMCostsToggleAllocatedSubscriptionOfferParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCostsToggleAllocatedSubscriptionOffer>>,
        TError,
        {params?: PostApiCCMCostsToggleAllocatedSubscriptionOfferParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCostsToggleAllocatedSubscriptionOfferMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Previews the subscription offers for a specific service agreement and allocation.
 */
export const postApiCCMCostsPreviewSubscriptionOffer = (
    careClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView: BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferResult[]>(
      {url: `/api/CCM/Costs/PreviewSubscriptionOffer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView, signal
    },
      options);
    }
  


export const getPostApiCCMCostsPreviewSubscriptionOfferMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsPreviewSubscriptionOffer>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsPreviewSubscriptionOffer>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>}, TContext> => {

const mutationKey = ['postApiCCMCostsPreviewSubscriptionOffer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCostsPreviewSubscriptionOffer>>, {data: BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCCMCostsPreviewSubscriptionOffer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCostsPreviewSubscriptionOfferMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCostsPreviewSubscriptionOffer>>>
    export type PostApiCCMCostsPreviewSubscriptionOfferMutationBody = BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>
    export type PostApiCCMCostsPreviewSubscriptionOfferMutationError = ErrorType<string>

    /**
 * @summary Previews the subscription offers for a specific service agreement and allocation.
 */
export const usePostApiCCMCostsPreviewSubscriptionOffer = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsPreviewSubscriptionOffer>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCostsPreviewSubscriptionOffer>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCostsPreviewSubscriptionOfferMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Previews the subscription offers for a specific service agreement and allocation.
 */
export const postApiCCMCostsPreviewSubscriptionOfferV2 = (
    careClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView: BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsPreviewSubscriptionOfferResult[]>(
      {url: `/api/CCM/Costs/PreviewSubscriptionOfferV2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView, signal
    },
      options);
    }
  


export const getPostApiCCMCostsPreviewSubscriptionOfferV2MutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsPreviewSubscriptionOfferV2>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsPreviewSubscriptionOfferV2>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>}, TContext> => {

const mutationKey = ['postApiCCMCostsPreviewSubscriptionOfferV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCostsPreviewSubscriptionOfferV2>>, {data: BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCCMCostsPreviewSubscriptionOfferV2(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCostsPreviewSubscriptionOfferV2MutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCostsPreviewSubscriptionOfferV2>>>
    export type PostApiCCMCostsPreviewSubscriptionOfferV2MutationBody = BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>
    export type PostApiCCMCostsPreviewSubscriptionOfferV2MutationError = ErrorType<string>

    /**
 * @summary Previews the subscription offers for a specific service agreement and allocation.
 */
export const usePostApiCCMCostsPreviewSubscriptionOfferV2 = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsPreviewSubscriptionOfferV2>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCostsPreviewSubscriptionOfferV2>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsViewModelsPreviewSubscriptionOffersRequestView>},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCostsPreviewSubscriptionOfferV2MutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Validates a campaign code for a specific service agreement.
 */
export const getApiCCMCostsValidateCampaignCode = (
    params?: GetApiCCMCostsValidateCampaignCodeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsCampaignCodeValidationView>(
      {url: `/api/CCM/Costs/ValidateCampaignCode`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMCostsValidateCampaignCodeQueryKey = (params?: GetApiCCMCostsValidateCampaignCodeParams,) => {
    return [`/api/CCM/Costs/ValidateCampaignCode`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMCostsValidateCampaignCodeQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMCostsValidateCampaignCode>>, TError = ErrorType<string>>(params?: GetApiCCMCostsValidateCampaignCodeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCostsValidateCampaignCode>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMCostsValidateCampaignCodeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMCostsValidateCampaignCode>>> = ({ signal }) => getApiCCMCostsValidateCampaignCode(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCostsValidateCampaignCode>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMCostsValidateCampaignCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMCostsValidateCampaignCode>>>
export type GetApiCCMCostsValidateCampaignCodeQueryError = ErrorType<string>


/**
 * @summary Validates a campaign code for a specific service agreement.
 */

export function useGetApiCCMCostsValidateCampaignCode<TData = Awaited<ReturnType<typeof getApiCCMCostsValidateCampaignCode>>, TError = ErrorType<string>>(
 params?: GetApiCCMCostsValidateCampaignCodeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCostsValidateCampaignCode>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMCostsValidateCampaignCodeQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets the generated invoices for a specific input.
 * @summary Gets the generated invoices for a specific input.
 */
export const postApiCCMCostsGenerateInvoices = (
    careClubCCMAPIModelsDtoInvoiceRequestDto: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoGeneratedInvoiceDto[]>(
      {url: `/api/CCM/Costs/GenerateInvoices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsDtoInvoiceRequestDto, signal
    },
      options);
    }
  


export const getPostApiCCMCostsGenerateInvoicesMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsGenerateInvoices>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsGenerateInvoices>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>}, TContext> => {

const mutationKey = ['postApiCCMCostsGenerateInvoices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCostsGenerateInvoices>>, {data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCCMCostsGenerateInvoices(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCostsGenerateInvoicesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCostsGenerateInvoices>>>
    export type PostApiCCMCostsGenerateInvoicesMutationBody = BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>
    export type PostApiCCMCostsGenerateInvoicesMutationError = ErrorType<string>

    /**
 * @summary Gets the generated invoices for a specific input.
 */
export const usePostApiCCMCostsGenerateInvoices = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCostsGenerateInvoices>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCostsGenerateInvoices>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsDtoInvoiceRequestDto>},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCostsGenerateInvoicesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Gets all credit control cases for a given service agreement.
 * @summary Gets all credit control cases for a given service agreement.
 */
export const getApiCCMCreditControlGetCreditControlCases = (
    params?: GetApiCCMCreditControlGetCreditControlCasesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsCreditControlCaseView[]>(
      {url: `/api/CCM/CreditControl/GetCreditControlCases`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMCreditControlGetCreditControlCasesQueryKey = (params?: GetApiCCMCreditControlGetCreditControlCasesParams,) => {
    return [`/api/CCM/CreditControl/GetCreditControlCases`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMCreditControlGetCreditControlCasesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlCases>>, TError = ErrorType<string>>(params?: GetApiCCMCreditControlGetCreditControlCasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlCases>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMCreditControlGetCreditControlCasesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlCases>>> = ({ signal }) => getApiCCMCreditControlGetCreditControlCases(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlCases>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMCreditControlGetCreditControlCasesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlCases>>>
export type GetApiCCMCreditControlGetCreditControlCasesQueryError = ErrorType<string>


/**
 * @summary Gets all credit control cases for a given service agreement.
 */

export function useGetApiCCMCreditControlGetCreditControlCases<TData = Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlCases>>, TError = ErrorType<string>>(
 params?: GetApiCCMCreditControlGetCreditControlCasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlCases>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMCreditControlGetCreditControlCasesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a list of CreditControlHoldView objects for the given userId
 * @summary Gets all holds
 */
export const getApiCCMCreditControlGetHolds = (
    params?: GetApiCCMCreditControlGetHoldsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsCreditControlHoldView[]>(
      {url: `/api/CCM/CreditControl/GetHolds`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMCreditControlGetHoldsQueryKey = (params?: GetApiCCMCreditControlGetHoldsParams,) => {
    return [`/api/CCM/CreditControl/GetHolds`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMCreditControlGetHoldsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMCreditControlGetHolds>>, TError = ErrorType<void>>(params?: GetApiCCMCreditControlGetHoldsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetHolds>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMCreditControlGetHoldsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMCreditControlGetHolds>>> = ({ signal }) => getApiCCMCreditControlGetHolds(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetHolds>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMCreditControlGetHoldsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMCreditControlGetHolds>>>
export type GetApiCCMCreditControlGetHoldsQueryError = ErrorType<void>


/**
 * @summary Gets all holds
 */

export function useGetApiCCMCreditControlGetHolds<TData = Awaited<ReturnType<typeof getApiCCMCreditControlGetHolds>>, TError = ErrorType<void>>(
 params?: GetApiCCMCreditControlGetHoldsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetHolds>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMCreditControlGetHoldsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets the credit control action logs for a given service agreement credit control.
 * @summary Gets the credit control action logs for a given service agreement credit control.
 */
export const getApiCCMCreditControlGetCreditControlActionLogs = (
    params?: GetApiCCMCreditControlGetCreditControlActionLogsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsCreditControlActionLogView[]>(
      {url: `/api/CCM/CreditControl/GetCreditControlActionLogs`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMCreditControlGetCreditControlActionLogsQueryKey = (params?: GetApiCCMCreditControlGetCreditControlActionLogsParams,) => {
    return [`/api/CCM/CreditControl/GetCreditControlActionLogs`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMCreditControlGetCreditControlActionLogsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlActionLogs>>, TError = ErrorType<string>>(params?: GetApiCCMCreditControlGetCreditControlActionLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlActionLogs>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMCreditControlGetCreditControlActionLogsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlActionLogs>>> = ({ signal }) => getApiCCMCreditControlGetCreditControlActionLogs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlActionLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMCreditControlGetCreditControlActionLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlActionLogs>>>
export type GetApiCCMCreditControlGetCreditControlActionLogsQueryError = ErrorType<string>


/**
 * @summary Gets the credit control action logs for a given service agreement credit control.
 */

export function useGetApiCCMCreditControlGetCreditControlActionLogs<TData = Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlActionLogs>>, TError = ErrorType<string>>(
 params?: GetApiCCMCreditControlGetCreditControlActionLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetCreditControlActionLogs>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMCreditControlGetCreditControlActionLogsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets the CCJ claim statuses for a given service agreement credit control.
 * @summary Gets the CCJ claim statuses for a given service agreement credit control.
 */
export const getApiCCMCreditControlGetCCJClaimStatuses = (
    params?: GetApiCCMCreditControlGetCCJClaimStatusesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsCCJClaimStatusView[]>(
      {url: `/api/CCM/CreditControl/GetCCJClaimStatuses`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMCreditControlGetCCJClaimStatusesQueryKey = (params?: GetApiCCMCreditControlGetCCJClaimStatusesParams,) => {
    return [`/api/CCM/CreditControl/GetCCJClaimStatuses`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMCreditControlGetCCJClaimStatusesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMCreditControlGetCCJClaimStatuses>>, TError = ErrorType<string>>(params?: GetApiCCMCreditControlGetCCJClaimStatusesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetCCJClaimStatuses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMCreditControlGetCCJClaimStatusesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMCreditControlGetCCJClaimStatuses>>> = ({ signal }) => getApiCCMCreditControlGetCCJClaimStatuses(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetCCJClaimStatuses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMCreditControlGetCCJClaimStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMCreditControlGetCCJClaimStatuses>>>
export type GetApiCCMCreditControlGetCCJClaimStatusesQueryError = ErrorType<string>


/**
 * @summary Gets the CCJ claim statuses for a given service agreement credit control.
 */

export function useGetApiCCMCreditControlGetCCJClaimStatuses<TData = Awaited<ReturnType<typeof getApiCCMCreditControlGetCCJClaimStatuses>>, TError = ErrorType<string>>(
 params?: GetApiCCMCreditControlGetCCJClaimStatusesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetCCJClaimStatuses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMCreditControlGetCCJClaimStatusesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint will open a new credit control case for a given service agreement and return the id of the newly created credit control case.
 * @summary Open a new credit control case for a given service agreement
 */
export const postApiCCMCreditControlOpenCreditControlCase = (
    params?: PostApiCCMCreditControlOpenCreditControlCaseParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/CCM/CreditControl/OpenCreditControlCase`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCreditControlOpenCreditControlCaseMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCreditControlOpenCreditControlCase>>, TError,{params?: PostApiCCMCreditControlOpenCreditControlCaseParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCreditControlOpenCreditControlCase>>, TError,{params?: PostApiCCMCreditControlOpenCreditControlCaseParams}, TContext> => {

const mutationKey = ['postApiCCMCreditControlOpenCreditControlCase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCreditControlOpenCreditControlCase>>, {params?: PostApiCCMCreditControlOpenCreditControlCaseParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMCreditControlOpenCreditControlCase(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCreditControlOpenCreditControlCaseMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCreditControlOpenCreditControlCase>>>
    
    export type PostApiCCMCreditControlOpenCreditControlCaseMutationError = ErrorType<string>

    /**
 * @summary Open a new credit control case for a given service agreement
 */
export const usePostApiCCMCreditControlOpenCreditControlCase = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCreditControlOpenCreditControlCase>>, TError,{params?: PostApiCCMCreditControlOpenCreditControlCaseParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCreditControlOpenCreditControlCase>>,
        TError,
        {params?: PostApiCCMCreditControlOpenCreditControlCaseParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCreditControlOpenCreditControlCaseMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Removes a pending case from the service agreement based on the service agreement id and service agreement credit control id
 * @summary Removes a pending case from the service agreement
 */
export const postApiCCMCreditControlRemovePendingCase = (
    params?: PostApiCCMCreditControlRemovePendingCaseParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/CreditControl/RemovePendingCase`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCreditControlRemovePendingCaseMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCreditControlRemovePendingCase>>, TError,{params?: PostApiCCMCreditControlRemovePendingCaseParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCreditControlRemovePendingCase>>, TError,{params?: PostApiCCMCreditControlRemovePendingCaseParams}, TContext> => {

const mutationKey = ['postApiCCMCreditControlRemovePendingCase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCreditControlRemovePendingCase>>, {params?: PostApiCCMCreditControlRemovePendingCaseParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMCreditControlRemovePendingCase(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCreditControlRemovePendingCaseMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCreditControlRemovePendingCase>>>
    
    export type PostApiCCMCreditControlRemovePendingCaseMutationError = ErrorType<string>

    /**
 * @summary Removes a pending case from the service agreement
 */
export const usePostApiCCMCreditControlRemovePendingCase = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCreditControlRemovePendingCase>>, TError,{params?: PostApiCCMCreditControlRemovePendingCaseParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCreditControlRemovePendingCase>>,
        TError,
        {params?: PostApiCCMCreditControlRemovePendingCaseParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCreditControlRemovePendingCaseMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Applies a hold to a specific service agreement and credit control.
 */
export const postApiCCMCreditControlApplyHold = (
    params?: PostApiCCMCreditControlApplyHoldParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/CreditControl/ApplyHold`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCreditControlApplyHoldMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCreditControlApplyHold>>, TError,{params?: PostApiCCMCreditControlApplyHoldParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCreditControlApplyHold>>, TError,{params?: PostApiCCMCreditControlApplyHoldParams}, TContext> => {

const mutationKey = ['postApiCCMCreditControlApplyHold'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCreditControlApplyHold>>, {params?: PostApiCCMCreditControlApplyHoldParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMCreditControlApplyHold(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCreditControlApplyHoldMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCreditControlApplyHold>>>
    
    export type PostApiCCMCreditControlApplyHoldMutationError = ErrorType<string>

    /**
 * @summary Applies a hold to a specific service agreement and credit control.
 */
export const usePostApiCCMCreditControlApplyHold = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCreditControlApplyHold>>, TError,{params?: PostApiCCMCreditControlApplyHoldParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCreditControlApplyHold>>,
        TError,
        {params?: PostApiCCMCreditControlApplyHoldParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCreditControlApplyHoldMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Removes a hold from a service agreement.
 * @summary Removes a hold from a service agreement.
 */
export const postApiCCMCreditControlRemoveHold = (
    params?: PostApiCCMCreditControlRemoveHoldParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/CreditControl/RemoveHold`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCreditControlRemoveHoldMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCreditControlRemoveHold>>, TError,{params?: PostApiCCMCreditControlRemoveHoldParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCreditControlRemoveHold>>, TError,{params?: PostApiCCMCreditControlRemoveHoldParams}, TContext> => {

const mutationKey = ['postApiCCMCreditControlRemoveHold'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCreditControlRemoveHold>>, {params?: PostApiCCMCreditControlRemoveHoldParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMCreditControlRemoveHold(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCreditControlRemoveHoldMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCreditControlRemoveHold>>>
    
    export type PostApiCCMCreditControlRemoveHoldMutationError = ErrorType<string>

    /**
 * @summary Removes a hold from a service agreement.
 */
export const usePostApiCCMCreditControlRemoveHold = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCreditControlRemoveHold>>, TError,{params?: PostApiCCMCreditControlRemoveHoldParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCreditControlRemoveHold>>,
        TError,
        {params?: PostApiCCMCreditControlRemoveHoldParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCreditControlRemoveHoldMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Gets the details of a letter.
 */
export const getApiCCMCreditControlGetLetterDetails = (
    params?: GetApiCCMCreditControlGetLetterDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<StannpAPIWrapperModelsDtoLetterDetailsResponse>(
      {url: `/api/CCM/CreditControl/GetLetterDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMCreditControlGetLetterDetailsQueryKey = (params?: GetApiCCMCreditControlGetLetterDetailsParams,) => {
    return [`/api/CCM/CreditControl/GetLetterDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMCreditControlGetLetterDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMCreditControlGetLetterDetails>>, TError = ErrorType<string>>(params?: GetApiCCMCreditControlGetLetterDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetLetterDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMCreditControlGetLetterDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMCreditControlGetLetterDetails>>> = ({ signal }) => getApiCCMCreditControlGetLetterDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetLetterDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMCreditControlGetLetterDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMCreditControlGetLetterDetails>>>
export type GetApiCCMCreditControlGetLetterDetailsQueryError = ErrorType<string>


/**
 * @summary Gets the details of a letter.
 */

export function useGetApiCCMCreditControlGetLetterDetails<TData = Awaited<ReturnType<typeof getApiCCMCreditControlGetLetterDetails>>, TError = ErrorType<string>>(
 params?: GetApiCCMCreditControlGetLetterDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetLetterDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMCreditControlGetLetterDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the details of a SMS.
 */
export const getApiCCMCreditControlGetSMSDetails = (
    params?: GetApiCCMCreditControlGetSMSDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoSMSStatusResponse>(
      {url: `/api/CCM/CreditControl/GetSMSDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMCreditControlGetSMSDetailsQueryKey = (params?: GetApiCCMCreditControlGetSMSDetailsParams,) => {
    return [`/api/CCM/CreditControl/GetSMSDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMCreditControlGetSMSDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMCreditControlGetSMSDetails>>, TError = ErrorType<string>>(params?: GetApiCCMCreditControlGetSMSDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetSMSDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMCreditControlGetSMSDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMCreditControlGetSMSDetails>>> = ({ signal }) => getApiCCMCreditControlGetSMSDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetSMSDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMCreditControlGetSMSDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMCreditControlGetSMSDetails>>>
export type GetApiCCMCreditControlGetSMSDetailsQueryError = ErrorType<string>


/**
 * @summary Gets the details of a SMS.
 */

export function useGetApiCCMCreditControlGetSMSDetails<TData = Awaited<ReturnType<typeof getApiCCMCreditControlGetSMSDetails>>, TError = ErrorType<string>>(
 params?: GetApiCCMCreditControlGetSMSDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCreditControlGetSMSDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMCreditControlGetSMSDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Creates a new customer with the given customer and userId
 * @summary Creates a new customer
 */
export const postApiCCMCustomerCreate = (
    careClubCCMAPIModelsViewModelsCustomerView: BodyType<CareClubCCMAPIModelsViewModelsCustomerView>,
    params?: PostApiCCMCustomerCreateParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsSetCustomerResult>(
      {url: `/api/CCM/Customer/Create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsViewModelsCustomerView,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCustomerCreateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerCreate>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsCustomerView>;params?: PostApiCCMCustomerCreateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerCreate>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsCustomerView>;params?: PostApiCCMCustomerCreateParams}, TContext> => {

const mutationKey = ['postApiCCMCustomerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCustomerCreate>>, {data: BodyType<CareClubCCMAPIModelsViewModelsCustomerView>;params?: PostApiCCMCustomerCreateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMCustomerCreate(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCustomerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCustomerCreate>>>
    export type PostApiCCMCustomerCreateMutationBody = BodyType<CareClubCCMAPIModelsViewModelsCustomerView>
    export type PostApiCCMCustomerCreateMutationError = ErrorType<void>

    /**
 * @summary Creates a new customer
 */
export const usePostApiCCMCustomerCreate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerCreate>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsCustomerView>;params?: PostApiCCMCustomerCreateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCustomerCreate>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsViewModelsCustomerView>;params?: PostApiCCMCustomerCreateParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCustomerCreateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint is used to save a customer.
 * @summary This endpoint is used to save a customer.
 */
export const postApiCCMCustomerSave = (
    careClubCCMAPIModelsViewModelsCustomerView: BodyType<CareClubCCMAPIModelsViewModelsCustomerView>,
    params?: PostApiCCMCustomerSaveParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsCustomerView>(
      {url: `/api/CCM/Customer/Save`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsViewModelsCustomerView,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCustomerSaveMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerSave>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsCustomerView>;params?: PostApiCCMCustomerSaveParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerSave>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsCustomerView>;params?: PostApiCCMCustomerSaveParams}, TContext> => {

const mutationKey = ['postApiCCMCustomerSave'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCustomerSave>>, {data: BodyType<CareClubCCMAPIModelsViewModelsCustomerView>;params?: PostApiCCMCustomerSaveParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMCustomerSave(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCustomerSaveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCustomerSave>>>
    export type PostApiCCMCustomerSaveMutationBody = BodyType<CareClubCCMAPIModelsViewModelsCustomerView>
    export type PostApiCCMCustomerSaveMutationError = ErrorType<void>

    /**
 * @summary This endpoint is used to save a customer.
 */
export const usePostApiCCMCustomerSave = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerSave>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsCustomerView>;params?: PostApiCCMCustomerSaveParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCustomerSave>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsViewModelsCustomerView>;params?: PostApiCCMCustomerSaveParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCustomerSaveMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint will return the VIP details for a given Service Agreement Customer Id.
 * @summary Get VIP Details
 */
export const getVIPDetails = (
    params?: GetVIPDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsVIPDetailsView>(
      {url: `/api/CCM/Customer/GetVIPDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetVIPDetailsQueryKey = (params?: GetVIPDetailsParams,) => {
    return [`/api/CCM/Customer/GetVIPDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetVIPDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getVIPDetails>>, TError = ErrorType<string>>(params?: GetVIPDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVIPDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVIPDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVIPDetails>>> = ({ signal }) => getVIPDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVIPDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVIPDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getVIPDetails>>>
export type GetVIPDetailsQueryError = ErrorType<string>


/**
 * @summary Get VIP Details
 */

export function useGetVIPDetails<TData = Awaited<ReturnType<typeof getVIPDetails>>, TError = ErrorType<string>>(
 params?: GetVIPDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVIPDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVIPDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint will return the VIP status types for a given service agreement customer.
 * @summary Get VIP Status Types
 */
export const getApiCCMCustomerGetVIPStatusTypes = (
    params?: GetApiCCMCustomerGetVIPStatusTypesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsVIPStatusTypesView[]>(
      {url: `/api/CCM/Customer/GetVIPStatusTypes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMCustomerGetVIPStatusTypesQueryKey = (params?: GetApiCCMCustomerGetVIPStatusTypesParams,) => {
    return [`/api/CCM/Customer/GetVIPStatusTypes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMCustomerGetVIPStatusTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMCustomerGetVIPStatusTypes>>, TError = ErrorType<string>>(params?: GetApiCCMCustomerGetVIPStatusTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCustomerGetVIPStatusTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMCustomerGetVIPStatusTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMCustomerGetVIPStatusTypes>>> = ({ signal }) => getApiCCMCustomerGetVIPStatusTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCustomerGetVIPStatusTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMCustomerGetVIPStatusTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMCustomerGetVIPStatusTypes>>>
export type GetApiCCMCustomerGetVIPStatusTypesQueryError = ErrorType<string>


/**
 * @summary Get VIP Status Types
 */

export function useGetApiCCMCustomerGetVIPStatusTypes<TData = Awaited<ReturnType<typeof getApiCCMCustomerGetVIPStatusTypes>>, TError = ErrorType<string>>(
 params?: GetApiCCMCustomerGetVIPStatusTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCustomerGetVIPStatusTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMCustomerGetVIPStatusTypesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint sets the VIP override status for a service agreement customer.
 * @summary Sets the VIP override status for a service agreement customer.
 */
export const postApiCCMCustomerSetVIPOverride = (
    params?: PostApiCCMCustomerSetVIPOverrideParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/CCM/Customer/SetVIPOverride`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCustomerSetVIPOverrideMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerSetVIPOverride>>, TError,{params?: PostApiCCMCustomerSetVIPOverrideParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerSetVIPOverride>>, TError,{params?: PostApiCCMCustomerSetVIPOverrideParams}, TContext> => {

const mutationKey = ['postApiCCMCustomerSetVIPOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCustomerSetVIPOverride>>, {params?: PostApiCCMCustomerSetVIPOverrideParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMCustomerSetVIPOverride(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCustomerSetVIPOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCustomerSetVIPOverride>>>
    
    export type PostApiCCMCustomerSetVIPOverrideMutationError = ErrorType<string>

    /**
 * @summary Sets the VIP override status for a service agreement customer.
 */
export const usePostApiCCMCustomerSetVIPOverride = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerSetVIPOverride>>, TError,{params?: PostApiCCMCustomerSetVIPOverrideParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCustomerSetVIPOverride>>,
        TError,
        {params?: PostApiCCMCustomerSetVIPOverrideParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCustomerSetVIPOverrideMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Sends a feedback request to the customer associated with the given service agreement.
 * @summary Sends a feedback request to the customer associated with the given service agreement.
 */
export const postApiCCMCustomerSendFeedbackRequest = (
    params?: PostApiCCMCustomerSendFeedbackRequestParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/CCM/Customer/SendFeedbackRequest`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCustomerSendFeedbackRequestMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerSendFeedbackRequest>>, TError,{params?: PostApiCCMCustomerSendFeedbackRequestParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerSendFeedbackRequest>>, TError,{params?: PostApiCCMCustomerSendFeedbackRequestParams}, TContext> => {

const mutationKey = ['postApiCCMCustomerSendFeedbackRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCustomerSendFeedbackRequest>>, {params?: PostApiCCMCustomerSendFeedbackRequestParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMCustomerSendFeedbackRequest(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCustomerSendFeedbackRequestMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCustomerSendFeedbackRequest>>>
    
    export type PostApiCCMCustomerSendFeedbackRequestMutationError = ErrorType<string>

    /**
 * @summary Sends a feedback request to the customer associated with the given service agreement.
 */
export const usePostApiCCMCustomerSendFeedbackRequest = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerSendFeedbackRequest>>, TError,{params?: PostApiCCMCustomerSendFeedbackRequestParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCustomerSendFeedbackRequest>>,
        TError,
        {params?: PostApiCCMCustomerSendFeedbackRequestParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCustomerSendFeedbackRequestMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint is used to test encryption of data.
 * @summary TestEncryption endpoint is used to test encryption of data.
 */
export const postApiCCMCustomerTestEncryption = (
    params?: PostApiCCMCustomerTestEncryptionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/CCM/Customer/TestEncryption`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCustomerTestEncryptionMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerTestEncryption>>, TError,{params?: PostApiCCMCustomerTestEncryptionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerTestEncryption>>, TError,{params?: PostApiCCMCustomerTestEncryptionParams}, TContext> => {

const mutationKey = ['postApiCCMCustomerTestEncryption'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCustomerTestEncryption>>, {params?: PostApiCCMCustomerTestEncryptionParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMCustomerTestEncryption(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCustomerTestEncryptionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCustomerTestEncryption>>>
    
    export type PostApiCCMCustomerTestEncryptionMutationError = ErrorType<string>

    /**
 * @summary TestEncryption endpoint is used to test encryption of data.
 */
export const usePostApiCCMCustomerTestEncryption = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerTestEncryption>>, TError,{params?: PostApiCCMCustomerTestEncryptionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCustomerTestEncryption>>,
        TError,
        {params?: PostApiCCMCustomerTestEncryptionParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCustomerTestEncryptionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * The encrypted payload is decrypted and the decrypted TrustPilotInvitation object is returned.
 * @summary TestDecryption endpoint is used to decrypt the payload and return the TrustPilotInvitation object.
 */
export const postApiCCMCustomerTestDecryption = (
    params?: PostApiCCMCustomerTestDecryptionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoTrustPilotInvitationDto>(
      {url: `/api/CCM/Customer/TestDecryption`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCustomerTestDecryptionMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerTestDecryption>>, TError,{params?: PostApiCCMCustomerTestDecryptionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerTestDecryption>>, TError,{params?: PostApiCCMCustomerTestDecryptionParams}, TContext> => {

const mutationKey = ['postApiCCMCustomerTestDecryption'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCustomerTestDecryption>>, {params?: PostApiCCMCustomerTestDecryptionParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMCustomerTestDecryption(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCustomerTestDecryptionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCustomerTestDecryption>>>
    
    export type PostApiCCMCustomerTestDecryptionMutationError = ErrorType<string>

    /**
 * @summary TestDecryption endpoint is used to decrypt the payload and return the TrustPilotInvitation object.
 */
export const usePostApiCCMCustomerTestDecryption = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerTestDecryption>>, TError,{params?: PostApiCCMCustomerTestDecryptionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCustomerTestDecryption>>,
        TError,
        {params?: PostApiCCMCustomerTestDecryptionParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCustomerTestDecryptionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Writes a message to the log with the specified log level.
 * @summary Writes a message to the log with the specified log level.
 */
export const postApiCCMCustomerWriteToLog = (
    params?: PostApiCCMCustomerWriteToLogParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Customer/WriteToLog`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMCustomerWriteToLogMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerWriteToLog>>, TError,{params?: PostApiCCMCustomerWriteToLogParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerWriteToLog>>, TError,{params?: PostApiCCMCustomerWriteToLogParams}, TContext> => {

const mutationKey = ['postApiCCMCustomerWriteToLog'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMCustomerWriteToLog>>, {params?: PostApiCCMCustomerWriteToLogParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMCustomerWriteToLog(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMCustomerWriteToLogMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMCustomerWriteToLog>>>
    
    export type PostApiCCMCustomerWriteToLogMutationError = ErrorType<string>

    /**
 * @summary Writes a message to the log with the specified log level.
 */
export const usePostApiCCMCustomerWriteToLog = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMCustomerWriteToLog>>, TError,{params?: PostApiCCMCustomerWriteToLogParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMCustomerWriteToLog>>,
        TError,
        {params?: PostApiCCMCustomerWriteToLogParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMCustomerWriteToLogMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint will return the customer details for a given service agreement id.
 * @summary Get customer by agreement id
 */
export const getApiCCMCustomerGetByAgreementId = (
    params?: GetApiCCMCustomerGetByAgreementIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetCustomerResult>(
      {url: `/api/CCM/Customer/GetByAgreementId`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMCustomerGetByAgreementIdQueryKey = (params?: GetApiCCMCustomerGetByAgreementIdParams,) => {
    return [`/api/CCM/Customer/GetByAgreementId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMCustomerGetByAgreementIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMCustomerGetByAgreementId>>, TError = ErrorType<string>>(params?: GetApiCCMCustomerGetByAgreementIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCustomerGetByAgreementId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMCustomerGetByAgreementIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMCustomerGetByAgreementId>>> = ({ signal }) => getApiCCMCustomerGetByAgreementId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCustomerGetByAgreementId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMCustomerGetByAgreementIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMCustomerGetByAgreementId>>>
export type GetApiCCMCustomerGetByAgreementIdQueryError = ErrorType<string>


/**
 * @summary Get customer by agreement id
 */

export function useGetApiCCMCustomerGetByAgreementId<TData = Awaited<ReturnType<typeof getApiCCMCustomerGetByAgreementId>>, TError = ErrorType<string>>(
 params?: GetApiCCMCustomerGetByAgreementIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMCustomerGetByAgreementId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMCustomerGetByAgreementIdQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a DiarySummaryResultView object containing the summary.
 * @summary Gets a summary of the diary entries for the specified date.
 */
export const getApiCCMDiaryGetSummary = (
    params?: GetApiCCMDiaryGetSummaryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsDiarySummaryResultView>(
      {url: `/api/CCM/Diary/GetSummary`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMDiaryGetSummaryQueryKey = (params?: GetApiCCMDiaryGetSummaryParams,) => {
    return [`/api/CCM/Diary/GetSummary`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMDiaryGetSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMDiaryGetSummary>>, TError = ErrorType<string>>(params?: GetApiCCMDiaryGetSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMDiaryGetSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMDiaryGetSummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMDiaryGetSummary>>> = ({ signal }) => getApiCCMDiaryGetSummary(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMDiaryGetSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMDiaryGetSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMDiaryGetSummary>>>
export type GetApiCCMDiaryGetSummaryQueryError = ErrorType<string>


/**
 * @summary Gets a summary of the diary entries for the specified date.
 */

export function useGetApiCCMDiaryGetSummary<TData = Awaited<ReturnType<typeof getApiCCMDiaryGetSummary>>, TError = ErrorType<string>>(
 params?: GetApiCCMDiaryGetSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMDiaryGetSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMDiaryGetSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a DiarySummaryResultView object containing the summary of outstanding diary entries
 * @summary Get a summary of outstanding diary entries
 */
export const getApiCCMDiaryGetSummaryOutstanding = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsDiarySummaryResultView>(
      {url: `/api/CCM/Diary/GetSummaryOutstanding`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiCCMDiaryGetSummaryOutstandingQueryKey = () => {
    return [`/api/CCM/Diary/GetSummaryOutstanding`] as const;
    }

    
export const getGetApiCCMDiaryGetSummaryOutstandingQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMDiaryGetSummaryOutstanding>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMDiaryGetSummaryOutstanding>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMDiaryGetSummaryOutstandingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMDiaryGetSummaryOutstanding>>> = ({ signal }) => getApiCCMDiaryGetSummaryOutstanding(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMDiaryGetSummaryOutstanding>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMDiaryGetSummaryOutstandingQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMDiaryGetSummaryOutstanding>>>
export type GetApiCCMDiaryGetSummaryOutstandingQueryError = ErrorType<void>


/**
 * @summary Get a summary of outstanding diary entries
 */

export function useGetApiCCMDiaryGetSummaryOutstanding<TData = Awaited<ReturnType<typeof getApiCCMDiaryGetSummaryOutstanding>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMDiaryGetSummaryOutstanding>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMDiaryGetSummaryOutstandingQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Add an entry to the diary with the given parameters
 * @summary Add an entry to the diary
 */
export const postApiCCMDiaryAddEntry = (
    params?: PostApiCCMDiaryAddEntryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Diary/AddEntry`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMDiaryAddEntryMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMDiaryAddEntry>>, TError,{params?: PostApiCCMDiaryAddEntryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMDiaryAddEntry>>, TError,{params?: PostApiCCMDiaryAddEntryParams}, TContext> => {

const mutationKey = ['postApiCCMDiaryAddEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMDiaryAddEntry>>, {params?: PostApiCCMDiaryAddEntryParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMDiaryAddEntry(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMDiaryAddEntryMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMDiaryAddEntry>>>
    
    export type PostApiCCMDiaryAddEntryMutationError = ErrorType<string>

    /**
 * @summary Add an entry to the diary
 */
export const usePostApiCCMDiaryAddEntry = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMDiaryAddEntry>>, TError,{params?: PostApiCCMDiaryAddEntryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMDiaryAddEntry>>,
        TError,
        {params?: PostApiCCMDiaryAddEntryParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMDiaryAddEntryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Updates an existing diary entry with the given parameters
 * @summary Updates an existing diary entry
 */
export const postApiCCMDiaryUpdateEntry = (
    params?: PostApiCCMDiaryUpdateEntryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Diary/UpdateEntry`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMDiaryUpdateEntryMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMDiaryUpdateEntry>>, TError,{params?: PostApiCCMDiaryUpdateEntryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMDiaryUpdateEntry>>, TError,{params?: PostApiCCMDiaryUpdateEntryParams}, TContext> => {

const mutationKey = ['postApiCCMDiaryUpdateEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMDiaryUpdateEntry>>, {params?: PostApiCCMDiaryUpdateEntryParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMDiaryUpdateEntry(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMDiaryUpdateEntryMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMDiaryUpdateEntry>>>
    
    export type PostApiCCMDiaryUpdateEntryMutationError = ErrorType<string>

    /**
 * @summary Updates an existing diary entry
 */
export const usePostApiCCMDiaryUpdateEntry = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMDiaryUpdateEntry>>, TError,{params?: PostApiCCMDiaryUpdateEntryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMDiaryUpdateEntry>>,
        TError,
        {params?: PostApiCCMDiaryUpdateEntryParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMDiaryUpdateEntryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Retrieves a diary entry from the database based on the provided diaryId.
 * @summary Retrieves a diary entry from the database.
 */
export const getApiCCMDiaryGetEntry = (
    params?: GetApiCCMDiaryGetEntryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsDiaryEntryView>(
      {url: `/api/CCM/Diary/GetEntry`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMDiaryGetEntryQueryKey = (params?: GetApiCCMDiaryGetEntryParams,) => {
    return [`/api/CCM/Diary/GetEntry`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMDiaryGetEntryQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMDiaryGetEntry>>, TError = ErrorType<string>>(params?: GetApiCCMDiaryGetEntryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMDiaryGetEntry>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMDiaryGetEntryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMDiaryGetEntry>>> = ({ signal }) => getApiCCMDiaryGetEntry(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMDiaryGetEntry>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMDiaryGetEntryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMDiaryGetEntry>>>
export type GetApiCCMDiaryGetEntryQueryError = ErrorType<string>


/**
 * @summary Retrieves a diary entry from the database.
 */

export function useGetApiCCMDiaryGetEntry<TData = Awaited<ReturnType<typeof getApiCCMDiaryGetEntry>>, TError = ErrorType<string>>(
 params?: GetApiCCMDiaryGetEntryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMDiaryGetEntry>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMDiaryGetEntryQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint sends an email.
 * @summary Sends an email
 */
export const postApiCCMEmailSendEmail = (
    rightioEmailSenderModelsEmailNoAttachmentsDto: BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/CCM/Email/SendEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioEmailSenderModelsEmailNoAttachmentsDto, signal
    },
      options);
    }
  


export const getPostApiCCMEmailSendEmailMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMEmailSendEmail>>, TError,{data: BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMEmailSendEmail>>, TError,{data: BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>}, TContext> => {

const mutationKey = ['postApiCCMEmailSendEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMEmailSendEmail>>, {data: BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCCMEmailSendEmail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMEmailSendEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMEmailSendEmail>>>
    export type PostApiCCMEmailSendEmailMutationBody = BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>
    export type PostApiCCMEmailSendEmailMutationError = ErrorType<string>

    /**
 * @summary Sends an email
 */
export const usePostApiCCMEmailSendEmail = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMEmailSendEmail>>, TError,{data: BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMEmailSendEmail>>,
        TError,
        {data: BodyType<RightioEmailSenderModelsEmailNoAttachmentsDto>},
        TContext
      > => {

      const mutationOptions = getPostApiCCMEmailSendEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Retrieves a list of external engineers based on the postcode and trade code provided.
 * @summary Retrieves a list of external engineers based on the postcode and trade code provided.
 */
export const getApiCCMEngineersGetExternalEngineers = (
    params?: GetApiCCMEngineersGetExternalEngineersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetExternalEngineersResult[]>(
      {url: `/api/CCM/Engineers/GetExternalEngineers`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMEngineersGetExternalEngineersQueryKey = (params?: GetApiCCMEngineersGetExternalEngineersParams,) => {
    return [`/api/CCM/Engineers/GetExternalEngineers`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMEngineersGetExternalEngineersQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineers>>, TError = ErrorType<void>>(params?: GetApiCCMEngineersGetExternalEngineersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMEngineersGetExternalEngineersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineers>>> = ({ signal }) => getApiCCMEngineersGetExternalEngineers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMEngineersGetExternalEngineersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineers>>>
export type GetApiCCMEngineersGetExternalEngineersQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of external engineers based on the postcode and trade code provided.
 */

export function useGetApiCCMEngineersGetExternalEngineers<TData = Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineers>>, TError = ErrorType<void>>(
 params?: GetApiCCMEngineersGetExternalEngineersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMEngineersGetExternalEngineersQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Gets the details of an external engineer
 */
export const getApiCCMEngineersGetExternalEngineerDetails = (
    params?: GetApiCCMEngineersGetExternalEngineerDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetExternalEngineerDetailsResult[]>(
      {url: `/api/CCM/Engineers/GetExternalEngineerDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMEngineersGetExternalEngineerDetailsQueryKey = (params?: GetApiCCMEngineersGetExternalEngineerDetailsParams,) => {
    return [`/api/CCM/Engineers/GetExternalEngineerDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMEngineersGetExternalEngineerDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineerDetails>>, TError = ErrorType<string>>(params?: GetApiCCMEngineersGetExternalEngineerDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineerDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMEngineersGetExternalEngineerDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineerDetails>>> = ({ signal }) => getApiCCMEngineersGetExternalEngineerDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineerDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMEngineersGetExternalEngineerDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineerDetails>>>
export type GetApiCCMEngineersGetExternalEngineerDetailsQueryError = ErrorType<string>


/**
 * @summary Gets the details of an external engineer
 */

export function useGetApiCCMEngineersGetExternalEngineerDetails<TData = Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineerDetails>>, TError = ErrorType<string>>(
 params?: GetApiCCMEngineersGetExternalEngineerDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetExternalEngineerDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMEngineersGetExternalEngineerDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Set an external engineer for a given engineerId and notes about the engineer
 * @summary Set an external engineer for a given engineerId
 */
export const postApiCCMEngineersSetExternalEngineer = (
    params?: PostApiCCMEngineersSetExternalEngineerParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Engineers/SetExternalEngineer`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMEngineersSetExternalEngineerMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMEngineersSetExternalEngineer>>, TError,{params?: PostApiCCMEngineersSetExternalEngineerParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMEngineersSetExternalEngineer>>, TError,{params?: PostApiCCMEngineersSetExternalEngineerParams}, TContext> => {

const mutationKey = ['postApiCCMEngineersSetExternalEngineer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMEngineersSetExternalEngineer>>, {params?: PostApiCCMEngineersSetExternalEngineerParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMEngineersSetExternalEngineer(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMEngineersSetExternalEngineerMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMEngineersSetExternalEngineer>>>
    
    export type PostApiCCMEngineersSetExternalEngineerMutationError = ErrorType<string>

    /**
 * @summary Set an external engineer for a given engineerId
 */
export const usePostApiCCMEngineersSetExternalEngineer = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMEngineersSetExternalEngineer>>, TError,{params?: PostApiCCMEngineersSetExternalEngineerParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMEngineersSetExternalEngineer>>,
        TError,
        {params?: PostApiCCMEngineersSetExternalEngineerParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMEngineersSetExternalEngineerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Retrieves a list of external engineers based on the trade code provided.
 * @summary Retrieves a list of external engineers based on the trade code provided.
 */
export const getApiCCMEngineersGetAllExternalEngineersForTrade = (
    params?: GetApiCCMEngineersGetAllExternalEngineersForTradeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetExternalEngineersResult[]>(
      {url: `/api/CCM/Engineers/GetAllExternalEngineersForTrade`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMEngineersGetAllExternalEngineersForTradeQueryKey = (params?: GetApiCCMEngineersGetAllExternalEngineersForTradeParams,) => {
    return [`/api/CCM/Engineers/GetAllExternalEngineersForTrade`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMEngineersGetAllExternalEngineersForTradeQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForTrade>>, TError = ErrorType<void>>(params?: GetApiCCMEngineersGetAllExternalEngineersForTradeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForTrade>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMEngineersGetAllExternalEngineersForTradeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForTrade>>> = ({ signal }) => getApiCCMEngineersGetAllExternalEngineersForTrade(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForTrade>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMEngineersGetAllExternalEngineersForTradeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForTrade>>>
export type GetApiCCMEngineersGetAllExternalEngineersForTradeQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of external engineers based on the trade code provided.
 */

export function useGetApiCCMEngineersGetAllExternalEngineersForTrade<TData = Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForTrade>>, TError = ErrorType<void>>(
 params?: GetApiCCMEngineersGetAllExternalEngineersForTradeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForTrade>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMEngineersGetAllExternalEngineersForTradeQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieves a list of external engineers based on the postcode provided.
 * @summary Retrieves a list of external engineers based on the postcode provided.
 */
export const getApiCCMEngineersGetAllExternalEngineersForArea = (
    params?: GetApiCCMEngineersGetAllExternalEngineersForAreaParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetExternalEngineersResult[]>(
      {url: `/api/CCM/Engineers/GetAllExternalEngineersForArea`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMEngineersGetAllExternalEngineersForAreaQueryKey = (params?: GetApiCCMEngineersGetAllExternalEngineersForAreaParams,) => {
    return [`/api/CCM/Engineers/GetAllExternalEngineersForArea`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMEngineersGetAllExternalEngineersForAreaQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForArea>>, TError = ErrorType<void>>(params?: GetApiCCMEngineersGetAllExternalEngineersForAreaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForArea>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMEngineersGetAllExternalEngineersForAreaQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForArea>>> = ({ signal }) => getApiCCMEngineersGetAllExternalEngineersForArea(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForArea>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMEngineersGetAllExternalEngineersForAreaQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForArea>>>
export type GetApiCCMEngineersGetAllExternalEngineersForAreaQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of external engineers based on the postcode provided.
 */

export function useGetApiCCMEngineersGetAllExternalEngineersForArea<TData = Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForArea>>, TError = ErrorType<void>>(
 params?: GetApiCCMEngineersGetAllExternalEngineersForAreaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineersForArea>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMEngineersGetAllExternalEngineersForAreaQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieves a list of all external engineers.
 * @summary Retrieves a list of all external engineers.
 */
export const getApiCCMEngineersGetAllExternalEngineers = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetExternalEngineersResult[]>(
      {url: `/api/CCM/Engineers/GetAllExternalEngineers`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiCCMEngineersGetAllExternalEngineersQueryKey = () => {
    return [`/api/CCM/Engineers/GetAllExternalEngineers`] as const;
    }

    
export const getGetApiCCMEngineersGetAllExternalEngineersQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineers>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMEngineersGetAllExternalEngineersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineers>>> = ({ signal }) => getApiCCMEngineersGetAllExternalEngineers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMEngineersGetAllExternalEngineersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineers>>>
export type GetApiCCMEngineersGetAllExternalEngineersQueryError = ErrorType<void>


/**
 * @summary Retrieves a list of all external engineers.
 */

export function useGetApiCCMEngineersGetAllExternalEngineers<TData = Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineers>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEngineersGetAllExternalEngineers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMEngineersGetAllExternalEngineersQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets a list of enquiries based on the given parameters
 * @summary Gets a list of enquiries based on the given parameters
 */
export const getApiCCMEnquiriesGetEnquiries = (
    params?: GetApiCCMEnquiriesGetEnquiriesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsEnquiriesResultView[]>(
      {url: `/api/CCM/Enquiries/GetEnquiries`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMEnquiriesGetEnquiriesQueryKey = (params?: GetApiCCMEnquiriesGetEnquiriesParams,) => {
    return [`/api/CCM/Enquiries/GetEnquiries`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMEnquiriesGetEnquiriesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiries>>, TError = ErrorType<string>>(params?: GetApiCCMEnquiriesGetEnquiriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMEnquiriesGetEnquiriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiries>>> = ({ signal }) => getApiCCMEnquiriesGetEnquiries(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMEnquiriesGetEnquiriesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiries>>>
export type GetApiCCMEnquiriesGetEnquiriesQueryError = ErrorType<string>


/**
 * @summary Gets a list of enquiries based on the given parameters
 */

export function useGetApiCCMEnquiriesGetEnquiries<TData = Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiries>>, TError = ErrorType<string>>(
 params?: GetApiCCMEnquiriesGetEnquiriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMEnquiriesGetEnquiriesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns an EnquiryResultView object
 * @summary Get an enquiry by its Id
 */
export const getApiCCMEnquiriesGetEnquiry = (
    params?: GetApiCCMEnquiriesGetEnquiryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsEnquiryResultView>(
      {url: `/api/CCM/Enquiries/GetEnquiry`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMEnquiriesGetEnquiryQueryKey = (params?: GetApiCCMEnquiriesGetEnquiryParams,) => {
    return [`/api/CCM/Enquiries/GetEnquiry`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMEnquiriesGetEnquiryQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiry>>, TError = ErrorType<string>>(params?: GetApiCCMEnquiriesGetEnquiryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiry>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMEnquiriesGetEnquiryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiry>>> = ({ signal }) => getApiCCMEnquiriesGetEnquiry(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiry>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMEnquiriesGetEnquiryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiry>>>
export type GetApiCCMEnquiriesGetEnquiryQueryError = ErrorType<string>


/**
 * @summary Get an enquiry by its Id
 */

export function useGetApiCCMEnquiriesGetEnquiry<TData = Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiry>>, TError = ErrorType<string>>(
 params?: GetApiCCMEnquiriesGetEnquiryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMEnquiriesGetEnquiry>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMEnquiriesGetEnquiryQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a list of Service Agreement Enquiry Types
 * @summary Gets a list of all available Service Agreement Enquiry Types
 */
export const getEnquiryTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoServiceAgreementEnquiryTypeDto[]>(
      {url: `/api/CCM/Enquiries/GetEnquiryTypes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetEnquiryTypesQueryKey = () => {
    return [`/api/CCM/Enquiries/GetEnquiryTypes`] as const;
    }

    
export const getGetEnquiryTypesQueryOptions = <TData = Awaited<ReturnType<typeof getEnquiryTypes>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEnquiryTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnquiryTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnquiryTypes>>> = ({ signal }) => getEnquiryTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnquiryTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEnquiryTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getEnquiryTypes>>>
export type GetEnquiryTypesQueryError = ErrorType<void>


/**
 * @summary Gets a list of all available Service Agreement Enquiry Types
 */

export function useGetEnquiryTypes<TData = Awaited<ReturnType<typeof getEnquiryTypes>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEnquiryTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEnquiryTypesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a list of Enquiry Reasons
 * @summary Get Enquiry Reasons
 */
export const getEnquiryReasons = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsReferenceDataView[]>(
      {url: `/api/CCM/Enquiries/GetEnquiryReasons`, method: 'GET', signal
    },
      options);
    }
  

export const getGetEnquiryReasonsQueryKey = () => {
    return [`/api/CCM/Enquiries/GetEnquiryReasons`] as const;
    }

    
export const getGetEnquiryReasonsQueryOptions = <TData = Awaited<ReturnType<typeof getEnquiryReasons>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEnquiryReasons>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnquiryReasonsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnquiryReasons>>> = ({ signal }) => getEnquiryReasons(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnquiryReasons>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEnquiryReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getEnquiryReasons>>>
export type GetEnquiryReasonsQueryError = ErrorType<string>


/**
 * @summary Get Enquiry Reasons
 */

export function useGetEnquiryReasons<TData = Awaited<ReturnType<typeof getEnquiryReasons>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEnquiryReasons>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEnquiryReasonsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a list of Enquiry Outcomes
 * @summary Get a list of Enquiry Outcomes
 */
export const getEnquiryOutcomes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsReferenceDataView[]>(
      {url: `/api/CCM/Enquiries/GetEnquiryOutcomes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetEnquiryOutcomesQueryKey = () => {
    return [`/api/CCM/Enquiries/GetEnquiryOutcomes`] as const;
    }

    
export const getGetEnquiryOutcomesQueryOptions = <TData = Awaited<ReturnType<typeof getEnquiryOutcomes>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEnquiryOutcomes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnquiryOutcomesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnquiryOutcomes>>> = ({ signal }) => getEnquiryOutcomes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnquiryOutcomes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEnquiryOutcomesQueryResult = NonNullable<Awaited<ReturnType<typeof getEnquiryOutcomes>>>
export type GetEnquiryOutcomesQueryError = ErrorType<void>


/**
 * @summary Get a list of Enquiry Outcomes
 */

export function useGetEnquiryOutcomes<TData = Awaited<ReturnType<typeof getEnquiryOutcomes>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEnquiryOutcomes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEnquiryOutcomesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Set an enquiry with the given enquiry object and user id
 * @summary Set an enquiry
 */
export const postApiCCMEnquiriesSetEnquiry = (
    careClubCCMAPIModelsDtoEnquiryDto: BodyType<CareClubCCMAPIModelsDtoEnquiryDto>,
    params?: PostApiCCMEnquiriesSetEnquiryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/CCM/Enquiries/SetEnquiry`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsDtoEnquiryDto,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMEnquiriesSetEnquiryMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMEnquiriesSetEnquiry>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoEnquiryDto>;params?: PostApiCCMEnquiriesSetEnquiryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMEnquiriesSetEnquiry>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoEnquiryDto>;params?: PostApiCCMEnquiriesSetEnquiryParams}, TContext> => {

const mutationKey = ['postApiCCMEnquiriesSetEnquiry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMEnquiriesSetEnquiry>>, {data: BodyType<CareClubCCMAPIModelsDtoEnquiryDto>;params?: PostApiCCMEnquiriesSetEnquiryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMEnquiriesSetEnquiry(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMEnquiriesSetEnquiryMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMEnquiriesSetEnquiry>>>
    export type PostApiCCMEnquiriesSetEnquiryMutationBody = BodyType<CareClubCCMAPIModelsDtoEnquiryDto>
    export type PostApiCCMEnquiriesSetEnquiryMutationError = ErrorType<string>

    /**
 * @summary Set an enquiry
 */
export const usePostApiCCMEnquiriesSetEnquiry = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMEnquiriesSetEnquiry>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoEnquiryDto>;params?: PostApiCCMEnquiriesSetEnquiryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMEnquiriesSetEnquiry>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsDtoEnquiryDto>;params?: PostApiCCMEnquiriesSetEnquiryParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMEnquiriesSetEnquiryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Gets the history links for a user.
 * @summary Gets the history links for a user.
 */
export const getApiCCMHomeGetHistoryLinks = (
    params?: GetApiCCMHomeGetHistoryLinksParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsHistoryLinksView>(
      {url: `/api/CCM/Home/GetHistoryLinks`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMHomeGetHistoryLinksQueryKey = (params?: GetApiCCMHomeGetHistoryLinksParams,) => {
    return [`/api/CCM/Home/GetHistoryLinks`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMHomeGetHistoryLinksQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMHomeGetHistoryLinks>>, TError = ErrorType<string>>(params?: GetApiCCMHomeGetHistoryLinksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHomeGetHistoryLinks>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMHomeGetHistoryLinksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMHomeGetHistoryLinks>>> = ({ signal }) => getApiCCMHomeGetHistoryLinks(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHomeGetHistoryLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMHomeGetHistoryLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMHomeGetHistoryLinks>>>
export type GetApiCCMHomeGetHistoryLinksQueryError = ErrorType<string>


/**
 * @summary Gets the history links for a user.
 */

export function useGetApiCCMHomeGetHistoryLinks<TData = Awaited<ReturnType<typeof getApiCCMHomeGetHistoryLinks>>, TError = ErrorType<string>>(
 params?: GetApiCCMHomeGetHistoryLinksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHomeGetHistoryLinks>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMHomeGetHistoryLinksQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a list of report links
 * @summary Gets a list of report links
 */
export const getReportLinks = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsReportLinkView[]>(
      {url: `/api/CCM/Home/GetReportLinks`, method: 'GET', signal
    },
      options);
    }
  

export const getGetReportLinksQueryKey = () => {
    return [`/api/CCM/Home/GetReportLinks`] as const;
    }

    
export const getGetReportLinksQueryOptions = <TData = Awaited<ReturnType<typeof getReportLinks>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReportLinks>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportLinksQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportLinks>>> = ({ signal }) => getReportLinks(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReportLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getReportLinks>>>
export type GetReportLinksQueryError = ErrorType<void>


/**
 * @summary Gets a list of report links
 */

export function useGetReportLinks<TData = Awaited<ReturnType<typeof getReportLinks>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReportLinks>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReportLinksQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns the status of the application
 * @summary Gets the status of the application
 */
export const getStatus = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsStatusResultGroupView>(
      {url: `/api/CCM/Home/GetStatus`, method: 'GET', signal
    },
      options);
    }
  

export const getGetStatusQueryKey = () => {
    return [`/api/CCM/Home/GetStatus`] as const;
    }

    
export const getGetStatusQueryOptions = <TData = Awaited<ReturnType<typeof getStatus>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatus>>> = ({ signal }) => getStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getStatus>>>
export type GetStatusQueryError = ErrorType<void>


/**
 * @summary Gets the status of the application
 */

export function useGetStatus<TData = Awaited<ReturnType<typeof getStatus>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStatusQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Sets a job and returns the id of the job
 * @summary Sets a job
 */
export const postApiCCMJobsSetJob = (
    careClubCCMAPIModelsViewModelsJobSaveView: BodyType<CareClubCCMAPIModelsViewModelsJobSaveView>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/CCM/Jobs/SetJob`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsViewModelsJobSaveView, signal
    },
      options);
    }
  


export const getPostApiCCMJobsSetJobMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMJobsSetJob>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsJobSaveView>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMJobsSetJob>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsJobSaveView>}, TContext> => {

const mutationKey = ['postApiCCMJobsSetJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMJobsSetJob>>, {data: BodyType<CareClubCCMAPIModelsViewModelsJobSaveView>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCCMJobsSetJob(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMJobsSetJobMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMJobsSetJob>>>
    export type PostApiCCMJobsSetJobMutationBody = BodyType<CareClubCCMAPIModelsViewModelsJobSaveView>
    export type PostApiCCMJobsSetJobMutationError = ErrorType<string>

    /**
 * @summary Sets a job
 */
export const usePostApiCCMJobsSetJob = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMJobsSetJob>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsJobSaveView>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMJobsSetJob>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsViewModelsJobSaveView>},
        TContext
      > => {

      const mutationOptions = getPostApiCCMJobsSetJobMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Gets the job details for the specified service agreement job id.
 * @summary Gets the job details for the specified service agreement job id.
 */
export const getApiCCMJobsGetJob = (
    params?: GetApiCCMJobsGetJobParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsJobDetailsView>(
      {url: `/api/CCM/Jobs/GetJob`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMJobsGetJobQueryKey = (params?: GetApiCCMJobsGetJobParams,) => {
    return [`/api/CCM/Jobs/GetJob`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMJobsGetJobQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMJobsGetJob>>, TError = ErrorType<string>>(params?: GetApiCCMJobsGetJobParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetJob>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMJobsGetJobQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMJobsGetJob>>> = ({ signal }) => getApiCCMJobsGetJob(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMJobsGetJobQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMJobsGetJob>>>
export type GetApiCCMJobsGetJobQueryError = ErrorType<string>


/**
 * @summary Gets the job details for the specified service agreement job id.
 */

export function useGetApiCCMJobsGetJob<TData = Awaited<ReturnType<typeof getApiCCMJobsGetJob>>, TError = ErrorType<string>>(
 params?: GetApiCCMJobsGetJobParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetJob>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMJobsGetJobQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a list of all call types
 * @summary Gets a list of all call types
 */
export const getCallTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsCallTypeView[]>(
      {url: `/api/CCM/Jobs/GetCallTypes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCallTypesQueryKey = () => {
    return [`/api/CCM/Jobs/GetCallTypes`] as const;
    }

    
export const getGetCallTypesQueryOptions = <TData = Awaited<ReturnType<typeof getCallTypes>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCallTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCallTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallTypes>>> = ({ signal }) => getCallTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCallTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCallTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getCallTypes>>>
export type GetCallTypesQueryError = ErrorType<string>


/**
 * @summary Gets a list of all call types
 */

export function useGetCallTypes<TData = Awaited<ReturnType<typeof getCallTypes>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCallTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCallTypesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a list of all trades
 * @summary Gets a list of all trades
 */
export const getTrades = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsTradeView[]>(
      {url: `/api/CCM/Jobs/GetTrades`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTradesQueryKey = () => {
    return [`/api/CCM/Jobs/GetTrades`] as const;
    }

    
export const getGetTradesQueryOptions = <TData = Awaited<ReturnType<typeof getTrades>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrades>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrades>>> = ({ signal }) => getTrades(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrades>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTradesQueryResult = NonNullable<Awaited<ReturnType<typeof getTrades>>>
export type GetTradesQueryError = ErrorType<void>


/**
 * @summary Gets a list of all trades
 */

export function useGetTrades<TData = Awaited<ReturnType<typeof getTrades>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrades>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTradesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint returns a list of job groups based on the trade code provided.
 * @summary Gets a list of job groups based on the trade code
 */
export const getApiCCMJobsGetJobGroups = (
    params?: GetApiCCMJobsGetJobGroupsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsJobGroupView[]>(
      {url: `/api/CCM/Jobs/GetJobGroups`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMJobsGetJobGroupsQueryKey = (params?: GetApiCCMJobsGetJobGroupsParams,) => {
    return [`/api/CCM/Jobs/GetJobGroups`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMJobsGetJobGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMJobsGetJobGroups>>, TError = ErrorType<string>>(params?: GetApiCCMJobsGetJobGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetJobGroups>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMJobsGetJobGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMJobsGetJobGroups>>> = ({ signal }) => getApiCCMJobsGetJobGroups(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetJobGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMJobsGetJobGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMJobsGetJobGroups>>>
export type GetApiCCMJobsGetJobGroupsQueryError = ErrorType<string>


/**
 * @summary Gets a list of job groups based on the trade code
 */

export function useGetApiCCMJobsGetJobGroups<TData = Awaited<ReturnType<typeof getApiCCMJobsGetJobGroups>>, TError = ErrorType<string>>(
 params?: GetApiCCMJobsGetJobGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetJobGroups>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMJobsGetJobGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets a list of job types based on the account code, trade code, and job group code.
 * @summary Gets a list of job types based on the account code, trade code, and job group code.
 */
export const getApiCCMJobsGetJobTypes = (
    params?: GetApiCCMJobsGetJobTypesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsJobTypeView[]>(
      {url: `/api/CCM/Jobs/GetJobTypes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMJobsGetJobTypesQueryKey = (params?: GetApiCCMJobsGetJobTypesParams,) => {
    return [`/api/CCM/Jobs/GetJobTypes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMJobsGetJobTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMJobsGetJobTypes>>, TError = ErrorType<string>>(params?: GetApiCCMJobsGetJobTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetJobTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMJobsGetJobTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMJobsGetJobTypes>>> = ({ signal }) => getApiCCMJobsGetJobTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetJobTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMJobsGetJobTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMJobsGetJobTypes>>>
export type GetApiCCMJobsGetJobTypesQueryError = ErrorType<string>


/**
 * @summary Gets a list of job types based on the account code, trade code, and job group code.
 */

export function useGetApiCCMJobsGetJobTypes<TData = Awaited<ReturnType<typeof getApiCCMJobsGetJobTypes>>, TError = ErrorType<string>>(
 params?: GetApiCCMJobsGetJobTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetJobTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMJobsGetJobTypesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets a list of Service Agreement Job Types from the database.
 * @summary Gets a list of Service Agreement Job Types
 */
export const getApiCCMJobsGetServiceAgreementJobTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsServiceAgreementJobTypeView[]>(
      {url: `/api/CCM/Jobs/GetServiceAgreementJobTypes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiCCMJobsGetServiceAgreementJobTypesQueryKey = () => {
    return [`/api/CCM/Jobs/GetServiceAgreementJobTypes`] as const;
    }

    
export const getGetApiCCMJobsGetServiceAgreementJobTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMJobsGetServiceAgreementJobTypes>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetServiceAgreementJobTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMJobsGetServiceAgreementJobTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMJobsGetServiceAgreementJobTypes>>> = ({ signal }) => getApiCCMJobsGetServiceAgreementJobTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetServiceAgreementJobTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMJobsGetServiceAgreementJobTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMJobsGetServiceAgreementJobTypes>>>
export type GetApiCCMJobsGetServiceAgreementJobTypesQueryError = ErrorType<void>


/**
 * @summary Gets a list of Service Agreement Job Types
 */

export function useGetApiCCMJobsGetServiceAgreementJobTypes<TData = Awaited<ReturnType<typeof getApiCCMJobsGetServiceAgreementJobTypes>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetServiceAgreementJobTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMJobsGetServiceAgreementJobTypesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a list of appointment time types
 * @summary Gets a list of appointment time types
 */
export const getApiCCMJobsGetAppointmentTimeTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsAppointmentTimeTypeView[]>(
      {url: `/api/CCM/Jobs/GetAppointmentTimeTypes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiCCMJobsGetAppointmentTimeTypesQueryKey = () => {
    return [`/api/CCM/Jobs/GetAppointmentTimeTypes`] as const;
    }

    
export const getGetApiCCMJobsGetAppointmentTimeTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMJobsGetAppointmentTimeTypes>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetAppointmentTimeTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMJobsGetAppointmentTimeTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMJobsGetAppointmentTimeTypes>>> = ({ signal }) => getApiCCMJobsGetAppointmentTimeTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetAppointmentTimeTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMJobsGetAppointmentTimeTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMJobsGetAppointmentTimeTypes>>>
export type GetApiCCMJobsGetAppointmentTimeTypesQueryError = ErrorType<void>


/**
 * @summary Gets a list of appointment time types
 */

export function useGetApiCCMJobsGetAppointmentTimeTypes<TData = Awaited<ReturnType<typeof getApiCCMJobsGetAppointmentTimeTypes>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMJobsGetAppointmentTimeTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMJobsGetAppointmentTimeTypesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets the job cost details for a given request.
 * @summary Gets the job cost details for a given request.
 */
export const postApiCCMJobsGetJobCostDetails = (
    careClubCCMAPIModelsViewModelsGetJobCostDetailsRequestView: BodyType<CareClubCCMAPIModelsViewModelsGetJobCostDetailsRequestView>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsJobCostDetailsView>(
      {url: `/api/CCM/Jobs/GetJobCostDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsViewModelsGetJobCostDetailsRequestView, signal
    },
      options);
    }
  


export const getPostApiCCMJobsGetJobCostDetailsMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMJobsGetJobCostDetails>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsGetJobCostDetailsRequestView>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMJobsGetJobCostDetails>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsGetJobCostDetailsRequestView>}, TContext> => {

const mutationKey = ['postApiCCMJobsGetJobCostDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMJobsGetJobCostDetails>>, {data: BodyType<CareClubCCMAPIModelsViewModelsGetJobCostDetailsRequestView>}> = (props) => {
          const {data} = props ?? {};

          return  postApiCCMJobsGetJobCostDetails(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMJobsGetJobCostDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMJobsGetJobCostDetails>>>
    export type PostApiCCMJobsGetJobCostDetailsMutationBody = BodyType<CareClubCCMAPIModelsViewModelsGetJobCostDetailsRequestView>
    export type PostApiCCMJobsGetJobCostDetailsMutationError = ErrorType<string>

    /**
 * @summary Gets the job cost details for a given request.
 */
export const usePostApiCCMJobsGetJobCostDetails = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMJobsGetJobCostDetails>>, TError,{data: BodyType<CareClubCCMAPIModelsViewModelsGetJobCostDetailsRequestView>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMJobsGetJobCostDetails>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsViewModelsGetJobCostDetailsRequestView>},
        TContext
      > => {

      const mutationOptions = getPostApiCCMJobsGetJobCostDetailsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Book a job with the given details
 * @summary Books a job with the given details
 */
export const postApiCCMJobsBookJob = (
    params?: PostApiCCMJobsBookJobParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcIActionResult>(
      {url: `/api/CCM/Jobs/BookJob`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMJobsBookJobMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMJobsBookJob>>, TError,{params?: PostApiCCMJobsBookJobParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMJobsBookJob>>, TError,{params?: PostApiCCMJobsBookJobParams}, TContext> => {

const mutationKey = ['postApiCCMJobsBookJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMJobsBookJob>>, {params?: PostApiCCMJobsBookJobParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMJobsBookJob(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMJobsBookJobMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMJobsBookJob>>>
    
    export type PostApiCCMJobsBookJobMutationError = ErrorType<string>

    /**
 * @summary Books a job with the given details
 */
export const usePostApiCCMJobsBookJob = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMJobsBookJob>>, TError,{params?: PostApiCCMJobsBookJobParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMJobsBookJob>>,
        TError,
        {params?: PostApiCCMJobsBookJobParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMJobsBookJobMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Get a list of notes by service agreement id
 * @summary Get a list of notes by service agreement
 */
export const getApiCCMNotesGetByAgreement = (
    params?: GetApiCCMNotesGetByAgreementParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsNoteView[]>(
      {url: `/api/CCM/Notes/GetByAgreement`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMNotesGetByAgreementQueryKey = (params?: GetApiCCMNotesGetByAgreementParams,) => {
    return [`/api/CCM/Notes/GetByAgreement`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMNotesGetByAgreementQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMNotesGetByAgreement>>, TError = ErrorType<void>>(params?: GetApiCCMNotesGetByAgreementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMNotesGetByAgreement>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMNotesGetByAgreementQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMNotesGetByAgreement>>> = ({ signal }) => getApiCCMNotesGetByAgreement(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMNotesGetByAgreement>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMNotesGetByAgreementQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMNotesGetByAgreement>>>
export type GetApiCCMNotesGetByAgreementQueryError = ErrorType<void>


/**
 * @summary Get a list of notes by service agreement
 */

export function useGetApiCCMNotesGetByAgreement<TData = Awaited<ReturnType<typeof getApiCCMNotesGetByAgreement>>, TError = ErrorType<void>>(
 params?: GetApiCCMNotesGetByAgreementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMNotesGetByAgreement>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMNotesGetByAgreementQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieves a note by its Id and returns a NoteView object
 * @summary Gets a note by its Id
 */
export const getApiCCMNotesGet = (
    params?: GetApiCCMNotesGetParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsNoteView>(
      {url: `/api/CCM/Notes/Get`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMNotesGetQueryKey = (params?: GetApiCCMNotesGetParams,) => {
    return [`/api/CCM/Notes/Get`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMNotesGetQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMNotesGet>>, TError = ErrorType<void>>(params?: GetApiCCMNotesGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMNotesGet>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMNotesGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMNotesGet>>> = ({ signal }) => getApiCCMNotesGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMNotesGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMNotesGetQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMNotesGet>>>
export type GetApiCCMNotesGetQueryError = ErrorType<void>


/**
 * @summary Gets a note by its Id
 */

export function useGetApiCCMNotesGet<TData = Awaited<ReturnType<typeof getApiCCMNotesGet>>, TError = ErrorType<void>>(
 params?: GetApiCCMNotesGetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMNotesGet>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMNotesGetQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint adds a new note to a service agreement.
 * @summary Add a new note to a service agreement
 */
export const postApiCCMNotesAdd = (
    params?: PostApiCCMNotesAddParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Notes/Add`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMNotesAddMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMNotesAdd>>, TError,{params?: PostApiCCMNotesAddParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMNotesAdd>>, TError,{params?: PostApiCCMNotesAddParams}, TContext> => {

const mutationKey = ['postApiCCMNotesAdd'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMNotesAdd>>, {params?: PostApiCCMNotesAddParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMNotesAdd(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMNotesAddMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMNotesAdd>>>
    
    export type PostApiCCMNotesAddMutationError = ErrorType<string>

    /**
 * @summary Add a new note to a service agreement
 */
export const usePostApiCCMNotesAdd = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMNotesAdd>>, TError,{params?: PostApiCCMNotesAddParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMNotesAdd>>,
        TError,
        {params?: PostApiCCMNotesAddParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMNotesAddMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Returns a list of NoteView objects
 * @summary Gets all notes for a given service agreement customer
 */
export const getApiCCMNotesGetAll = (
    params?: GetApiCCMNotesGetAllParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsNoteView[]>(
      {url: `/api/CCM/Notes/GetAll`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMNotesGetAllQueryKey = (params?: GetApiCCMNotesGetAllParams,) => {
    return [`/api/CCM/Notes/GetAll`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMNotesGetAllQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMNotesGetAll>>, TError = ErrorType<void>>(params?: GetApiCCMNotesGetAllParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMNotesGetAll>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMNotesGetAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMNotesGetAll>>> = ({ signal }) => getApiCCMNotesGetAll(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMNotesGetAll>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMNotesGetAllQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMNotesGetAll>>>
export type GetApiCCMNotesGetAllQueryError = ErrorType<void>


/**
 * @summary Gets all notes for a given service agreement customer
 */

export function useGetApiCCMNotesGetAll<TData = Awaited<ReturnType<typeof getApiCCMNotesGetAll>>, TError = ErrorType<void>>(
 params?: GetApiCCMNotesGetAllParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMNotesGetAll>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMNotesGetAllQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint retrieves a list of addresses based on the postcode and property name provided.
 * @summary Retrieves a list of addresses based on the postcode and property name provided.
 */
export const getApiCCMPAFGetAddresses = (
    params?: GetApiCCMPAFGetAddressesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoAddressLocationDto[]>(
      {url: `/api/CCM/PAF/GetAddresses`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMPAFGetAddressesQueryKey = (params?: GetApiCCMPAFGetAddressesParams,) => {
    return [`/api/CCM/PAF/GetAddresses`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMPAFGetAddressesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMPAFGetAddresses>>, TError = ErrorType<string>>(params?: GetApiCCMPAFGetAddressesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPAFGetAddresses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMPAFGetAddressesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMPAFGetAddresses>>> = ({ signal }) => getApiCCMPAFGetAddresses(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPAFGetAddresses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMPAFGetAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMPAFGetAddresses>>>
export type GetApiCCMPAFGetAddressesQueryError = ErrorType<string>


/**
 * @summary Retrieves a list of addresses based on the postcode and property name provided.
 */

export function useGetApiCCMPAFGetAddresses<TData = Awaited<ReturnType<typeof getApiCCMPAFGetAddresses>>, TError = ErrorType<string>>(
 params?: GetApiCCMPAFGetAddressesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPAFGetAddresses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMPAFGetAddressesQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint retrieves a list of addresses based on the postcode provided.
 * @summary Retrieves a list of addresses based on the postcode provided.
 */
export const getApiCCMPAFGetAddressesByFullPostcode = (
    params?: GetApiCCMPAFGetAddressesByFullPostcodeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoPAFAddressDto[]>(
      {url: `/api/CCM/PAF/GetAddressesByFullPostcode`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMPAFGetAddressesByFullPostcodeQueryKey = (params?: GetApiCCMPAFGetAddressesByFullPostcodeParams,) => {
    return [`/api/CCM/PAF/GetAddressesByFullPostcode`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMPAFGetAddressesByFullPostcodeQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMPAFGetAddressesByFullPostcode>>, TError = ErrorType<string>>(params?: GetApiCCMPAFGetAddressesByFullPostcodeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPAFGetAddressesByFullPostcode>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMPAFGetAddressesByFullPostcodeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMPAFGetAddressesByFullPostcode>>> = ({ signal }) => getApiCCMPAFGetAddressesByFullPostcode(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPAFGetAddressesByFullPostcode>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMPAFGetAddressesByFullPostcodeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMPAFGetAddressesByFullPostcode>>>
export type GetApiCCMPAFGetAddressesByFullPostcodeQueryError = ErrorType<string>


/**
 * @summary Retrieves a list of addresses based on the postcode provided.
 */

export function useGetApiCCMPAFGetAddressesByFullPostcode<TData = Awaited<ReturnType<typeof getApiCCMPAFGetAddressesByFullPostcode>>, TError = ErrorType<string>>(
 params?: GetApiCCMPAFGetAddressesByFullPostcodeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPAFGetAddressesByFullPostcode>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMPAFGetAddressesByFullPostcodeQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets the payment details for a given service agreement id.
 * @summary Gets the payment details for a given service agreement id.
 */
export const getApiCCMPaymentGetPaymentDetails = (
    params?: GetApiCCMPaymentGetPaymentDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsPaymentDetailsView>(
      {url: `/api/CCM/Payment/GetPaymentDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMPaymentGetPaymentDetailsQueryKey = (params?: GetApiCCMPaymentGetPaymentDetailsParams,) => {
    return [`/api/CCM/Payment/GetPaymentDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMPaymentGetPaymentDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetails>>, TError = ErrorType<string>>(params?: GetApiCCMPaymentGetPaymentDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMPaymentGetPaymentDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetails>>> = ({ signal }) => getApiCCMPaymentGetPaymentDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMPaymentGetPaymentDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetails>>>
export type GetApiCCMPaymentGetPaymentDetailsQueryError = ErrorType<string>


/**
 * @summary Gets the payment details for a given service agreement id.
 */

export function useGetApiCCMPaymentGetPaymentDetails<TData = Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetails>>, TError = ErrorType<string>>(
 params?: GetApiCCMPaymentGetPaymentDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMPaymentGetPaymentDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets the payment summary for a given service agreement.
 * @summary Gets the payment summary for a given service agreement.
 */
export const getApiCCMPaymentGetPaymentSummary = (
    params?: GetApiCCMPaymentGetPaymentSummaryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsPaymentSummaryView>(
      {url: `/api/CCM/Payment/GetPaymentSummary`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMPaymentGetPaymentSummaryQueryKey = (params?: GetApiCCMPaymentGetPaymentSummaryParams,) => {
    return [`/api/CCM/Payment/GetPaymentSummary`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMPaymentGetPaymentSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentSummary>>, TError = ErrorType<string>>(params?: GetApiCCMPaymentGetPaymentSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMPaymentGetPaymentSummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentSummary>>> = ({ signal }) => getApiCCMPaymentGetPaymentSummary(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMPaymentGetPaymentSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentSummary>>>
export type GetApiCCMPaymentGetPaymentSummaryQueryError = ErrorType<string>


/**
 * @summary Gets the payment summary for a given service agreement.
 */

export function useGetApiCCMPaymentGetPaymentSummary<TData = Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentSummary>>, TError = ErrorType<string>>(
 params?: GetApiCCMPaymentGetPaymentSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMPaymentGetPaymentSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets the next unpaid invoice group total for a given service agreement and payment frequency.
 * @summary Gets the next unpaid invoice group total for a given service agreement and payment frequency.
 */
export const getApiCCMPaymentGetNextUnpaidInvoiceGroupTotal = (
    params?: GetApiCCMPaymentGetNextUnpaidInvoiceGroupTotalParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsInvoiceGroupTotalView>(
      {url: `/api/CCM/Payment/GetNextUnpaidInvoiceGroupTotal`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMPaymentGetNextUnpaidInvoiceGroupTotalQueryKey = (params?: GetApiCCMPaymentGetNextUnpaidInvoiceGroupTotalParams,) => {
    return [`/api/CCM/Payment/GetNextUnpaidInvoiceGroupTotal`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMPaymentGetNextUnpaidInvoiceGroupTotalQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMPaymentGetNextUnpaidInvoiceGroupTotal>>, TError = ErrorType<string>>(params?: GetApiCCMPaymentGetNextUnpaidInvoiceGroupTotalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetNextUnpaidInvoiceGroupTotal>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMPaymentGetNextUnpaidInvoiceGroupTotalQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMPaymentGetNextUnpaidInvoiceGroupTotal>>> = ({ signal }) => getApiCCMPaymentGetNextUnpaidInvoiceGroupTotal(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetNextUnpaidInvoiceGroupTotal>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMPaymentGetNextUnpaidInvoiceGroupTotalQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMPaymentGetNextUnpaidInvoiceGroupTotal>>>
export type GetApiCCMPaymentGetNextUnpaidInvoiceGroupTotalQueryError = ErrorType<string>


/**
 * @summary Gets the next unpaid invoice group total for a given service agreement and payment frequency.
 */

export function useGetApiCCMPaymentGetNextUnpaidInvoiceGroupTotal<TData = Awaited<ReturnType<typeof getApiCCMPaymentGetNextUnpaidInvoiceGroupTotal>>, TError = ErrorType<string>>(
 params?: GetApiCCMPaymentGetNextUnpaidInvoiceGroupTotalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetNextUnpaidInvoiceGroupTotal>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMPaymentGetNextUnpaidInvoiceGroupTotalQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieves a list of manual payment methods from the system.
 * @summary Retrieves a list of manual payment methods.
 */
export const getApiCCMPaymentGetManualPaymentMethods = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsManualPaymentMethodView[]>(
      {url: `/api/CCM/Payment/GetManualPaymentMethods`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiCCMPaymentGetManualPaymentMethodsQueryKey = () => {
    return [`/api/CCM/Payment/GetManualPaymentMethods`] as const;
    }

    
export const getGetApiCCMPaymentGetManualPaymentMethodsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMPaymentGetManualPaymentMethods>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetManualPaymentMethods>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMPaymentGetManualPaymentMethodsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMPaymentGetManualPaymentMethods>>> = ({ signal }) => getApiCCMPaymentGetManualPaymentMethods(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetManualPaymentMethods>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMPaymentGetManualPaymentMethodsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMPaymentGetManualPaymentMethods>>>
export type GetApiCCMPaymentGetManualPaymentMethodsQueryError = ErrorType<string>


/**
 * @summary Retrieves a list of manual payment methods.
 */

export function useGetApiCCMPaymentGetManualPaymentMethods<TData = Awaited<ReturnType<typeof getApiCCMPaymentGetManualPaymentMethods>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetManualPaymentMethods>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMPaymentGetManualPaymentMethodsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint takes a Stripe payment for a service agreement.
 * @summary Takes a Stripe payment for a service agreement.
 */
export const postApiCCMPaymentTakeStripePayment = (
    params?: PostApiCCMPaymentTakeStripePaymentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioStripeAPIWrapperModelsDtoConfirmPaymentResponseDto>(
      {url: `/api/CCM/Payment/TakeStripePayment`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMPaymentTakeStripePaymentMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentTakeStripePayment>>, TError,{params?: PostApiCCMPaymentTakeStripePaymentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentTakeStripePayment>>, TError,{params?: PostApiCCMPaymentTakeStripePaymentParams}, TContext> => {

const mutationKey = ['postApiCCMPaymentTakeStripePayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMPaymentTakeStripePayment>>, {params?: PostApiCCMPaymentTakeStripePaymentParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMPaymentTakeStripePayment(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMPaymentTakeStripePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMPaymentTakeStripePayment>>>
    
    export type PostApiCCMPaymentTakeStripePaymentMutationError = ErrorType<string>

    /**
 * @summary Takes a Stripe payment for a service agreement.
 */
export const usePostApiCCMPaymentTakeStripePayment = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentTakeStripePayment>>, TError,{params?: PostApiCCMPaymentTakeStripePaymentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMPaymentTakeStripePayment>>,
        TError,
        {params?: PostApiCCMPaymentTakeStripePaymentParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMPaymentTakeStripePaymentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint adds a credit note to a service agreement.
 * @summary Add a credit note to a service agreement
 */
export const postApiCCMPaymentAddCreditNote = (
    params?: PostApiCCMPaymentAddCreditNoteParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Payment/AddCreditNote`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMPaymentAddCreditNoteMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentAddCreditNote>>, TError,{params?: PostApiCCMPaymentAddCreditNoteParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentAddCreditNote>>, TError,{params?: PostApiCCMPaymentAddCreditNoteParams}, TContext> => {

const mutationKey = ['postApiCCMPaymentAddCreditNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMPaymentAddCreditNote>>, {params?: PostApiCCMPaymentAddCreditNoteParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMPaymentAddCreditNote(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMPaymentAddCreditNoteMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMPaymentAddCreditNote>>>
    
    export type PostApiCCMPaymentAddCreditNoteMutationError = ErrorType<string>

    /**
 * @summary Add a credit note to a service agreement
 */
export const usePostApiCCMPaymentAddCreditNote = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentAddCreditNote>>, TError,{params?: PostApiCCMPaymentAddCreditNoteParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMPaymentAddCreditNote>>,
        TError,
        {params?: PostApiCCMPaymentAddCreditNoteParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMPaymentAddCreditNoteMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Set manual payment for a service agreement with the given parameters
 * @summary Set manual payment for a service agreement
 */
export const postApiCCMPaymentSetManualPayment = (
    params?: PostApiCCMPaymentSetManualPaymentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Payment/SetManualPayment`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMPaymentSetManualPaymentMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentSetManualPayment>>, TError,{params?: PostApiCCMPaymentSetManualPaymentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentSetManualPayment>>, TError,{params?: PostApiCCMPaymentSetManualPaymentParams}, TContext> => {

const mutationKey = ['postApiCCMPaymentSetManualPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMPaymentSetManualPayment>>, {params?: PostApiCCMPaymentSetManualPaymentParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMPaymentSetManualPayment(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMPaymentSetManualPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMPaymentSetManualPayment>>>
    
    export type PostApiCCMPaymentSetManualPaymentMutationError = ErrorType<string>

    /**
 * @summary Set manual payment for a service agreement
 */
export const usePostApiCCMPaymentSetManualPayment = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentSetManualPayment>>, TError,{params?: PostApiCCMPaymentSetManualPaymentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMPaymentSetManualPayment>>,
        TError,
        {params?: PostApiCCMPaymentSetManualPaymentParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMPaymentSetManualPaymentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * This endpoint will credit off outstanding invoices for a given service agreement.
 * @summary Credit off outstanding invoices for a given service agreement
 */
export const postApiCCMPaymentCreditOffOutstandingInvoices = (
    params?: PostApiCCMPaymentCreditOffOutstandingInvoicesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MicrosoftAspNetCoreMvcOkResult>(
      {url: `/api/CCM/Payment/CreditOffOutstandingInvoices`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMPaymentCreditOffOutstandingInvoicesMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentCreditOffOutstandingInvoices>>, TError,{params?: PostApiCCMPaymentCreditOffOutstandingInvoicesParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentCreditOffOutstandingInvoices>>, TError,{params?: PostApiCCMPaymentCreditOffOutstandingInvoicesParams}, TContext> => {

const mutationKey = ['postApiCCMPaymentCreditOffOutstandingInvoices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMPaymentCreditOffOutstandingInvoices>>, {params?: PostApiCCMPaymentCreditOffOutstandingInvoicesParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMPaymentCreditOffOutstandingInvoices(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMPaymentCreditOffOutstandingInvoicesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMPaymentCreditOffOutstandingInvoices>>>
    
    export type PostApiCCMPaymentCreditOffOutstandingInvoicesMutationError = ErrorType<string>

    /**
 * @summary Credit off outstanding invoices for a given service agreement
 */
export const usePostApiCCMPaymentCreditOffOutstandingInvoices = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentCreditOffOutstandingInvoices>>, TError,{params?: PostApiCCMPaymentCreditOffOutstandingInvoicesParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMPaymentCreditOffOutstandingInvoices>>,
        TError,
        {params?: PostApiCCMPaymentCreditOffOutstandingInvoicesParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMPaymentCreditOffOutstandingInvoicesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Gets the billing details for a given service agreement.
 * @summary Gets the billing details for a given service agreement.
 */
export const getApiCCMPaymentGetBillingDetails = (
    params?: GetApiCCMPaymentGetBillingDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsBillingDetailsView>(
      {url: `/api/CCM/Payment/GetBillingDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMPaymentGetBillingDetailsQueryKey = (params?: GetApiCCMPaymentGetBillingDetailsParams,) => {
    return [`/api/CCM/Payment/GetBillingDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMPaymentGetBillingDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMPaymentGetBillingDetails>>, TError = ErrorType<string>>(params?: GetApiCCMPaymentGetBillingDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetBillingDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMPaymentGetBillingDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMPaymentGetBillingDetails>>> = ({ signal }) => getApiCCMPaymentGetBillingDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetBillingDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMPaymentGetBillingDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMPaymentGetBillingDetails>>>
export type GetApiCCMPaymentGetBillingDetailsQueryError = ErrorType<string>


/**
 * @summary Gets the billing details for a given service agreement.
 */

export function useGetApiCCMPaymentGetBillingDetails<TData = Awaited<ReturnType<typeof getApiCCMPaymentGetBillingDetails>>, TError = ErrorType<string>>(
 params?: GetApiCCMPaymentGetBillingDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetBillingDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMPaymentGetBillingDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint will return the Square Application Id
 * @summary Get the Square Application Id
 */
export const getSquareApplicationId = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/CCM/Payment/GetSquareApplicationId`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSquareApplicationIdQueryKey = () => {
    return [`/api/CCM/Payment/GetSquareApplicationId`] as const;
    }

    
export const getGetSquareApplicationIdQueryOptions = <TData = Awaited<ReturnType<typeof getSquareApplicationId>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSquareApplicationId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSquareApplicationIdQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSquareApplicationId>>> = ({ signal }) => getSquareApplicationId(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSquareApplicationId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSquareApplicationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSquareApplicationId>>>
export type GetSquareApplicationIdQueryError = ErrorType<string>


/**
 * @summary Get the Square Application Id
 */

export function useGetSquareApplicationId<TData = Awaited<ReturnType<typeof getSquareApplicationId>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSquareApplicationId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSquareApplicationIdQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint will return the Square Location Id
 * @summary Get the Square Location Id
 */
export const getSquareLocationId = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/CCM/Payment/GetSquareLocationId`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSquareLocationIdQueryKey = () => {
    return [`/api/CCM/Payment/GetSquareLocationId`] as const;
    }

    
export const getGetSquareLocationIdQueryOptions = <TData = Awaited<ReturnType<typeof getSquareLocationId>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSquareLocationId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSquareLocationIdQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSquareLocationId>>> = ({ signal }) => getSquareLocationId(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSquareLocationId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSquareLocationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSquareLocationId>>>
export type GetSquareLocationIdQueryError = ErrorType<string>


/**
 * @summary Get the Square Location Id
 */

export function useGetSquareLocationId<TData = Awaited<ReturnType<typeof getSquareLocationId>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSquareLocationId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSquareLocationIdQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint will return the Square Post Url
 * @summary Get the Square Post Url
 */
export const getSquarePostUrl = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/CCM/Payment/GetSquarePostUrl`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSquarePostUrlQueryKey = () => {
    return [`/api/CCM/Payment/GetSquarePostUrl`] as const;
    }

    
export const getGetSquarePostUrlQueryOptions = <TData = Awaited<ReturnType<typeof getSquarePostUrl>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSquarePostUrl>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSquarePostUrlQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSquarePostUrl>>> = ({ signal }) => getSquarePostUrl(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSquarePostUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSquarePostUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getSquarePostUrl>>>
export type GetSquarePostUrlQueryError = ErrorType<string>


/**
 * @summary Get the Square Post Url
 */

export function useGetSquarePostUrl<TData = Awaited<ReturnType<typeof getSquarePostUrl>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSquarePostUrl>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSquarePostUrlQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint will return the Square Api Key
 * @summary Get the Square Api Key
 */
export const getSquareApiKey = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/CCM/Payment/GetSquareApiKey`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSquareApiKeyQueryKey = () => {
    return [`/api/CCM/Payment/GetSquareApiKey`] as const;
    }

    
export const getGetSquareApiKeyQueryOptions = <TData = Awaited<ReturnType<typeof getSquareApiKey>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSquareApiKey>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSquareApiKeyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSquareApiKey>>> = ({ signal }) => getSquareApiKey(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSquareApiKey>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSquareApiKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getSquareApiKey>>>
export type GetSquareApiKeyQueryError = ErrorType<string>


/**
 * @summary Get the Square Api Key
 */

export function useGetSquareApiKey<TData = Awaited<ReturnType<typeof getSquareApiKey>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSquareApiKey>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSquareApiKeyQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint will return the Square Access Token
 * @summary Get the Square Access Token
 */
export const getSquareAccessToken = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/CCM/Payment/GetSquareAccessToken`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSquareAccessTokenQueryKey = () => {
    return [`/api/CCM/Payment/GetSquareAccessToken`] as const;
    }

    
export const getGetSquareAccessTokenQueryOptions = <TData = Awaited<ReturnType<typeof getSquareAccessToken>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSquareAccessToken>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSquareAccessTokenQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSquareAccessToken>>> = ({ signal }) => getSquareAccessToken(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSquareAccessToken>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSquareAccessTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getSquareAccessToken>>>
export type GetSquareAccessTokenQueryError = ErrorType<string>


/**
 * @summary Get the Square Access Token
 */

export function useGetSquareAccessToken<TData = Awaited<ReturnType<typeof getSquareAccessToken>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSquareAccessToken>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSquareAccessTokenQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint will return the Stripe Publishable Key
 * @summary Get the Stripe Publishable Key
 */
export const getStripePublishableKey = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/CCM/Payment/GetStripePublishableKey`, method: 'GET', signal
    },
      options);
    }
  

export const getGetStripePublishableKeyQueryKey = () => {
    return [`/api/CCM/Payment/GetStripePublishableKey`] as const;
    }

    
export const getGetStripePublishableKeyQueryOptions = <TData = Awaited<ReturnType<typeof getStripePublishableKey>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStripePublishableKey>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStripePublishableKeyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStripePublishableKey>>> = ({ signal }) => getStripePublishableKey(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStripePublishableKey>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStripePublishableKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getStripePublishableKey>>>
export type GetStripePublishableKeyQueryError = ErrorType<string>


/**
 * @summary Get the Stripe Publishable Key
 */

export function useGetStripePublishableKey<TData = Awaited<ReturnType<typeof getStripePublishableKey>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStripePublishableKey>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStripePublishableKeyQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint returns the Stripe Client Secret for the current user.
 * @summary Gets the Stripe Client Secret
 */
export const getApiCCMPaymentGetStripeClientSecret = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/CCM/Payment/GetStripeClientSecret`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiCCMPaymentGetStripeClientSecretQueryKey = () => {
    return [`/api/CCM/Payment/GetStripeClientSecret`] as const;
    }

    
export const getGetApiCCMPaymentGetStripeClientSecretQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMPaymentGetStripeClientSecret>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetStripeClientSecret>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMPaymentGetStripeClientSecretQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMPaymentGetStripeClientSecret>>> = ({ signal }) => getApiCCMPaymentGetStripeClientSecret(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetStripeClientSecret>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMPaymentGetStripeClientSecretQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMPaymentGetStripeClientSecret>>>
export type GetApiCCMPaymentGetStripeClientSecretQueryError = ErrorType<string>


/**
 * @summary Gets the Stripe Client Secret
 */

export function useGetApiCCMPaymentGetStripeClientSecret<TData = Awaited<ReturnType<typeof getApiCCMPaymentGetStripeClientSecret>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetStripeClientSecret>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMPaymentGetStripeClientSecretQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint returns the GoCardless Bank Account and Customer Details for the current user.
 * @summary Gets the GoCardless Bank Account and Customer Details
 */
export const getApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetails = (
    params?: GetApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpGetGoCardlessCustomerAndBankDetailsBySACustomerIdResult[]>(
      {url: `/api/CCM/Payment/GetGoCardlessBankAccountAndCustomerDetails`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetailsQueryKey = (params?: GetApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetailsParams,) => {
    return [`/api/CCM/Payment/GetGoCardlessBankAccountAndCustomerDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetails>>, TError = ErrorType<string>>(params?: GetApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetails>>> = ({ signal }) => getApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetails>>>
export type GetApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetailsQueryError = ErrorType<string>


/**
 * @summary Gets the GoCardless Bank Account and Customer Details
 */

export function useGetApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetails<TData = Awaited<ReturnType<typeof getApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetails>>, TError = ErrorType<string>>(
 params?: GetApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetails>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMPaymentGetGoCardlessBankAccountAndCustomerDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint takes a Square payment for a service agreement.
 * @summary Takes a Square payment for a service agreement.
 */
export const postApiCCMPaymentTakeSquarePayment = (
    postApiCCMPaymentTakeSquarePaymentBody: BodyType<string[]>,
    params?: PostApiCCMPaymentTakeSquarePaymentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsPaymentAPIWrapperCardPaymentResponse>(
      {url: `/api/CCM/Payment/TakeSquarePayment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiCCMPaymentTakeSquarePaymentBody,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMPaymentTakeSquarePaymentMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentTakeSquarePayment>>, TError,{data: BodyType<string[]>;params?: PostApiCCMPaymentTakeSquarePaymentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentTakeSquarePayment>>, TError,{data: BodyType<string[]>;params?: PostApiCCMPaymentTakeSquarePaymentParams}, TContext> => {

const mutationKey = ['postApiCCMPaymentTakeSquarePayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMPaymentTakeSquarePayment>>, {data: BodyType<string[]>;params?: PostApiCCMPaymentTakeSquarePaymentParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMPaymentTakeSquarePayment(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMPaymentTakeSquarePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMPaymentTakeSquarePayment>>>
    export type PostApiCCMPaymentTakeSquarePaymentMutationBody = BodyType<string[]>
    export type PostApiCCMPaymentTakeSquarePaymentMutationError = ErrorType<string>

    /**
 * @summary Takes a Square payment for a service agreement.
 */
export const usePostApiCCMPaymentTakeSquarePayment = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMPaymentTakeSquarePayment>>, TError,{data: BodyType<string[]>;params?: PostApiCCMPaymentTakeSquarePaymentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMPaymentTakeSquarePayment>>,
        TError,
        {data: BodyType<string[]>;params?: PostApiCCMPaymentTakeSquarePaymentParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMPaymentTakeSquarePaymentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Gets Payment Details for given service agreement customer id.
 * @summary Gets Payment Details for given service agreement customer id
 */
export const getApiCCMPaymentGetPaymentDetailsByCustomerId = (
    params?: GetApiCCMPaymentGetPaymentDetailsByCustomerIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresServiceAgreementPaymentDetail[]>(
      {url: `/api/CCM/Payment/GetPaymentDetailsByCustomerId`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMPaymentGetPaymentDetailsByCustomerIdQueryKey = (params?: GetApiCCMPaymentGetPaymentDetailsByCustomerIdParams,) => {
    return [`/api/CCM/Payment/GetPaymentDetailsByCustomerId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMPaymentGetPaymentDetailsByCustomerIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetailsByCustomerId>>, TError = ErrorType<string>>(params?: GetApiCCMPaymentGetPaymentDetailsByCustomerIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetailsByCustomerId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMPaymentGetPaymentDetailsByCustomerIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetailsByCustomerId>>> = ({ signal }) => getApiCCMPaymentGetPaymentDetailsByCustomerId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetailsByCustomerId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMPaymentGetPaymentDetailsByCustomerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetailsByCustomerId>>>
export type GetApiCCMPaymentGetPaymentDetailsByCustomerIdQueryError = ErrorType<string>


/**
 * @summary Gets Payment Details for given service agreement customer id
 */

export function useGetApiCCMPaymentGetPaymentDetailsByCustomerId<TData = Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetailsByCustomerId>>, TError = ErrorType<string>>(
 params?: GetApiCCMPaymentGetPaymentDetailsByCustomerIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMPaymentGetPaymentDetailsByCustomerId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMPaymentGetPaymentDetailsByCustomerIdQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a list of transactions for the given service agreement
 * @summary Gets all transactions for a given service agreement
 */
export const getApiCCMTransactionsGetTransactions = (
    params?: GetApiCCMTransactionsGetTransactionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsViewModelsTransactionView[]>(
      {url: `/api/CCM/Transactions/GetTransactions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMTransactionsGetTransactionsQueryKey = (params?: GetApiCCMTransactionsGetTransactionsParams,) => {
    return [`/api/CCM/Transactions/GetTransactions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMTransactionsGetTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMTransactionsGetTransactions>>, TError = ErrorType<void>>(params?: GetApiCCMTransactionsGetTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMTransactionsGetTransactions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMTransactionsGetTransactionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMTransactionsGetTransactions>>> = ({ signal }) => getApiCCMTransactionsGetTransactions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMTransactionsGetTransactions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMTransactionsGetTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMTransactionsGetTransactions>>>
export type GetApiCCMTransactionsGetTransactionsQueryError = ErrorType<void>


/**
 * @summary Gets all transactions for a given service agreement
 */

export function useGetApiCCMTransactionsGetTransactions<TData = Awaited<ReturnType<typeof getApiCCMTransactionsGetTransactions>>, TError = ErrorType<void>>(
 params?: GetApiCCMTransactionsGetTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMTransactionsGetTransactions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMTransactionsGetTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Applies a lock to the specified user.
 * @summary Applies a lock to the specified user.
 */
export const postApiCCMUserLockApply = (
    params?: PostApiCCMUserLockApplyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoUserLockStatus>(
      {url: `/api/CCM/UserLock/Apply`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMUserLockApplyMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMUserLockApply>>, TError,{params?: PostApiCCMUserLockApplyParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMUserLockApply>>, TError,{params?: PostApiCCMUserLockApplyParams}, TContext> => {

const mutationKey = ['postApiCCMUserLockApply'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMUserLockApply>>, {params?: PostApiCCMUserLockApplyParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMUserLockApply(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMUserLockApplyMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMUserLockApply>>>
    
    export type PostApiCCMUserLockApplyMutationError = ErrorType<string>

    /**
 * @summary Applies a lock to the specified user.
 */
export const usePostApiCCMUserLockApply = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMUserLockApply>>, TError,{params?: PostApiCCMUserLockApplyParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMUserLockApply>>,
        TError,
        {params?: PostApiCCMUserLockApplyParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMUserLockApplyMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Apply a customer lock to a service agreement by its ID, with the option to override an existing lock.
 * @summary Apply a customer lock to a service agreement by its ID
 */
export const postApiCCMUserLockApplyCustomerLockByServiceAgreementId = (
    params?: PostApiCCMUserLockApplyCustomerLockByServiceAgreementIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoUserLockStatus>(
      {url: `/api/CCM/UserLock/ApplyCustomerLockByServiceAgreementId`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMUserLockApplyCustomerLockByServiceAgreementIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMUserLockApplyCustomerLockByServiceAgreementId>>, TError,{params?: PostApiCCMUserLockApplyCustomerLockByServiceAgreementIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMUserLockApplyCustomerLockByServiceAgreementId>>, TError,{params?: PostApiCCMUserLockApplyCustomerLockByServiceAgreementIdParams}, TContext> => {

const mutationKey = ['postApiCCMUserLockApplyCustomerLockByServiceAgreementId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMUserLockApplyCustomerLockByServiceAgreementId>>, {params?: PostApiCCMUserLockApplyCustomerLockByServiceAgreementIdParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMUserLockApplyCustomerLockByServiceAgreementId(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMUserLockApplyCustomerLockByServiceAgreementIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMUserLockApplyCustomerLockByServiceAgreementId>>>
    
    export type PostApiCCMUserLockApplyCustomerLockByServiceAgreementIdMutationError = ErrorType<string>

    /**
 * @summary Apply a customer lock to a service agreement by its ID
 */
export const usePostApiCCMUserLockApplyCustomerLockByServiceAgreementId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMUserLockApplyCustomerLockByServiceAgreementId>>, TError,{params?: PostApiCCMUserLockApplyCustomerLockByServiceAgreementIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMUserLockApplyCustomerLockByServiceAgreementId>>,
        TError,
        {params?: PostApiCCMUserLockApplyCustomerLockByServiceAgreementIdParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMUserLockApplyCustomerLockByServiceAgreementIdMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Clear the user lock status for the given lock type and lock type identifier
 * @summary Clear the user lock status for the given lock type and lock type identifier
 */
export const postApiCCMUserLockClear = (
    params?: PostApiCCMUserLockClearParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoUserLockStatus>(
      {url: `/api/CCM/UserLock/Clear`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiCCMUserLockClearMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMUserLockClear>>, TError,{params?: PostApiCCMUserLockClearParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMUserLockClear>>, TError,{params?: PostApiCCMUserLockClearParams}, TContext> => {

const mutationKey = ['postApiCCMUserLockClear'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMUserLockClear>>, {params?: PostApiCCMUserLockClearParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiCCMUserLockClear(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMUserLockClearMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMUserLockClear>>>
    
    export type PostApiCCMUserLockClearMutationError = ErrorType<string>

    /**
 * @summary Clear the user lock status for the given lock type and lock type identifier
 */
export const usePostApiCCMUserLockClear = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMUserLockClear>>, TError,{params?: PostApiCCMUserLockClearParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMUserLockClear>>,
        TError,
        {params?: PostApiCCMUserLockClearParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMUserLockClearMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * Get all user lock details for the specified user id
 * @summary Get all user lock details
 */
export const getApiCCMUserLockGetAll = (
    params?: GetApiCCMUserLockGetAllParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoUserLockDetailDto[]>(
      {url: `/api/CCM/UserLock/GetAll`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMUserLockGetAllQueryKey = (params?: GetApiCCMUserLockGetAllParams,) => {
    return [`/api/CCM/UserLock/GetAll`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMUserLockGetAllQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMUserLockGetAll>>, TError = ErrorType<string>>(params?: GetApiCCMUserLockGetAllParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMUserLockGetAll>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMUserLockGetAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMUserLockGetAll>>> = ({ signal }) => getApiCCMUserLockGetAll(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMUserLockGetAll>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMUserLockGetAllQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMUserLockGetAll>>>
export type GetApiCCMUserLockGetAllQueryError = ErrorType<string>


/**
 * @summary Get all user lock details
 */

export function useGetApiCCMUserLockGetAll<TData = Awaited<ReturnType<typeof getApiCCMUserLockGetAll>>, TError = ErrorType<string>>(
 params?: GetApiCCMUserLockGetAllParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMUserLockGetAll>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMUserLockGetAllQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * This endpoint returns a list of users who have the specified permission.
 * @summary Gets a list of users by permission
 */
export const getApiCCMUsersGetUsersByPermission = (
    params?: GetApiCCMUsersGetUsersByPermissionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetUsersByPermissionResult[]>(
      {url: `/api/CCM/Users/GetUsersByPermission`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMUsersGetUsersByPermissionQueryKey = (params?: GetApiCCMUsersGetUsersByPermissionParams,) => {
    return [`/api/CCM/Users/GetUsersByPermission`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMUsersGetUsersByPermissionQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMUsersGetUsersByPermission>>, TError = ErrorType<string>>(params?: GetApiCCMUsersGetUsersByPermissionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMUsersGetUsersByPermission>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMUsersGetUsersByPermissionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMUsersGetUsersByPermission>>> = ({ signal }) => getApiCCMUsersGetUsersByPermission(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMUsersGetUsersByPermission>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMUsersGetUsersByPermissionQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMUsersGetUsersByPermission>>>
export type GetApiCCMUsersGetUsersByPermissionQueryError = ErrorType<string>


/**
 * @summary Gets a list of users by permission
 */

export function useGetApiCCMUsersGetUsersByPermission<TData = Awaited<ReturnType<typeof getApiCCMUsersGetUsersByPermission>>, TError = ErrorType<string>>(
 params?: GetApiCCMUsersGetUsersByPermissionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMUsersGetUsersByPermission>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMUsersGetUsersByPermissionQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieves a list of service agreements for a customer based on the customer's ID and whether the customer is a customer or not.
 * @summary Retrieves a list of service agreements for a customer.
 */
export const getApiCCMHubAgreements = (
    params?: GetApiCCMHubAgreementsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsTablesServiceAgreements[]>(
      {url: `/api/CCM/Hub/Agreements`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMHubAgreementsQueryKey = (params?: GetApiCCMHubAgreementsParams,) => {
    return [`/api/CCM/Hub/Agreements`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMHubAgreementsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMHubAgreements>>, TError = ErrorType<string>>(params?: GetApiCCMHubAgreementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHubAgreements>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMHubAgreementsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMHubAgreements>>> = ({ signal }) => getApiCCMHubAgreements(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHubAgreements>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMHubAgreementsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMHubAgreements>>>
export type GetApiCCMHubAgreementsQueryError = ErrorType<string>


/**
 * @summary Retrieves a list of service agreements for a customer.
 */

export function useGetApiCCMHubAgreements<TData = Awaited<ReturnType<typeof getApiCCMHubAgreements>>, TError = ErrorType<string>>(
 params?: GetApiCCMHubAgreementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHubAgreements>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMHubAgreementsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Gets the last service agreement reference number for a customer.
 * @summary Gets the last service agreement reference number for a customer.
 */
export const getApiCCMHubLastServiceAgreementReferenceNumber = (
    params?: GetApiCCMHubLastServiceAgreementReferenceNumberParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/CCM/Hub/LastServiceAgreementReferenceNumber`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMHubLastServiceAgreementReferenceNumberQueryKey = (params?: GetApiCCMHubLastServiceAgreementReferenceNumberParams,) => {
    return [`/api/CCM/Hub/LastServiceAgreementReferenceNumber`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMHubLastServiceAgreementReferenceNumberQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMHubLastServiceAgreementReferenceNumber>>, TError = ErrorType<string>>(params?: GetApiCCMHubLastServiceAgreementReferenceNumberParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHubLastServiceAgreementReferenceNumber>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMHubLastServiceAgreementReferenceNumberQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMHubLastServiceAgreementReferenceNumber>>> = ({ signal }) => getApiCCMHubLastServiceAgreementReferenceNumber(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHubLastServiceAgreementReferenceNumber>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMHubLastServiceAgreementReferenceNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMHubLastServiceAgreementReferenceNumber>>>
export type GetApiCCMHubLastServiceAgreementReferenceNumberQueryError = ErrorType<string>


/**
 * @summary Gets the last service agreement reference number for a customer.
 */

export function useGetApiCCMHubLastServiceAgreementReferenceNumber<TData = Awaited<ReturnType<typeof getApiCCMHubLastServiceAgreementReferenceNumber>>, TError = ErrorType<string>>(
 params?: GetApiCCMHubLastServiceAgreementReferenceNumberParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHubLastServiceAgreementReferenceNumber>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMHubLastServiceAgreementReferenceNumberQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieves a list of claims for a customer based on the customer's id and a boolean value indicating if the customer is a customer
 * @summary Retrieves a list of claims for a customer
 */
export const getApiCCMHubClaims = (
    params?: GetApiCCMHubClaimsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoClaimGetDto[]>(
      {url: `/api/CCM/Hub/Claims`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMHubClaimsQueryKey = (params?: GetApiCCMHubClaimsParams,) => {
    return [`/api/CCM/Hub/Claims`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMHubClaimsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMHubClaims>>, TError = ErrorType<string>>(params?: GetApiCCMHubClaimsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHubClaims>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMHubClaimsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMHubClaims>>> = ({ signal }) => getApiCCMHubClaims(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHubClaims>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMHubClaimsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMHubClaims>>>
export type GetApiCCMHubClaimsQueryError = ErrorType<string>


/**
 * @summary Retrieves a list of claims for a customer
 */

export function useGetApiCCMHubClaims<TData = Awaited<ReturnType<typeof getApiCCMHubClaims>>, TError = ErrorType<string>>(
 params?: GetApiCCMHubClaimsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHubClaims>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMHubClaimsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Creates a new claim for a customer with the given customerId and isCustomer boolean value
 * @summary Creates a new claim for a customer
 */
export const postApiCCMHubClaims = (
    careClubCCMAPIModelsDtoClaimPostDto: BodyType<CareClubCCMAPIModelsDtoClaimPostDto>,
    params?: PostApiCCMHubClaimsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoClaimPostDto>(
      {url: `/api/CCM/Hub/Claims`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: careClubCCMAPIModelsDtoClaimPostDto,
        params, signal
    },
      options);
    }
  


export const getPostApiCCMHubClaimsMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMHubClaims>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoClaimPostDto>;params?: PostApiCCMHubClaimsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCCMHubClaims>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoClaimPostDto>;params?: PostApiCCMHubClaimsParams}, TContext> => {

const mutationKey = ['postApiCCMHubClaims'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCCMHubClaims>>, {data: BodyType<CareClubCCMAPIModelsDtoClaimPostDto>;params?: PostApiCCMHubClaimsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCCMHubClaims(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCCMHubClaimsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCCMHubClaims>>>
    export type PostApiCCMHubClaimsMutationBody = BodyType<CareClubCCMAPIModelsDtoClaimPostDto>
    export type PostApiCCMHubClaimsMutationError = ErrorType<string>

    /**
 * @summary Creates a new claim for a customer
 */
export const usePostApiCCMHubClaims = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCCMHubClaims>>, TError,{data: BodyType<CareClubCCMAPIModelsDtoClaimPostDto>;params?: PostApiCCMHubClaimsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiCCMHubClaims>>,
        TError,
        {data: BodyType<CareClubCCMAPIModelsDtoClaimPostDto>;params?: PostApiCCMHubClaimsParams},
        TContext
      > => {

      const mutationOptions = getPostApiCCMHubClaimsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    /**
 * @summary Get the service agreement document by document type and customer id.
 */
export const getApiCCMHubDocuments = (
    params?: GetApiCCMHubDocumentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CareClubCCMAPIModelsDtoServiceAgreementDocumentDto>(
      {url: `/api/CCM/Hub/Documents`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCCMHubDocumentsQueryKey = (params?: GetApiCCMHubDocumentsParams,) => {
    return [`/api/CCM/Hub/Documents`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCCMHubDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCCMHubDocuments>>, TError = ErrorType<string>>(params?: GetApiCCMHubDocumentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHubDocuments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCCMHubDocumentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCCMHubDocuments>>> = ({ signal }) => getApiCCMHubDocuments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHubDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCCMHubDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCCMHubDocuments>>>
export type GetApiCCMHubDocumentsQueryError = ErrorType<string>


/**
 * @summary Get the service agreement document by document type and customer id.
 */

export function useGetApiCCMHubDocuments<TData = Awaited<ReturnType<typeof getApiCCMHubDocuments>>, TError = ErrorType<string>>(
 params?: GetApiCCMHubDocumentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCCMHubDocuments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiCCMHubDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



